import React from "react";
import { useEffect, useRef, useState, createRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from 'react-router-dom';
import ComFunction from "../components/ComFunction";
import { getActiveAxiosCount } from "../components/ComFunction";
import { unstable_batchedUpdates } from "react-dom";
import AGFunction from "../components/AGFunction";
import MasterBase from "../components/MasterLayout";
import HinbanEntryGridAr from "./components/HinbanEntryGridAr";
import WashGrid from "../components/WashGrid";
import EntrySetting from "../components/EntrySetting";
import HinbanEntryRemarks from "./components/HinbanEntryRemarks";
import HinbanEntryImages from "./components/HinbanEntryImages";
import HinbanEntryFiles from "./components/HinbanEntryFiles";
import HinbanEntryBase from "./components/HinbanEntryBase";
import ChipScrollBar from "./components/ChipScrollBar";
import HinbanEntryInput from "./components/HinbanEntryInput";
import DropZone from "../components/DropZone";
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Dialog from '@material-ui/core/Dialog';
import CircularProgress from '@material-ui/core/CircularProgress';
import Backdrop from '@material-ui/core/Backdrop';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { isEmpty, getglobaldata, CellType, Getstorage, Savestorage, DeepCopy, getWindowDimensions, setglobaldata, getformid, getcontroller, getsubkey, initializedata, isEnabled, DicVal, FormatDate } from '../modules/appLibrary';
import { cfFileUpload, cfNewUploadFile, cfMargeUploadFiles } from '../modules/commodule';
import { setimagelist } from '../modules/imagedlgstore';
import { confmsg } from '../modules/msgboxstore';
import { arrayMove } from 'react-sortable-hoc';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import Chip from '@material-ui/core/Chip';
import { styled } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import InputBase from '@material-ui/core/InputBase';
import EntryLayout from '../components/EntryLayout';
import { changestatus, listtabs, entrytriggercall, setgridlist, listoption, entryrerender, entrydata, setchangeurl, rerendergrid } from '../modules/formstore';
import { setentrypanel, addentrylayout, setentrylayout, setentrystartup} from '../modules/toolpanelstore';
import noimage from '../Resources/noimage.jpg';
import { createGridRefAccessors } from "./shared/entry/gridRefAccessors";
import { createTotalGridAccessors } from "./shared/entry/totalGridAccessors";
import { createEntryValueResolver } from "./shared/entry/entryValueResolver";
import { createGenkaPatternResolver } from "./shared/entry/genkaPatternResolver";
import { createSoseiCalcService } from "./shared/entry/soseiCalcService";
import { createCallformLauncher } from "./shared/entry/callformLauncher";
import { createColumnInfoService } from "./shared/entry/columnInfoService";
import { createLayoutStorageService } from "./shared/entry/layoutStorageService";
import { createSustainableImageService } from "./kakousiji/panels/sustainableImageService";
import { createColumnIdUtil } from "./kakousiji/columnIdUtil";
import { createTypeColumnResolver } from "./kakousiji/panels/typeColumnResolver";
import { createDemandRowNormalizer } from "./kakousiji/panels/demandRowNormalizer";
import { createDemandGridSupportService } from "./kakousiji/panels/demandGridSupportService";
import { createDemandGridColumnBuilder } from "./kakousiji/panels/demandGridColumnBuilder";
import { createDemandHeaderRenderer } from "./kakousiji/renderers/demandHeaderRenderer";
import { createSectionIdBridge } from "./kakousiji/sections/sectionIdBridge";
import "../css/Kakousiji.css";
import {
    normalizeGroupNo as sharedNormalizeGroupNo,
    groupNoToLabel as sharedGroupNoToLabel
} from "./kakousiji/panels/groupIdentityUtil";
import { createItemMasterService } from "./hinbanmaster/masters/itemMasterService";
import { createColorMasterService } from "./hinbanmaster/masters/colorMasterService";
import { createBrandGroupService } from "./hinbanmaster/masters/brandGroupService";
import { createJyutakuSupplierService } from "./hinbanmaster/masters/jyutakuSupplierService";
import { createQrcInfoService } from "./hinbanmaster/masters/qrcInfoService";
import { createJanSeasonService } from "./hinbanmaster/masters/janSeasonService";
import { createGenkaPatternLoader } from "./hinbanmaster/genka/genkaPatternLoader";
import { createGenkaGridService } from "./hinbanmaster/genka/genkaGridService";
import { createGenkaRecalcService } from "./hinbanmaster/genka/genkaRecalcService";
import { createKubunOptionService } from "./hinbanmaster/kakousiji/kubunOptionService";
import { createKakousijiSummaryListService } from "./hinbanmaster/kakousiji/summaryListService";
import { createKakousijiEntrySnapshotService } from "./hinbanmaster/kakousiji/entrySnapshotService";
import { createFukushizaiScopeDisplayService } from "./hinbanmaster/kakousiji/fukushizaiScopeDisplayService";
import { createQualityScopeDisplayService } from "./hinbanmaster/kakousiji/qualityScopeDisplayService";
import { createKakousijiDraftService } from "./hinbanmaster/kakousiji/draftService";
import { createMainSavePayloadBuilder } from "./hinbanmaster/save/mainSavePayloadBuilder";
import { createKakousijiSavePayloadBuilder } from "./hinbanmaster/save/kakousijiSavePayloadBuilder";
import { createGenkaRenderer } from "./hinbanmaster/renderers/genkaRenderer";
import { createSampleSectionRenderer } from "./hinbanmaster/renderers/sampleSectionRenderer";
import { createSustainablePreviewRenderer } from "./hinbanmaster/renderers/sustainablePreviewRenderer";
import { createHinbanSectionActionRenderer } from "./hinbanmaster/renderers/sectionActionRenderer";
import { createKakousijiDialogRenderer } from "./hinbanmaster/renderers/kakousijiDialogRenderer";
import HinbanMasterEntryForm from "./hinbanmaster/components/EntryFormLayout";
import { KAKOUSIJI_NONZERO_EDIT_BUTTON_PANEL_TYPES, KAKOUSIJI_ZERO_EDIT_BUTTON_PANEL_TYPES, KAKOUSIJI_EDIT_BUTTON_PANEL_TYPES, EDIT_UPDATE_TRACKING_PANEL_TYPES } from "./hinbanmaster/constants";
import { createHinbanWashPanelService } from "./hinbanmaster/panels/washPanelService";
import { createKakousijiSampleInfoService } from "./hinbanmaster/panels/sampleInfoService";
import { createFieldNormalizeService } from "./hinbanmaster/fields/fieldNormalizeService";
import { createDerivedFieldService } from "./hinbanmaster/fields/derivedFieldService";
import { createEntryDefaultsService } from "./hinbanmaster/entry/entryDefaultsService";
import { createHinbanNumberingService } from "./hinbanmaster/numbering/hinbanNumberingService";
import { createHinbanPermissionService } from "./hinbanmaster/auth/permissionService";
import { createPdtcDetailService } from "./hinbanmaster/panels/pdtcDetailService";
import { createKakousijiGroupContextService } from "./hinbanmaster/kakousiji/groupContextService";
import { createKakousijiRepresentativeProjectionService } from "./hinbanmaster/kakousiji/representativeProjectionService";
import { createKakousijiDetailCalcService } from "./hinbanmaster/kakousiji/detailCalcService";
import { createKakousijiFukushizaiListService } from "./hinbanmaster/kakousiji/fukushizaiListService";
import { createKakousijiGroupDialogService } from "./hinbanmaster/kakousiji/groupDialogService";
import { createHinbanActionService } from "./hinbanmaster/actions/hinbanActionService";
import { createSectionEditStateService } from "./hinbanmaster/sections/sectionEditStateService";
import { createSectionHeaderService } from "./hinbanmaster/sections/sectionHeaderService";
import { createPdtSizePatternService } from "./hinbanmaster/masters/pdtSizePatternService";
import { createEntryLifecycleService } from "./hinbanmaster/entry/entryLifecycleService";
import { createValueChangedService } from "./hinbanmaster/entry/valueChangedService";
import { createSaveOrchestrator } from "./hinbanmaster/save/saveOrchestrator";
import { createKakousijiAddDialogService } from "./hinbanmaster/kakousiji/addDialogService";
import { createPanelVisibilityService } from "./hinbanmaster/sections/panelVisibilityService";
import { createSectionContentRenderer } from "./hinbanmaster/renderers/sectionContentRenderer";
import { createHinbanHeadlineRenderer } from "./hinbanmaster/renderers/hinbanHeadlineRenderer";
import "../css/HinbanMaster.css";
import { perfCountRender, perfWhyChanged, perfSpanStart, perfSpanEnd, perfActionOrigin } from "../modules/perfTrace";

const ListItem = styled('li')(({ theme }) => ({
    margin: theme.spacing(0.5),
    listStyle: 'none'
}));

const SUSTAINABLE_IMAGE_FILE_FIELD = "SSDSAS_SASEGATAFILEMEI";
const DEFAULT_DELETE_CONFIRM_MESSAGE = "データの削除を行います。データの復帰はできませんよろしいですか？";
const HINBAN_MASTER_DELETE_CONFIRM_MESSAGE = "品番マスタを削除します。よろしいですか？";
const HINBAN_NUMBERING_FAILED_MESSAGE = "採番に失敗しました。";
const PDTC_SIZE_SELECTED_FIELD = "__pdtc_size_selected";



export const HinbanMaster = props => {
    perfCountRender("HinbanMaster");

    const panelsdef = [];
    const G_id = { BASE: "0", IMAGE: "pic", FILE: "file", NB: "nb", PL:"pl"}
    const formid = getformid("HinbanMaster", props.location.search);
    const controller = getcontroller("HinbanMaster", props.location.search);
    const subkey = getsubkey(props.location.search);

    const corpkey = useSelector(state => state.user.corpkey);
    const account = useSelector(state => state.user.account);
    const staff = useSelector(state => state.user.accctl);
    const menuinfo = useSelector(state => state.form.menuinfo);
    const mainlayout = useSelector(state => state.toolpnl.layouts_et);
    const mainprelayout = useSelector(state => state.toolpnl.prelayout_et);
    const maininitlayout = useSelector(state => state.toolpnl.initlayout_et);

    const baseref = useRef();
    const AGRef = useRef();
    const fnc = useRef();
    const EntrybodyRef = useRef(null);
    const locationstate = useRef(null);    //遷移State

    const formstatus = useSelector(state => state.form.status);
    const entrylock = useSelector(state => state.form.entryformlock);
    const storeentrydata = useSelector(state => state.form.entrydata);
    const standardWaitOpen = useSelector(state => state.form.wait);
    const changeurl = useSelector(state => state.form.changeurl);
    const searchlistOpen = useSelector(state => state.search.open);
    const msgboxOpen = useSelector(state => state.msgbox.open);
    const msgboxType = useSelector(state => state.msgbox.type);
    const msgboxMessage = useSelector(state => state.msgbox.message);
    const msgboxCommand = useSelector(state => state.msgbox.doCommand);
    const msgboxCancel = useSelector(state => state.msgbox.doCancel);
    const [panel, setpanel] = useState(panelsdef);
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    const [columninfo, setcolumninfo] = useState(null);     //全カラム情報
    const [columns, setcolumns] = useState(null);
    const [edittingcode, setedittingcode] = useState(null);
    const [textfieldsall, settextfieldsall] = useState([]);
    const [textfields, settextfields] = useState([]);
    const [layoutlock, setlayoutlock] = useState(false);
    const [sectionclose, setsectionclose] = useState(false);
    const [gallery, setgallery] = useState(false);
    const [update, setUpdata] = useState(false);
    const [isDragActive, setIsDragActive] = useState(false);
    const [pdtItemCodesLoadVersion, setPdtItemCodesLoadVersion] = useState(0);
    const [kakousijiSummaryList, setKakousijiSummaryList] = useState([]);
    const [activeKakousijiKey, setActiveKakousijiKey] = useState("");
    const [kakousijiSummaryLoading, setKakousijiSummaryLoading] = useState(false);
    const [kakouType, setKakouType] = useState('type1');
    const [kakousijiOrderDateMap, setKakousijiOrderDateMap] = useState({ seihin: '', fukushizai: '' });
    // 発注履歴(製商品/素材/附属/副資材)。選択中の加工指示に紐づく履歴を保持する。
    const [kakousijiOrderHistoryData, setKakousijiOrderHistoryData] = useState({ seihin: [], sozai: [], fuzoku: [], fukushizai: [] });
    const [kakousijiOrderDenpyoMap, setKakousijiOrderDenpyoMap] = useState({ seihin: '', sozai: '', fuzoku: '', fukushizai: '' });
    const [kakousijiBulkInputMap, setKakousijiBulkInputMap] = useState({ '119': { lossRate: '', shikyuKbn: '' } });
    const [skuNameConfirmState, setSkuNameConfirmState] = useState({ open: false, onYes: null, onNo: null });
    const [kakousijiGroupControlState, setKakousijiGroupControlState] = useState({ itemCd: '', groupNo: '', sourceItemCd: '', sourceGroupNo: '' });
    const kakousijiGroupControlStateRef = useRef({ itemCd: '', groupNo: '', sourceItemCd: '', sourceGroupNo: '' });
    // 小物札ラベル(kakousiji/GetKomonoFudaLabels)のキャッシュ。キーは 小物札コード|ブランド。
    const komonoFudaLabelCacheRef = useRef({});
    const komonoFudaLabelLoadingRef = useRef({});
    // 洗濯表示(131)の全ソース行。WashGridは代表1行だけを表示行へ変換するため、
    // 品質アイテム/グループ切替時の代表行選び直しと保存用に全行を保持する。
    const kakousijiWashSourceRowsRef = useRef([]);
    // 品質表示スコープの選択。副資材とは独立して保持する(加工指示画面と同じ分離構成)。
    const [kakousijiQualityGroupControlState, setKakousijiQualityGroupControlState] = useState({ itemCd: '', groupNo: '' });
    const kakousijiQualityGroupControlStateRef = useRef({ itemCd: '', groupNo: '' });
    const [kakousijiGroupDialogState, setKakousijiGroupDialogState] = useState({
        open: false,
        mode: '',
        panelType: '',
        title: '',
        itemCd: '',
        groupNo: '',
        colorOptions: []
    });
    const [genkaPatternNo, setGenkaPatternNo] = useState(0);
    const [genkaPattern, setGenkaPattern] = useState('');
    const [genkaCurrency, setGenkaCurrency] = useState('');
    const [genkaCurrencyNo, setGenkaCurrencyNo] = useState('0');
    const [genkaCurrencyOptions, setGenkaCurrencyOptions] = useState([]);
    const [hinbanFixEnabled, setHinbanFixEnabled] = useState(false);
    const [hinbanDeleteMenuDisabled, setHinbanDeleteMenuDisabled] = useState(false);
    const [sectionEditInfo, setSectionEditInfo] = useState({});
    const [sectionOverwriteConfirmState, setSectionOverwriteConfirmState] = useState({ open: false, panel: null });
    const [sustainableServerImageUrl, setSustainableServerImageUrl] = useState("");
    const [sustainableImageFileEditing, setSustainableImageFileEditing] = useState(false);
    const [sustainableImageFileInputValue, setSustainableImageFileInputValue] = useState("");
    const [sectionEditRenderVersion, setSectionEditRenderVersion] = useState(0);
    // 初期表示中はローディングを出し続ける(通信が静定するまで)。
    const [initialLoading, setInitialLoading] = useState(false);
    const initialLoadingTimerRef = useRef(null);
    const [kakousijiAddDialogState, setKakousijiAddDialogState] = useState({
        open: false,
        options: [],
        selectedValue: '',
        busy: false
    });
    const gridlist = useSelector(state => state.form.gridlist);

    const dispatch = useDispatch();
    const search = useLocation().search;
    const AGFunc = React.forwardRef(AGFunction);
    const ComFunc = React.forwardRef(ComFunction);
    const scrollRef = useRef(null);
    const editableSectionsRef = useRef({});
    const kakousijiSectionEditStartedRef = useRef(false);
    const sectionFieldsetRefs = useRef({});
    const sectionOverlayRefs = useRef({});
    const sectionButtonRefs = useRef({});
    const sectionHeaderFieldsetRefs = useRef({});
    const genkaPatternRequestSeqRef = useRef(0);
    const sustainableImageRequestSeqRef = useRef(0);
    const sustainableImageFileCancelBlurRef = useRef(false);
    const entryInitialFocusRef = useRef("");
    const kakousijiEntryCacheRef = useRef({});
    const gridapiRefs = useRef([]);
    const gridcolapiRefs = useRef([]);
    const griddataRefs = useRef([]);
    const gridcolRefs = useRef([]);
    const kakousijiSampleGridColRefs = useRef({});
    const kakousijiSampleSyncRetryTimersRef = useRef({});
    const kakousijiSampleRenderedPanelRefs = useRef({});
    const totalgriddataRefs = useRef({});
    const totalgridcolRefs = useRef({});
    const totalgridapiRefs = useRef({});
    const washStpSearchChangeUrlBackupRef = useRef([]);
    const [pendingOrderLaunches, setPendingOrderLaunches] = useState([]);

    useEffect(() => {
        if (!msgboxOpen || msgboxType !== 1 || msgboxMessage !== DEFAULT_DELETE_CONFIRM_MESSAGE) return;
        dispatch(confmsg({
            msg: HINBAN_MASTER_DELETE_CONFIRM_MESSAGE,
            cmd: msgboxCommand,
            cancel: msgboxCancel
        }));
    }, [dispatch, msgboxOpen, msgboxType, msgboxMessage, msgboxCommand, msgboxCancel]);
    const washStpSearchRoutingActiveRef = useRef(false);
    const CELLTYPE = CellType();
    const FIXED_HINBAN_NUMBERING_LABEL = "品番採番選択";
    const FIXED_HINBAN_NUMBERING_COLUMNID = "__hinban_numbering_select__";
    const SUB_BRAND_LABEL = "サブブランド";
    const SUB_BRAND_COLUMNID = "PDT_SBRCODE";
    const SUB_BRAND_FALLBACK_COLUMNID = "PDT_SBNCD";
    const BRAND_GROUP_COLUMNID = "PDTMD_BRDGP";
    const COST_RATE_LABEL = "原価率";
    const COST_RATE_COLUMNID = "__cost_rate__";
    const COST_RATE_TARGET_TYPE = "102";
    const COST_RATE_INSERT_POSITION = 7;
    const BRAND_HINBAN_LABEL = "ブランド品番";
    const BRAND_HINBAN_COLUMNID = "PDT_SYOHINCD";
    const BRAND_HINBAN_SERIAL_LABEL = "ブランド品番連番";
    const BRAND_HINBAN_SERIAL_DATAID = "UNUSENO";
    const PDTC_SIZE_PATTERN_REQUIRED_MESSAGE = "サイズパターンを選択してください。";
    const PDT_SIZE_PATTERN_FIELD_IDS = ["PDT_SIZEPATUN", "PDT_SIZEPATURN", "PDT_SIZEPATTERNCODE", "BITM_SIZEPATTERNCODE", "txtSizePattern"];
    const HINBAN_MASTER_SEARCH_CHANGE_URL = "common/GetSearchMasterList=hinbanmaster/GetSearchMasterList";
    const BRAND_HINBAN_SERIAL_SELECT_MODE = {
        SERIAL_FIELD: "SERIAL_FIELD",
        SYOHINCD: "SYOHINCD"
    };
    const BRAND_HINBAN_PREREQUISITE_KEYS = ['PDT_BRDCODE', 'PDT_YEAR', 'PDT_SEASONCD', 'PDT_ITMCITEMCD'];
    const BRAND_HINBAN_PREREQUISITE_LENGTHS = [3, 1, 1, 2];
    const PDT_SYNFLG1_DISPLAY_VALUE_MAP = { "0": "仮品番", "2": "本品番" };
    const PDT_SYNFLG1_2_DISPLAY_VALUE_MAP = {
        "0": "承認待ち",
        "1": "差し戻し",
        "2": "承認済み",
        "3": "却下"
    };
    const PDT_SYNONOFFFLG_DISPLAY_VALUE_MAP = { "0": "未連携", "1": "連携済" };
    const HINBAN_INPUT_CONTROL_STATUS = {
        REGISTERED: "REGISTERED",
        REQUESTED: "REQUESTED",
        APPROVED: "APPROVED",
        MD_TONYU: "MD_TONYU"
    };
    const HINBAN_INPUT_CONTROL_BASE_LOCK_COLUMNS = [
        "PDT_OPPICD",
        "PDT_YEAR",
        "PDT_SEASONCD",
        "PDT_HBSEASONCD",
        "PDT_BRDCODE",
        "PDT_COUNTRY"
    ];
    const HINBAN_INPUT_CONTROL_AFTER_REQUEST_LOCK_COLUMNS = [
        BRAND_HINBAN_COLUMNID,
        "PDT_ITMCITEMCD",
        "PDT_SHOHINKBN",
        "PDT_PRICE",
        "PDT_SIREJYUTAKUKBN"
    ];
    const HINBAN_INPUT_CONTROL_MD_TONYU_LOCK_COLUMNS = ["PDT_JYUTAKUSIRECD"];
    const HINBAN_INPUT_CONTROL_NMM_LOCK_COLUMNS = ["PDT_STUDIOFLG", "PDT_OPENPRICEFLG"];
    const HINBAN_MANUAL_INPUT_LOCK_COLUMNS = ["PDT_TENKAICODE", "PDT_SIZEPATUN"];
    const HINBAN_INPUT_CONTROL_CONDITIONAL_COLUMNS = [
        BRAND_HINBAN_COLUMNID,
        "PDT_ITMCITEMCD",
        "PDT_SHOHINKBN",
        "PDT_PRICE"
    ];
    const HINBAN_INPUT_CONTROL_LOCK_COLUMNS = {
        [HINBAN_INPUT_CONTROL_STATUS.REGISTERED]: HINBAN_INPUT_CONTROL_BASE_LOCK_COLUMNS,
        [HINBAN_INPUT_CONTROL_STATUS.REQUESTED]: [
            ...HINBAN_INPUT_CONTROL_BASE_LOCK_COLUMNS,
            ...HINBAN_INPUT_CONTROL_AFTER_REQUEST_LOCK_COLUMNS
        ],
        [HINBAN_INPUT_CONTROL_STATUS.APPROVED]: [
            ...HINBAN_INPUT_CONTROL_BASE_LOCK_COLUMNS,
            ...HINBAN_INPUT_CONTROL_AFTER_REQUEST_LOCK_COLUMNS
        ],
        [HINBAN_INPUT_CONTROL_STATUS.MD_TONYU]: [
            ...HINBAN_INPUT_CONTROL_BASE_LOCK_COLUMNS,
            ...HINBAN_INPUT_CONTROL_AFTER_REQUEST_LOCK_COLUMNS,
            ...HINBAN_INPUT_CONTROL_MD_TONYU_LOCK_COLUMNS
        ]
    };
    const DETAIL_HEADER_PANEL = { id: "2", type: "210" };
    const PDT_ITEM_DETAIL_PANEL = { id: "4", type: "230" };
    const DETAIL_HEADER_FIELD_IDS = ["PDT_TENKAICODE", "PDT_SIZEPATUN"];
    const KAKOUSIJI_S_LO_TYPE_OFFSET = 7;
    const KAKOUSIJI_PANEL_TYPE_MIN = 108;
    const KAKOUSIJI_PANEL_TYPE_MAX = 147;
    const KAKOUSIJI_HEADER_PANEL_TYPE = '107';
    const KAKOUSIJI_MODE_ANCHOR_PANEL_TYPE = '108';
    const KAKOUSIJI_ANCHOR_PANEL_TYPE = '240';
    const KAKOUSIJI_SIJISU_PANEL_TYPE = '111';
    const KAKOUSIJI_SIJISU_TOTAL_PANEL_TYPE = '112';
    const KAKOUSIJI_SIJISU_TOTAL_COL_ID = 'SIJISU_TOTAL';
    const KAKOUSIJI_SOZAI_MEISAI_PANEL_TYPE = '114';
    const KAKOUSIJI_FUZOKU_MEISAI_PANEL_TYPE = '117';
    const KAKOUSIJI_FUKUSHIZAI_LIST_PANEL_TYPE = '119';
    // 行の通貨単位により単価/金額の入力可否を切り替える対象（加工指示画面と同じ制御）。
    //   通貨=JPY  ：単価/金額     は入力可、単価(外)/金額(外) は入力不可
    //   通貨≠JPY ：単価(外)/金額(外) は入力可、単価/金額     は入力不可
    const KAKOUSIJI_DOMESTIC_CURRENCY_CODE = 'JPY';
    const KAKOUSIJI_CURRENCY_INPUT_LOCK_BY_TYPE = {
        [KAKOUSIJI_SOZAI_MEISAI_PANEL_TYPE]: {
            currencyField: 'SSDS_CUR',
            domesticFields: ['SSDS_TANKA', 'SOZAI_KINGAKU'],
            foreignFields: ['SSDS_TANKAF', 'SOZAI_KINGAKU_GAIKA']
        },
        [KAKOUSIJI_FUZOKU_MEISAI_PANEL_TYPE]: {
            currencyField: 'SSDF_CUR',
            domesticFields: ['SSDF_TANKA', 'FUZOKU_KINGAKU'],
            foreignFields: ['SSDF_TANKAF', 'FUZOKU_KINGAKU_GAIKA']
        },
        [KAKOUSIJI_FUKUSHIZAI_LIST_PANEL_TYPE]: {
            currencyField: 'SSDZM_CUR',
            domesticFields: ['SSDZM_TANKA', 'FUKUSHIZAI_ICHIRAN_KINGAKU'],
            foreignFields: ['SSDZM_TANKAF', 'FUKUSHIZAI_ICHIRAN_KINGAKU_GAIKA']
        }
    };
    const KAKOUSIJI_FUKUSHIZAI_BASE_PANEL_TYPE = '120';
    const KAKOUSIJI_QUALITY_BASE_PANEL_TYPE = '125';
    // アイテムタブ/グループトグルで内容が切り替わるスコープ(加工指示画面と同じ区分)
    const KAKOUSIJI_FUKUSHIZAI_SCOPE_PANEL_TYPES = ['120', '121', '122', '123', '124'];
    const KAKOUSIJI_QUALITY_SCOPE_PANEL_TYPES = ['125', '126', '127', '128', '129', '130', '131'];
    // 品表注意パネル(加工指示の139相当。品質スコープ枠の先頭に表示する)
    const KAKOUSIJI_QUALITY_WARNING_PANEL_TYPE = '148';
    const KAKOUSIJI_QUALITY_DISPLAY_PANEL_TYPE = '126';
    const KAKOUSIJI_SOSEI_CALC_PANEL_TYPE = '145';
    const HINBAN_WASH_PANEL_TYPE = '131';
    const HINBAN_WASH_STP_SEARCH_CHANGE_URL = 'common/GetSearchMasterList=kakousiji/GetWashPatternSearchList';
    const HINBAN_WASH_STP_SEARCH_DATAID = '__HINBAN_WASH_STP__';
    const HINBAN_WASH_STP_SENTAKU_FIELDS = ['STP_SENTAKU1', 'STP_SENTAKU2', 'STP_SENTAKU3', 'STP_SENTAKU4', 'STP_SENTAKU5', 'STP_SENTAKU6', 'STP_SENTAKU7'];
    const HINBAN_GENKA_PANEL_TYPE = '133';
    const KAKOUSIJI_DEMAND_JUTYU_PANEL_TYPE = '137';
    const KAKOUSIJI_DEMAND_NOUHIN_PANEL_TYPE = '138';
    const KAKOUSIJI_SAMPLE_PANEL_TYPE_MIN = 140;
    const KAKOUSIJI_SAMPLE_PANEL_TYPE_MAX = 145;
    const KAKOUSIJI_SAMPLE_INFO_PANEL_TYPES = ['140', '141', '142', '143', '146', '147'];
    const KAKOUSIJI_SAMPLE_PANEL_DISPLAY_ORDER = ['140', '141', '142', '143', '146', '147', '144', '145'];
    const KAKOUSIJI_SAMPLE_GROUP_KEY = '__sample_kakousiji_group__';
    const KAKOUSIJI_SAMPLE_GROUP_DISPLAY_PANEL_TYPES = ['139', '140', '141', '142', '143', '146', '147', '144', '145'];
    const KAKOUSIJI_SAMPLE_KBN_INITIAL_VALUES = {
        '140': '1',
        '141': '2',
        '142': '3',
        '143': '4',
        '146': '5',
        '147': '6'
    };
    const KAKOUSIJI_SAMPLE_HEADER_FIELD_IDS = [
        'SSDSP_NO',
        'SSDSP_KBN',
        'SSDSP_TAN',
        'SSDSP_STOPF',
        'SSDSP_SAMPLEUP',
        'SSDSP_REQUEST',
        'SSDSP_ARRIVAL',
        'SSDSP_DESDELIVERY',
        'SSDSP_ANSDELIVERY'
    ];
    const KAKOUSIJI_SAMPLE_PARENT_FIELD_IDS = ['SSDSP_NO'];
    const KAKOUSIJI_SAMPLE_COMMENT_FIELD_ID = 'SSDSP_COMMENT';
    const KAKOUSIJI_SAMPLE_DETAIL_FIELD_IDS = ['SSDSPM_COLORCD', 'SSDSPM_SIZECD', 'SSDSPM_SURYO'];
    const KAKOUSIJI_SECTION_139_SAVE_FIELD_IDS = ['SSDX_KIKAKUNO', 'SSD_SIIRECD', 'SSD_KAKOUSAKICD', 'SSDX_SHIIREPOENF'];
    const KAKOUSIJI_SAMPLE_FIELD_LABELS = {
        SSDSP_NO: '加工指示番号',
        SSDSP_KBN: 'サンプル区分',
        SSDSP_TAN: 'サンプル単価',
        SSDSP_STOPF: 'サンプル中止',
        SSDSP_SAMPLEUP: 'サンプル用着分up',
        SSDSP_REQUEST: 'サンプル依頼',
        SSDSP_ARRIVAL: 'サンプル着日',
        SSDSP_DESDELIVERY: 'サンプル希望納期',
        SSDSP_ANSDELIVERY: 'サンプル回答納期',
        SSDSP_COMMENT: 'コメント',
        SSDSPM_COLORCD: 'カラー',
        SSDSPM_SIZECD: 'サイズ',
        SSDSPM_SURYO: '指示数'
    };
    const KAKOUSIJI_FUKUSHIZAI_LIST_FIELD_RULES = [
        { kind: '01', fields: ['SSDZ_SAGEFUDASIZECD'] },
        { kind: '02', fields: ['SSDZ_BRANDNAMECD1', 'SSDZ_BRANDNAMECD2', 'SSDZ_BRANDNAMECD3'] },
        { kind: '03', fields: ['SSDZ_SIZENAMECD1', 'SSDZ_SIZENAMECD2', 'SSDZ_SIZENAMECD3', 'SSDZ_SIZENAMECD4', 'SSDZ_SIZENAMECD5', 'SSDZ_SIZENAMECD6'] },
        { kind: '04', fields: ['SSDZ_SONOTANAMECD1', 'SSDZ_SONOTANAMECD2', 'SSDZ_SONOTANAMECD3', 'SSDZ_SONOTANAMECD4', 'SSDZ_SONOTANAMECD5', 'SSDZ_SONOTANAMECD6'] },
        { kind: '05', fields: ['SSDZ_SIIRUNOCD'] },
        { kind: '06', fields: ['SSDZ_SUKARTOTURICD'] },
        { kind: '07', fields: ['SSDZ_SPEAFUKUROCD'] },
        { kind: '08', fields: ['SSDZ_BINIRUFUKUROCD'] },
        { kind: '09', fields: ['SSDZ_KAIGAINJICD'] },
        { kind: '11', fields: ['SSDZ_KOMONOFUDACD'] },
        { kind: '10', fields: ['SSDZ_SONOTAFUZOKUCD1', 'SSDZ_SONOTAFUZOKUCD2', 'SSDZ_SONOTAFUZOKUCD3', 'SSDZ_SONOTAFUZOKUCD4', 'SSDZ_SONOTAFUZOKUCD5'] }
    ];
    const KAKOUSIJI_FUKUSHIZAI_BASE_HIDDEN_COLUMN_IDS = [
        'SSDZ_ITMCITEMCD',
        'SSDZ_COLORCD',
        'SSDZ_FUKUSIZAICOLORGRP'
    ];
    const kakouTypeButtons = [
        { id: 'type1', label: '基本情報' },
        { id: 'type2', label: '受注数' },
        { id: 'type3', label: '納品予定数' }
    ];
    const KAKOUSIJI_NOUHIN_SUMMARY_COL_ID = {
        zansu: 'NOUHIN_ZANSU',
        toinyuTotal: 'NOUHIN_TOINYU_TOTAL',
        siireTotal: 'NOUHIN_SIIRE_TOTAL',
        nouhinTotal: 'NOUHIN_YOTEI_TOTAL',
        centerTotal: 'NOUHIN_CENTER_TOTAL',
        part1Total: 'NOUHIN_BUNNO1_TOTAL',
        part2Total: 'NOUHIN_BUNNO2_TOTAL',
        part3Total: 'NOUHIN_BUNNO3_TOTAL',
        part4Total: 'NOUHIN_BUNNO4_TOTAL',
        zansuTotal: 'NOUHIN_ZANSU_TOTAL'
    };
    const KAKOUSIJI_JUTYU_SUMMARY_COL_ID = {
        colorSubtotal: 'JUTYU_COLOR_TOTAL',
        totalLabel: 'JUTYU_TOTAL'
    };
    const KAKOUSIJI_UI_ACTION = {
        PRODUCT_ORDER: 'product_order',
        DETAIL_COPY: 'detail_copy',
        CALC: 'calc'
    };
    const KAKOUSIJI_DETAIL_COPY_MODE = {
        LIST_REFLECT: 'list_reflect',
        BULK_LOSS: 'bulk_loss',
        BULK_SHIKYU: 'bulk_shikyu'
    };
    const genkaPatternUrl = 'kakousiji/GetGenkaPattern';
    const genkaSsdNoColumnIdCandidates = ['SSD_NO', 'SSDM_NO', 'SSDS_NO', 'SSDSH_NO', 'SSDF_NO', 'SSDFH_NO', 'SSDZM_NO'];
    const genkaKaigaiKbnColumnIdCandidates = ['SSD_KAIGAIKBN', 'SSDS_KAIGAIKBN', 'SSDF_KAIGAIKBN', 'SSDZM_KAIGAIKBN'];
    const genkaBrandKbnColumnIdCandidates = ['BRD_BRANDKBN'];
    const genkaYushoMushoKbnColumnIdCandidates = ['TOR_YUSHOMUSHOKBN'];
    const genkaShohinKbnColumnIdCandidates = ['PDT_SHOHINKBN'];
    const genkaOppiCdColumnIdCandidates = ['SSD_OPPICD', 'SSDS_OPPICD', 'SSDSH_OPPICD', 'SSDF_OPPICD', 'SSDZM_OPPICD', 'PDT_OPPICD', 'SSDM_OPPICD'];
    const genkaKakouSakiKbnColumnIdCandidates = ['SSD_KAKOUSAKIKBN', 'SSDS_KAKOUSAKIKBN', 'SSDF_KAKOUSAKIKBN', 'SSDZM_KAKOUSAKIKBN'];
    const genkaKakouSakiCdColumnIdCandidates = ['SSD_KAKOUSAKICD', 'SSDS_KAKOUSAKICD', 'SSDF_KAKOUSAKICD', 'SSDZM_KAKOUSAKICD'];
    const genkaKakouSakiSubCdColumnIdCandidates = ['SSD_KAKOUSAKISUBCD', 'SSDS_KAKOUSAKISUBCD', 'SSDF_KAKOUSAKISUBCD', 'SSDZM_KAKOUSAKISUBCD'];
    const genkaSupplierCurrencyColumnIdCandidates = ['SSD_TSUKATANI', 'SSDS_TSUKATANI', 'SSDF_TSUKATANI', 'SSDZM_TSUKATANI', 'SSDGM_TSUKATANI'];
    const genkaHeaderCurrencyColumnIdCandidates = ['SSDGM_TSUKATANI', 'SSD_TSUKATANI', 'PDTMD_TSUKATANI'];
    const genkaHeaderCurrencyLayoutTypeCandidates = [HINBAN_GENKA_PANEL_TYPE, '126', '127'];
    const genkaRateColumnIdCandidates = ['SSDGM_RATE'];
    const jyutakuHasuShoriPosColumnIdCandidates = ['PDT_JYUHASUPOSITION', 'PDT_JYUTAKUHASUSHORIPOS', 'PDT_JSRYORIITI', 'JSRYORIITI'];
    const jyutakuHasuShoriKbnColumnIdCandidates = ['PDT_JYUHASUKBN', 'PDT_JYUTAKUHASUSHORIKBN', 'PDT_JSRYORIKBN', 'JSRYORIKBN'];

    // 入力中データと添付情報は ref で保持し、個別更新でも再描画を抑える
    const entrydataRef = useRef(null);
    const imageRef = useRef(null);
    const fileRef = useRef(null);         //ファイル  
    // 加工指示セクションの金額の端数処理設定。kakousiji/GetEntryData のレスポンス(amountrounding)を保持する。
    const kakousijiAmountRoundingRef = useRef(null);
    const initialPdtcDetail220Ref = useRef([]);
    const initialPdtNameRef = useRef({ PDT_HINMEINM: "", PDT_HINMEIRN: "" });
    const initialHinbanInputControlDataRef = useRef({});
    const pdtTenkaiCodeChangedAfterLoadRef = useRef(false);
    const controlDateRef = useRef("");
    // GetControlDate の取得結果キャッシュと実行中リクエストの相乗り管理。
    // NEW FORM 表示時は formstatus effect と clearform→syncNewFormPdtYear の2系統が
    // 別タイミングで取得するため、素通しだと同じ値を2回取得してしまう。
    const controlDateRequestStateRef = useRef({ value: "", returnData: null, waiters: null });
    const entryFormStartedAtRef = useRef("");
    const sectionEditStartProcessingRef = useRef(false);
    const priceChangeEnableRef = useRef(null);
    const hinbanFixEnableRequestSeqRef = useRef(0);
    const brandDepartmentAuthRequestSeqRef = useRef(0);
    const brandDepartmentDeleteDisabledRef = useRef(false);
    const synFlg1DeleteDisabledRef = useRef(false);
    const seasonChangeTimerRef = useRef(null);
    const lastSeasonValueRef = useRef("");
    const lastHbSeasonCodeRef = useRef("");
    const lastQrcPackIrisuKeyRef = useRef("");
    const lastQrcMinHachuTaniKeyRef = useRef("");
    const lastQrcSyohinBunruiCdKeyRef = useRef("");
    const lastQrcSyohinComentKeyRef = useRef("");
    const lastBrandGroupBrandCodeRef = useRef("");
    const brandGroupInfoRequestSeqRef = useRef(0);
    const lastJyutakuSupplierCodeRef = useRef("");
    const observedJyutakuSupplierCodeRef = useRef("");
    const pdtItemCodesAppliedVersionRef = useRef(0);
    const kakousijiDraftSeqRef = useRef(1);
    const lastLoadedKakousijiCodeRef = useRef("");
    const activeKakousijiKeyRef = useRef("");
    const kakousijiLoadRequestSeqRef = useRef(0);
    const kakousijiLoadingRef = useRef(false);
    const pdtcSizeOptionsRef = useRef([]);
    const pdtcSizePatternRequestSeqRef = useRef(0);
    const pdtSizePatternOptionsRef = useRef([]);
    const pdtSizePatternOptionsRequestSeqRef = useRef(0);
    function assignEntryDataCurrent(nextValue, reason) {
        // Redux(Immer)由来のオブジェクトは凍結されており、以降の書き込みが例外になる。
        // 参照をそのまま保持せず、必ず書き込み可能な複製にしてから保持する。
        const frozen = (nextValue !== null && typeof nextValue === 'object' && Object.isFrozen(nextValue));
        if (frozen && typeof console !== 'undefined' && console.warn) {
            console.warn('[perf] assignEntryDataCurrent に凍結オブジェクト reason=' + String(reason), new Error('freeze-assign').stack);
        }
        const writable = frozen ? { ...nextValue } : nextValue;
        entrydataRef.current = writable;
        return writable;
    }
    function protectHbSeasonCommit(targetData, reason) {
        const next = { ...(targetData || {}) };
        const current = entrydataRef.current || {};
        const currentHbSeason = String(DicVal(current, "PDT_HBSEASONCD", "")).trim();
        const nextHbSeason = String(DicVal(next, "PDT_HBSEASONCD", "")).trim();
        if (targetData !== entrydataRef.current && isEmpty(nextHbSeason) && !isEmpty(currentHbSeason)) {
            next.PDT_HBSEASONCD = currentHbSeason;
            if (isEmpty(DicVal(next, "PDT_JANSEASONCD", "")) && !isEmpty(DicVal(current, "PDT_JANSEASONCD", ""))) {
                next.PDT_JANSEASONCD = DicVal(current, "PDT_JANSEASONCD", "");
            }

        }
        return next;
    }
    const kakousijiImportedSummaryRowsRef = useRef([]);
    const primarykeys = ["PDT_OPPICD"];

    function buildHinbanMasterDocumentTitle(entryObj = entrydataRef.current) {
        const baseTitle = "KKAP Lite  #" + DicVal(menuinfo, "name", "");
        if (formstatus !== "ENTRY FORM") return baseTitle;

        const syohinCode = String(DicVal(entryObj, BRAND_HINBAN_COLUMNID, "") ?? "").trim();
        return isEmpty(syohinCode) ? baseTitle : baseTitle + " (" + syohinCode + ")";
    }

    useEffect(() => {
        if (typeof document === "undefined" || isEmpty(menuinfo)) return;
        document.title = buildHinbanMasterDocumentTitle();
    }, [formstatus, storeentrydata, edittingcode, update, menuinfo]);

    // ---- 共通サービス(shared/entry)の生成 ----
    // deps は毎レンダー作り直し、state 参照は getter 経由にして古い値を掴まないようにする。
    const gridRefSvc = createGridRefAccessors({
        isEmpty, DicVal, createRef, fnc,
        griddataRefs, gridcolRefs, gridapiRefs, gridcolapiRefs,
        filterGridColDef: (panel, coldef) => filterDetailHeaderGridColDef(panel, coldef)
    });
    const totalGridSvc = createTotalGridAccessors({
        isEmpty, DicVal, createRef,
        totalgriddataRefs, totalgridcolRefs, totalgridapiRefs
    });
    const entryValueSvc = createEntryValueResolver({
        isEmpty,
        getColumnInfo: () => columninfo
    });
    const genkaPatternSvc = createGenkaPatternResolver({
        isEmpty, DicVal,
        findEntryValue: entryValueSvc.findEntryValue,
        normalizeCodeValue: entryValueSvc.normalizeCodeValue,
        resolveEntryColumnId: entryValueSvc.resolveEntryColumnId,
        findColumnInfoByCandidates: entryValueSvc.findColumnInfoByCandidates,
        parseBoolLike: entryValueSvc.parseBoolLike,
        normalizeColOptionsToStrings: entryValueSvc.normalizeColOptionsToStrings,
        getController: () => controller,
        getEdittingCode: () => edittingcode,
        candidates: {
            ssdNo: genkaSsdNoColumnIdCandidates,
            kaigaiKbn: genkaKaigaiKbnColumnIdCandidates,
            brandKbn: genkaBrandKbnColumnIdCandidates,
            yushoMushoKbn: genkaYushoMushoKbnColumnIdCandidates,
            shohinKbn: genkaShohinKbnColumnIdCandidates,
            oppiCd: genkaOppiCdColumnIdCandidates,
            kakouSakiKbn: genkaKakouSakiKbnColumnIdCandidates,
            kakouSakiCd: genkaKakouSakiCdColumnIdCandidates,
            kakouSakiSubCd: genkaKakouSakiSubCdColumnIdCandidates,
            supplierCurrency: genkaSupplierCurrencyColumnIdCandidates,
            headerCurrency: genkaHeaderCurrencyColumnIdCandidates,
            headerCurrencyLayoutType: genkaHeaderCurrencyLayoutTypeCandidates,
            rate: genkaRateColumnIdCandidates
        }
    });
    const soseiCalcSvc = createSoseiCalcService({
        isEmpty, DicVal, DeepCopy, fnc,
        normalizeText: (value) => normalizeKakousijiText(value),
        getColumnInfo: () => columninfo
    });
    const callformSvc = createCallformLauncher({
        isEmpty, fnc,
        getFormId: () => formid,
        setPendingOrderLaunches
    });
    const columnInfoSvc = createColumnInfoService({
        isEmpty,
        getColumnInfo: () => columninfo,
        getPanels: () => panel
    });
    const layoutStorageSvc = createLayoutStorageService({
        isEmpty, DeepCopy, Getstorage, Savestorage, G_id, fnc, AGRef, dispatch,
        addentrylayout, setentrylayout, setentrystartup,
        getCorpkey: () => corpkey,
        getAccount: () => account,
        getFormId: () => formid,
        getController: () => controller,
        getSubkey: () => subkey,
        getPanels: () => panel,
        getGridList: () => gridlist,
        getTextFields: () => textfields,
        getColumnInfo: () => columninfo,
        getMainLayout: () => mainlayout,
        getMainPreLayout: () => mainprelayout,
        getMainInitLayout: () => maininitlayout,
        setPanels: setpanel,
        setColumns: setcolumns,
        setTextFieldsAll: settextfieldsall,
        setTextFields: settextfields,
        tabletype: (id) => tabletype(id),
        GridColApi: (panel) => GridColApi(panel),
        SetGridColDef: (panel, coldef) => SetGridColDef(panel, coldef),
        isEmptyPanel: (id) => EmptyPanel(id),
        normalizeDisplayFields: (fields) => normalizeDisplayFields(fields),
        buildBaseFieldSet: (colinfo, columns) => buildBaseFieldSet(colinfo, columns)
    });
    const sustainableImageSvc = createSustainableImageService({
        isEmpty, fnc, entrydataRef, rerender,
        PANEL_TYPE: { SUSTAINABLE_MARK: '' },
        SUSTAINABLE_IMAGE_FILE_FIELD,
        normalizeKakousijiUiString: (value) => normalizeKakousijiText(value),
        readRowValueIgnoreCase: (row, columnId) => readKakousijiRowValueIgnoreCase(row, columnId),
        getEntryLock: () => entrylock,
        getLayoutLock: () => layoutlock,
        // 品番マスタはセクション単位の編集ロックも見る。
        isEditBlocked: (panelInfo) => entrylock || layoutlock || sectionBodyLocked(panelInfo),
        getSustainableImageFileInputValue: () => sustainableImageFileInputValue,
        sustainableImageFileCancelBlurRef,
        setSustainableImageFileInputValue,
        setSustainableImageFileEditing,
        loadSustainableImageFromServer: (source) => loadSustainableImageFromServer(source),
        afterCommit: () => dispatch(entrydata({ ...entrydataRef.current }))
    });
    const columnIdUtil = createColumnIdUtil({ isEmpty, DicVal });
    const sectionIdBridge = createSectionIdBridge({ canonicalPanelType: (type) => columnIdUtil.canonicalPanelType(type) });
    const typeColumnResolver = createTypeColumnResolver({
        isEmpty,
        getColumnInfo: () => columninfo,
        getColumns: () => columns,
        normalizeTypeKey: (key) => columnIdUtil.normalizeTypeKey(key),
        normalizeColumnIdSuffix: (columnid) => columnIdUtil.normalizeColumnIdSuffix(columnid),
        normalizeLabelKey: (label) => columnIdUtil.normalizeLabelKey(label)
    });
    // 受注数/納品予定の共通ロジック(demandRowNormalizer / demandGridColumnBuilder)は加工指示の
    // type キー("130"/"131")で列定義を引く。品番マスタでは同じ列が type 137/138 にあるため、
    // 需要グリッド専用の列解決で 130→137 / 131→138 へ写す(汎用の typeColumnResolver には影響させない)。
    const mapKakousijiDemandTypeKeyToHinban = (key) => {
        const normalized = columnIdUtil.normalizeTypeKey(key);
        if (normalized === "130") return KAKOUSIJI_DEMAND_JUTYU_PANEL_TYPE;
        if (normalized === "131") return KAKOUSIJI_DEMAND_NOUHIN_PANEL_TYPE;
        return normalized;
    };
    const demandTypeColumnResolver = createTypeColumnResolver({
        isEmpty,
        getColumnInfo: () => columninfo,
        getColumns: () => columns,
        normalizeTypeKey: mapKakousijiDemandTypeKeyToHinban,
        normalizeColumnIdSuffix: (columnid) => columnIdUtil.normalizeColumnIdSuffix(columnid),
        normalizeLabelKey: (label) => columnIdUtil.normalizeLabelKey(label)
    });
    const demandRowNormalizer = createDemandRowNormalizer({
        isEmpty,
        DicVal,
        resolveTypeColumnIdBySuffix: (type, suffixCandidates) => demandTypeColumnResolver.resolveTypeColumnIdBySuffix(type, suffixCandidates),
        resolveTypeColumnIdByName: (type, nameCandidates) => demandTypeColumnResolver.resolveTypeColumnIdByName(type, nameCandidates),
        resolveTypeColumnNameById: (type, columnId) => demandTypeColumnResolver.resolveTypeColumnNameById(type, columnId),
        JUTYU_SUMMARY_COL_ID: KAKOUSIJI_JUTYU_SUMMARY_COL_ID,
        NOUHIN_SUMMARY_COL_ID: KAKOUSIJI_NOUHIN_SUMMARY_COL_ID
    });
    const demandGridSupport = createDemandGridSupportService({
        JUTYU_SUMMARY_COL_ID: KAKOUSIJI_JUTYU_SUMMARY_COL_ID,
        NOUHIN_SUMMARY_COL_ID: KAKOUSIJI_NOUHIN_SUMMARY_COL_ID,
        isEmpty,
        DicVal,
        parseBoolLike: (value, defaultVal) => parseBoolLike(value, defaultVal),
        normalizeKakousijiUiString: (value) => normalizeKakousijiText(value),
        normalizeColumnIdUpper: (columnid) => columnIdUtil.normalizeColumnIdUpper(columnid),
        normalizeColumnIdSuffix: (columnid) => columnIdUtil.normalizeColumnIdSuffix(columnid),
        readRowValueIgnoreCase: (row, columnId) => readKakousijiRowValueIgnoreCase(row, columnId),
        isDemandPanelInfo: (panelInfo) => isKakousijiDemandPanel(panelInfo)
    });
    const demandGridColumnBuilder = createDemandGridColumnBuilder({
        griddataRefs,
        entrydataRef,
        isEmpty,
        isEnabled,
        DicVal,
        // 品番マスタは grid 行の引き当て方が異なるため getGridRows を渡す。
        getGridRows: (panelInfo) => GridData(panelInfo),
        resolveGridIndex: () => -1,
        ensureGridRefArray: () => ({ current: [] }),
        findEntryValue: (entryObj, candidates) => findEntryValue(entryObj, candidates),
        normalizeColumnIdUpper: (columnid) => columnIdUtil.normalizeColumnIdUpper(columnid),
        normalizeColumnIdSuffix: (columnid) => columnIdUtil.normalizeColumnIdSuffix(columnid),
        normalizeLabelKey: (label) => columnIdUtil.normalizeLabelKey(label),
        isGridAuxColId: (colId) => demandGridSupport.isGridAuxColId(colId),
        resolveTypeColumnIdBySuffix: (type, suffixCandidates) => demandTypeColumnResolver.resolveTypeColumnIdBySuffix(type, suffixCandidates),
        resolveTypeColumnIdByName: (type, nameCandidates) => demandTypeColumnResolver.resolveTypeColumnIdByName(type, nameCandidates),
        demandTypeKeyByPanel: (panelInfo) => columnIdUtil.demandTypeKeyByPanel(panelInfo),
        demandJutyuDisplayFieldId: (columnId) => demandGridSupport.demandJutyuDisplayFieldId(columnId),
        isDemandCellEditableByLayout: (colDef, params) => demandGridSupport.isDemandCellEditableByLayout(colDef, params),
        resolveDemandCellStyle: (originalCellStyle, colDef, params, demandType) => demandGridSupport.resolveDemandCellStyle(originalCellStyle, colDef, params, demandType),
        NOUHIN_SUMMARY_COL_ID: KAKOUSIJI_NOUHIN_SUMMARY_COL_ID
    });
    const demandHeaderRenderer = createDemandHeaderRenderer({
        PANEL_TYPE: { JUTYUSU: KAKOUSIJI_DEMAND_JUTYU_PANEL_TYPE, NOUHINYOTEI: KAKOUSIJI_DEMAND_NOUHIN_PANEL_TYPE },
        entrydataRef,
        findEntryValue: (entryObj, candidates) => findKakousijiEntryValue(entryObj, candidates),
        resolveDemandHeaderFallbackValue: (sectionId, primaryKeys, detailPanelType, fallbackGridSectionId) =>
            resolveKakousijiDemandHeaderFallbackValue(sectionId, primaryKeys, detailPanelType, fallbackGridSectionId)
    });




    function gridRefFallbackKey(panel) {
        return gridRefSvc.gridRefFallbackKey(panel);
    }
    function ensureGridRef(refArray, panel, initializer) {
        return gridRefSvc.ensureGridRef(refArray, panel, initializer);
    }
    function ensureGridDataRef(panel) {
        return gridRefSvc.ensureGridDataRef(panel);
    }
    function ensureGridColRef(panel) {
        return gridRefSvc.ensureGridColRef(panel);
    }
    function ensureKakousijiSampleGridColRef(panel) {
        const key = gridRefFallbackKey(panel) + '_sample_detail';
        if (isEmpty(kakousijiSampleGridColRefs.current[key])) kakousijiSampleGridColRefs.current[key] = createRef();
        return kakousijiSampleGridColRefs.current[key];
    }
    function ensureGridApiRef(panel) {
        return gridRefSvc.ensureGridApiRef(panel);
    }
    function ensureGridColApiRef(panel) {
        return gridRefSvc.ensureGridColApiRef(panel);
    }
    function SetGridData(panel, data) {
        gridRefSvc.SetGridData(panel, data);
    }
    function GridData(panel) {
        return gridRefSvc.GridData(panel);
    }
    function isSection220EmptyGrid(panel) {
        const sectionType = String(DicVal(panel, 'type', '')).trim();
        if (sectionType !== '220') return false;
        const rows = GridData(panel);
        return !Array.isArray(rows) || rows.length === 0;
    }
    function SetGridColDef(panel, coldef) {
        gridRefSvc.SetGridColDef(panel, coldef);
    }
    function SetGridApi(panel, api) {
        gridRefSvc.SetGridApi(panel, api);
    }
    function GridApi(panel) {
        return gridRefSvc.GridApi(panel);
    }
    function SetGridColApi(panel, api) {
        gridRefSvc.SetGridColApi(panel, api);
    }
    function GridColApi(panel) {
        return gridRefSvc.GridColApi(panel);
    }
    // 洗濯表示パネルの表示行変換と、洗濯記号マスタ検索の遷移制御をまとめる。
    function buildHinbanWashPanelServiceDeps() {
        return {
            DicVal,
            GridApi,
            GridData,
            HINBAN_MASTER_SEARCH_CHANGE_URL,
            HINBAN_WASH_PANEL_TYPE,
            HINBAN_WASH_STP_SEARCH_CHANGE_URL,
            HINBAN_WASH_STP_SEARCH_DATAID,
            SetGridData,
            changeurl,
            dispatch,
            entrydataRef,
            entrylock,
            fixedHinbanGenkaDisplayRows,
            fnc,
            isEmpty,
            isHinbanGenkaPanel,
            layoutlock,
            setchangeurl,
            washStpSearchChangeUrlBackupRef,
            washStpSearchRoutingActiveRef
        };
    }
    // 加工指示サンプル情報パネルの行・列・PDTC連動をまとめる。
    function buildKakousijiSampleInfoServiceDeps() {
        return {
            AGRef,
            CELLTYPE,
            DicVal,
            GridApi,
            GridData,
            KAKOUSIJI_SAMPLE_COMMENT_FIELD_ID,
            KAKOUSIJI_SAMPLE_DETAIL_FIELD_IDS,
            KAKOUSIJI_SAMPLE_FIELD_LABELS,
            KAKOUSIJI_SAMPLE_HEADER_FIELD_IDS,
            KAKOUSIJI_SAMPLE_INFO_PANEL_TYPES,
            KAKOUSIJI_SAMPLE_KBN_INITIAL_VALUES,
            KAKOUSIJI_SAMPLE_PARENT_FIELD_IDS,
            SetGridData,
            ValueChanged,
            activeKakousijiSummaryItem,
            buildDerivedPdtcDetails,
            columninfo,
            columns,
            comparePdtcDetailOrderValue,
            entrydataRef,
            fnc,
            getKakousijiEntryCache,
            gridRefFallbackKey,
            gridlist,
            initialPdtcDetail220Ref,
            isEmpty,
            kakousijiSampleRenderedPanelRefs,
            kakousijiSampleSyncRetryTimersRef,
            panel,
            pdtcDetailPanel,
            resolveDetailRowValue,
            setEntryGridRows,
            setSectionEditRenderVersion,
            textfields,
            textfieldsall
        };
    }
    // 列定義の正規化と、品番入力制御(手入力ロック等)の適用をまとめる。
    function buildFieldNormalizeServiceDeps() {
        return {
            BRAND_HINBAN_COLUMNID,
            CELLTYPE,
            DicVal,
            FIXED_HINBAN_NUMBERING_COLUMNID,
            FIXED_HINBAN_NUMBERING_LABEL,
            G_id,
            HINBAN_INPUT_CONTROL_CONDITIONAL_COLUMNS,
            HINBAN_INPUT_CONTROL_LOCK_COLUMNS,
            HINBAN_INPUT_CONTROL_NMM_LOCK_COLUMNS,
            HINBAN_INPUT_CONTROL_STATUS,
            HINBAN_MANUAL_INPUT_LOCK_COLUMNS,
            PDT_SYNFLG1_2_DISPLAY_VALUE_MAP,
            PDT_SYNFLG1_DISPLAY_VALUE_MAP,
            PDT_SYNONOFFFLG_DISPLAY_VALUE_MAP,
            entrydataRef,
            firstNonEmptyValue,
            formstatus,
            initialHinbanInputControlDataRef,
            isBrandHinbanNumberingControlledField,
            isEmpty,
            storeentrydata
        };
    }
    // 画面固有の派生項目(原価率・サブブランド・ブランド品番・固定採番)の生成と差し込みをまとめる。
    function buildDerivedFieldServiceDeps() {
        return {
            BRAND_GROUP_COLUMNID,
            BRAND_HINBAN_COLUMNID,
            BRAND_HINBAN_LABEL,
            BRAND_HINBAN_PREREQUISITE_KEYS,
            BRAND_HINBAN_PREREQUISITE_LENGTHS,
            BRAND_HINBAN_SERIAL_DATAID,
            BRAND_HINBAN_SERIAL_LABEL,
            CELLTYPE,
            COST_RATE_COLUMNID,
            COST_RATE_INSERT_POSITION,
            COST_RATE_LABEL,
            COST_RATE_TARGET_TYPE,
            DeepCopy,
            DicVal,
            FIXED_HINBAN_NUMBERING_LABEL,
            FormatDate,
            G_id,
            SUB_BRAND_COLUMNID,
            SUB_BRAND_FALLBACK_COLUMNID,
            SUB_BRAND_LABEL,
            createFixedHinbanNumberingField,
            dispatch,
            entrydata,
            entrydataRef,
            entryrerender,
            findBrandHinbanSerialField,
            formstatus,
            getEntryDataValue,
            isEmpty,
            isFixedHinbanNumberingTarget,
            matchesColumnId,
            normalizeNumberText,
            rerender,
            setEntryDataValue
        };
    }
    // 基本項目の組み立てと、新規時の既定値/連動値の適用・保存前整形をまとめる。
    function buildEntryDefaultsServiceDeps() {
        return {
            CELLTYPE,
            DicVal,
            G_id,
            applyCostRateToEntryData,
            assignEntryDataCurrent,
            columninfo,
            columns,
            controlDateRef,
            dispatch,
            entrydata,
            entrydataRef,
            entryrerender,
            firstNonEmptyValue,
            getEntryDataValue,
            initializedata,
            insertBrandHinbanField,
            insertCostRateField,
            insertFixedHinbanNumberingField,
            insertSubBrandField,
            isEmpty,
            matchesColumnId,
            normalizeDisplayFields,
            rerender,
            resolveBrandHinbanField,
            resolveCostRateField,
            resolveEntryDataKey,
            resolveFixedHinbanNumberingField,
            resolveSubBrandField,
            setEntryDataValue,
            staff,
            textfieldsall
        };
    }
    // ブランド品番/OPPI品番の採番制御と、保存時の採番確定をまとめる。
    function buildHinbanNumberingServiceDeps() {
        return {
            BRAND_HINBAN_COLUMNID,
            BRAND_HINBAN_SERIAL_DATAID,
            BRAND_HINBAN_SERIAL_LABEL,
            DicVal,
            FIXED_HINBAN_NUMBERING_COLUMNID,
            applyBrandHinbanCodeToEntryData,
            applyFirstExistingValue,
            assignEntryDataCurrent,
            dispatch,
            entrydata,
            entrydataRef,
            entryrerender,
            firstNonEmptyValue,
            fnc,
            getEntryDataValue,
            hasBrandHinbanPrerequisites,
            isEmpty,
            matchesColumnId,
            normalizeBrandHinbanSerialValue,
            protectHbSeasonCommit,
            rerender,
            sanitizeEntryData,
            setEntryDataValue,
            setSubBrandFieldOptions,
            textfieldsall
        };
    }
    // 価格変更可否・品番確定可否・削除メニュー可否など権限まわりの判定をまとめる。
    function buildHinbanPermissionServiceDeps() {
        return {
            DicVal,
            brandDepartmentAuthRequestSeqRef,
            brandDepartmentDeleteDisabledRef,
            fnc,
            formstatus,
            getEntryDataValue,
            hinbanDeleteMenuDisabled,
            hinbanFixEnableRequestSeqRef,
            isEmpty,
            priceChangeEnableRef,
            setHinbanDeleteMenuDisabled,
            setHinbanFixEnabled,
            setPriceFieldLocked,
            synFlg1DeleteDisabledRef
        };
    }
    // PDTC明細(カラー/サイズ/SKU)の派生行生成・サイズ選択列・品名同期をまとめる。
    function buildPdtcDetailServiceDeps() {
        return {
            CELLTYPE,
            DeepCopy,
            DicVal,
            GridData,
            PDTC_SIZE_SELECTED_FIELD,
            columninfo,
            columns,
            entrydataRef,
            fnc,
            formstatus,
            getEntryDataValue,
            gridlist,
            initialPdtNameRef,
            isEmpty,
            isEnabled,
            matchesColumnId,
            matchesColumnToken,
            panel,
            setEntryGridRows,
            setSkuNameConfirmState,
            skuNameConfirmState,
            storeRowData
        };
    }
    function isHinbanWashPanel(panelInfo) {
        return createHinbanWashPanelService(buildHinbanWashPanelServiceDeps()).isHinbanWashPanel(panelInfo);
    }
    function createHinbanWashDisplayRow(source = {}) {
        return createHinbanWashPanelService(buildHinbanWashPanelServiceDeps()).createHinbanWashDisplayRow(source);
    }
    function buildHinbanWashDisplayRows(rows) {
        return createHinbanWashPanelService(buildHinbanWashPanelServiceDeps()).buildHinbanWashDisplayRows(rows);
    }
    function buildHinbanWashSaveRows(rows) {
        return createHinbanWashPanelService(buildHinbanWashPanelServiceDeps()).buildHinbanWashSaveRows(rows);
    }
    function isSearchMasterListChangeUrl(value) {
        return createHinbanWashPanelService(buildHinbanWashPanelServiceDeps()).isSearchMasterListChangeUrl(value);
    }
    function sameChangeUrl(left, right) {
        return createHinbanWashPanelService(buildHinbanWashPanelServiceDeps()).sameChangeUrl(left, right);
    }
    function createHinbanMasterSearchChangeUrl(baseChangeUrl) {
        return createHinbanWashPanelService(buildHinbanWashPanelServiceDeps()).createHinbanMasterSearchChangeUrl(baseChangeUrl);
    }
    function createWashStpSearchChangeUrl(baseChangeUrl) {
        return createHinbanWashPanelService(buildHinbanWashPanelServiceDeps()).createWashStpSearchChangeUrl(baseChangeUrl);
    }
    function restoreWashStpSearchChangeUrl() {
        return createHinbanWashPanelService(buildHinbanWashPanelServiceDeps()).restoreWashStpSearchChangeUrl();
    }
    function routeWashStpSearchChangeUrl() {
        return createHinbanWashPanelService(buildHinbanWashPanelServiceDeps()).routeWashStpSearchChangeUrl();
    }
    function buildWashStpSearchDataInfo() {
        return createHinbanWashPanelService(buildHinbanWashPanelServiceDeps()).buildWashStpSearchDataInfo();
    }
    function applyWashStpMasterSelection(panelInfo, result) {
        return createHinbanWashPanelService(buildHinbanWashPanelServiceDeps()).applyWashStpMasterSelection(panelInfo, result);
    }
    function openWashStpMasterSearch(panelInfo) {
        return createHinbanWashPanelService(buildHinbanWashPanelServiceDeps()).openWashStpMasterSearch(panelInfo);
    }
    function buildWashGridFunctionRef(panelInfo) {
        return createHinbanWashPanelService(buildHinbanWashPanelServiceDeps()).buildWashGridFunctionRef(panelInfo);
    }
    function setEntryGridRows(panelInfo, rows) {
        return createHinbanWashPanelService(buildHinbanWashPanelServiceDeps()).setEntryGridRows(panelInfo, rows);
    }
    function totalRefKey(panel) {
        return totalGridSvc.totalRefKey(panel);
    }
    function ensureTotalDataRef(panel) {
        return totalGridSvc.ensureTotalDataRef(panel);
    }
    function ensureTotalColRef(panel) {
        return totalGridSvc.ensureTotalColRef(panel);
    }
    function ensureTotalApiRef(panel) {
        return totalGridSvc.ensureTotalApiRef(panel);
    }
    function SetTotalGridApi(panel, api) {
        totalGridSvc.SetTotalGridApi(panel, api);
    }
    function TotalGridApi(panel) {
        return totalGridSvc.TotalGridApi(panel);
    }
    function applyTotalRowsNow(totalPanel, rows) {
        totalGridSvc.applyTotalRowsNow(totalPanel, rows);
    }
    function onFirstTotalDataRendered(param, totalPanel) {
        totalGridSvc.onFirstTotalDataRendered(param, totalPanel);
    }
    function kakousijiSijisuTotalPanel(panelInfo) {
        return { ...panelInfo, totaltype: KAKOUSIJI_SIJISU_TOTAL_PANEL_TYPE };
    }
    function resolveKakousijiSijisuTotalColumnId() {
        const sources = [columns, columninfo];
        for (let i = 0; i < sources.length; i++) {
            const hit = (Array.isArray(sources[i]) ? sources[i] : []).find((col) => {
                if (String(DicVal(col, 'type', '')).trim() !== KAKOUSIJI_SIJISU_TOTAL_PANEL_TYPE) return false;
                const columnId = String(DicVal(col, 'columnid', DicVal(col, 'field', ''))).trim();
                return columnId !== '' && columnId !== 'rowid' && columnId !== 'grip';
            });
            const columnId = String(DicVal(hit, 'columnid', DicVal(hit, 'field', ''))).trim();
            if (columnId !== '') return columnId;
        }
        return KAKOUSIJI_SIJISU_TOTAL_COL_ID;
    }
    function buildKakousijiSijisuTotalRows(rows) {
        const sourceRows = Array.isArray(rows) ? rows : [];
        const toNum = (value) => {
            const num = Number(String(value ?? '').replace(/,/g, ''));
            return Number.isFinite(num) ? num : 0;
        };
        const qtyTotal = sourceRows.reduce((sum, row) => sum + toNum(DicVal(row, 'SSDM_SEIHATCHUSU', '')), 0);
        const totalColumnId = resolveKakousijiSijisuTotalColumnId();
        return [{
            rowid: 'TOTAL',
            grip: '計',
            [KAKOUSIJI_SIJISU_TOTAL_COL_ID]: String(qtyTotal),
            [totalColumnId]: String(qtyTotal)
        }];
    }
    function recalcKakousijiSijisuTotalRows(panelInfo) {
        if (!isKakousijiSijisuPanel(panelInfo)) return;
        const totalPanel = kakousijiSijisuTotalPanel(panelInfo);
        const nextRows = buildKakousijiSijisuTotalRows(GridData(panelInfo));
        ensureTotalDataRef(totalPanel).current = nextRows;
        applyTotalRowsNow(totalPanel, nextRows);
    }
    // 画面表示/レイアウト適用/データ読込/クリア/削除など入力画面のライフサイクル処理をまとめる。
    function buildEntryLifecycleServiceDeps() {
        return {
            AGRef,
            DeepCopy,
            DicVal,
            EDIT_UPDATE_TRACKING_PANEL_TYPES,
            EmptyPanel,
            EntrybodyRef,
            G_id,
            GridApi,
            GridData,
            SetGridApi,
            SetGridColApi,
            SetGridData,
            applyClientOnlyEntryDefaults,
            applyZaikoHyokaKbnFromShohinKbn,
            assignEntryDataCurrent,
            baseFieldsForInit,
            baseref,
            brandGroupInfoRequestSeqRef,
            buildHinbanGenkaStoredRows,
            buildHinbanWashDisplayRows,
            captureInitialPdtName,
            cfMargeUploadFiles,
            changestatus,
            columninfo,
            controlDateRef,
            controlDateRequestStateRef,
            controller,
            createBaseInitialData,
            currentPdtSizePatternCode,
            dispatch,
            displayInitialBlankDetailGridRow,
            edittingcode,
            entryFormStartedAtRef,
            entrydata,
            entrydataRef,
            entryrerender,
            fileRef,
            fnc,
            formatDateTimeForServer,
            formstatus,
            getglobaldata,
            gridlist,
            imageRef,
            importKakousijiEntriesFromHinbanData,
            initialHinbanInputControlDataRef,
            initialPdtcDetail220Ref,
            insertBrandHinbanField,
            insertCostRateField,
            insertFixedHinbanNumberingField,
            insertSubBrandField,
            isEmpty,
            isEnabled,
            isHinbanGenkaPanel,
            isHinbanWashPanel,
            kakousijiEntryCacheRef,
            kakousijiImportedSummaryRowsRef,
            lastBrandGroupBrandCodeRef,
            lastHbSeasonCodeRef,
            lastJyutakuSupplierCodeRef,
            lastLoadedKakousijiCodeRef,
            lastQrcMinHachuTaniKeyRef,
            lastQrcPackIrisuKeyRef,
            lastQrcSyohinBunruiCdKeyRef,
            lastQrcSyohinComentKeyRef,
            lastSeasonValueRef,
            loadBrandGroupInfo,
            loadHinbanFixEnableByBrand,
            loadJanSeasonCode,
            loadJyutakuSupplierInfo,
            loadKakousijiSummaryList,
            loadPdtSizePatternOptions,
            loadPdtSizePatternSizeOptions,
            loadPriceChangeEnable,
            loadQrcSyohinBunruiCd,
            loadQrcSyohinComent,
            loadSubBrandName,
            loadSustainableImageFromServer,
            loadUserAllowedBrandDepartment,
            locationstate,
            nametocolumn,
            normalizeKakousijiSampleDetailForDisplayByType,
            normalizePdtcDetailSections,
            observedJyutakuSupplierCodeRef,
            panel,
            pdtTenkaiCodeChangedAfterLoadRef,
            priceChangeEnableRef,
            primarykeys,
            refreshPdtSizePatternEditableState,
            rerender,
            resetSectionEdit,
            resolveBrandGroupBrandCode,
            resolveBrandHinbanField,
            resolveCostRateField,
            resolveFixedHinbanNumberingField,
            resolvePdtYearFromControlDate,
            resolveSubBrandField,
            scrollRef,
            seasonChangeTimerRef,
            setActiveKakousijiKey,
            setEntryGridRows,
            setGenkaCurrency,
            setGenkaCurrencyNo,
            setGenkaCurrencyOptions,
            setGenkaPattern,
            setGenkaPatternNo,
            setKakousijiSummaryList,
            setPdtItemCodesLoadVersion,
            setPriceFieldLocked,
            setSectionEditInfo,
            setSectionEditInfoFromData,
            setSectionEditInfoFromDataBulk,
            setSustainableImageFileEditing,
            setSustainableImageFileInputValue,
            setSustainableServerImageUrl,
            setedittingcode,
            setglobaldata,
            setimagelist,
            setpanel,
            settextfields,
            subkey,
            sustainableImageRequestSeqRef,
            syncHinbanGenkaCurrencyState,
            syncHinbanGenkaPatternByEntry,
            syncKakousijiSamplePanelsFromPdtc,
            syncMakerHyojyunJyodaiFromPrice,
            syncPdtYear,
            textfields,
            textfieldsall,
            updateSynFlg1DeleteDisabled
        };
    }
    // 基本項目/明細の値変更ハンドラと、それに伴う連動処理をまとめる。
    function buildValueChangedServiceDeps() {
        return {
            BRAND_HINBAN_COLUMNID,
            DicVal,
            GridData,
            HINBAN_GENKA_PANEL_TYPE,
            KAKOUSIJI_ANCHOR_PANEL_TYPE,
            KAKOUSIJI_DEMAND_JUTYU_PANEL_TYPE,
            KAKOUSIJI_DEMAND_NOUHIN_PANEL_TYPE,
            KAKOUSIJI_FUKUSHIZAI_BASE_PANEL_TYPE,
            KAKOUSIJI_FUKUSHIZAI_LIST_PANEL_TYPE,
            KAKOUSIJI_FUZOKU_MEISAI_PANEL_TYPE,
            KAKOUSIJI_SAMPLE_INFO_PANEL_TYPES,
            KAKOUSIJI_SIJISU_PANEL_TYPE,
            KAKOUSIJI_SOZAI_MEISAI_PANEL_TYPE,
            PDTC_SIZE_PATTERN_REQUIRED_MESSAGE,
            PDT_SIZE_PATTERN_FIELD_IDS,
            SUB_BRAND_COLUMNID,
            SUSTAINABLE_IMAGE_FILE_FIELD,
            activeKakousijiSummaryItem,
            applyCostRateToEntryData,
            applyKakousijiBaseUpdatesToCurrentContext,
            applyKakousijiGroupSelectionToRow,
            applyPdtSizePatternOptions,
            applyPdtcSizeOptions,
            applyRotRoundRuleToEntryData,
            applySubBrandNameToEntryData,
            applyZaikoHyokaKbnFromShohinKbn,
            clearPdtTenkaiCodeValue,
            columninfo,
            currentPdtSizePatternCode,
            dispatch,
            entrydata,
            entrydataRef,
            entryrerender,
            entrytriggercall,
            fnc,
            formstatus,
            getEntryDataValue,
            handleBrandHinbanSerialSelection,
            isEmpty,
            isKakousijiGroupManagedPanelType,
            isKakousijiPanelType,
            lastSeasonValueRef,
            loadBitmSubCode,
            loadBrandGroupInfo,
            loadColorMasterInfo,
            loadHinbanFixEnableByBrand,
            loadJanSeasonCode,
            loadJyutakuSupplierInfo,
            loadPdtSizePatternOptions,
            loadPdtSizePatternSizeOptions,
            loadPdtTenkaiCodeOptionsForData,
            loadPdtTenkaiSizePatternInfo,
            loadQrcSyohinBunruiCd,
            loadQrcSyohinComent,
            loadSustainableImageFromServer,
            loadUserAllowedBrandDepartment,
            matchesColumnId,
            matchesColumnToken,
            normalizeKakousijiDemandRows,
            pdtTenkaiCodeChangedAfterLoadRef,
            recalcHinbanGenkaGridAndSummary,
            recalcKakousijiAccessoryDetailCalcRows,
            recalcKakousijiFukushizaiListCalcRows,
            recalcKakousijiMaterialDetailCalcRows,
            recalcKakousijiSijisuTotalRows,
            refreshControlDate,
            refreshKakousijiSummaryState,
            refreshPdtSizePatternEditableState,
            resolveKakousijiActiveGroupSelection,
            resolveKakousijiRepresentativePanelTypeByFieldId,
            resolveKakousijiSummaryTargetSsdNo,
            seasonChangeTimerRef,
            setEntryGridRows,
            setSectionEditRenderVersion,
            settextfields,
            settextfieldsall,
            shouldRefreshHinbanGenkaByColumnId,
            shouldSyncKakousijiSummaryByFieldId,
            storeRowData,
            syncHinbanGenkaCurrencyState,
            syncHinbanGenkaPatternByEntry,
            syncItemDependentData,
            syncKakousijiRepresentativeEntryProjection,
            syncKakousijiSamplePanelsFromPdtc,
            syncMakerHyojyunJyodaiFromPrice,
            syncPdtBrandCodeAlias
        };
    }
    // 保存の実行制御(採番確定・確認ダイアログ・送信)をまとめる。
    function buildSaveOrchestratorDeps() {
        return {
            DicVal,
            G_id,
            Getrowid,
            GridData,
            HINBAN_NUMBERING_FAILED_MESSAGE,
            HINBAN_WASH_PANEL_TYPE,
            LoadData,
            SetPLData,
            buildHinbanWashSaveRows,
            buildMainSaveData,
            buildMainSaveDetail,
            buildPendingKakousijiSaveEntries,
            buildSaveColumnInfo,
            cfFileUpload,
            cfNewUploadFile,
            changestatus,
            columninfo,
            confirmPdtcSkuNameSyncOnSave,
            dispatch,
            edittingcode,
            ensureBrandHinbanValuesOnSave,
            ensureOppiHinbanAssigned,
            ensureSubBrandValuesOnSave,
            entrydataRef,
            fileRef,
            fnc,
            formid,
            formstatus,
            gridlist,
            hasResolvedOppiCode,
            imageRef,
            isEmpty,
            isEnabled,
            mergeKakousijiSaveEntries,
            normalizeKakousijiSampleDetailForStoreByType,
            prepareSsdqRowsForSaveEntries,
            primarykey,
            setedittingcode,
            storeRowData
        };
    }
    // 加工指示の追加ダイアログ状態と、選択エントリの読込/サンプル表示連携をまとめる。
    function buildKakousijiAddDialogServiceDeps() {
        return {
            DeepCopy,
            DicVal,
            GridData,
            KAKOUSIJI_SAMPLE_COMMENT_FIELD_ID,
            KAKOUSIJI_SAMPLE_DETAIL_FIELD_IDS,
            KAKOUSIJI_SAMPLE_GROUP_DISPLAY_PANEL_TYPES,
            activeKakousijiKeyRef,
            activeKakousijiSampleGroupEntryKey,
            appendKakousijiDraft,
            applyActiveKakousijiSelectionData,
            applyBrandHinbanNumberingLockToFields,
            applyKakousijiSection139Detail,
            buildKakousijiSampleGroupSummaryItem,
            buildKakousijiSection139SaveRow,
            clearActiveKakousijiSelectionData,
            columninfo,
            filterBaseFields,
            fnc,
            getKakousijiEntryCache,
            getKakousijiEntryCacheForSummaryItem,
            getKakousijiKubunOptions,
            gridlist,
            isEmpty,
            isKakousijiSampleGroupSummaryItem,
            kakousijiAddDialogState,
            kakousijiAmountRoundingRef,
            kakousijiLoadRequestSeqRef,
            kakousijiLoadingRef,
            kakousijiSampleFieldSource,
            kakousijiSampleGroupEntryKeys,
            lastLoadedKakousijiCodeRef,
            normalizeKakousijiSampleDetailForStoreByType,
            panel,
            reserveKakousijiSequence,
            resolveCurrentOppiCode,
            resolveInitialProductionKakousijiItem,
            setKakousijiAddDialogState,
            setKakousijiEntryCache,
            setKakousijiSummaryList,
            snapshotActiveKakousijiSelectionData,
            uniqueFieldsByColumnId
        };
    }
    // パネルの表示可否・並び順・サンプルグループ表示パネルの生成をまとめる。
    function buildPanelVisibilityServiceDeps() {
        return {
            DeepCopy,
            DicVal,
            G_id,
            GridData,
            hinbanFixEnabled,
            KAKOUSIJI_ANCHOR_PANEL_TYPE,
            KAKOUSIJI_HEADER_PANEL_TYPE,
            KAKOUSIJI_SAMPLE_GROUP_DISPLAY_PANEL_TYPES,
            KAKOUSIJI_SIJISU_TOTAL_PANEL_TYPE,
            SetGridData,
            activeKakousijiSummaryItem,
            columns,
            entrylock,
            fileRef,
            formstatus,
            getKakousijiEntryCache,
            imageRef,
            isEmpty,
            isKakousijiHeaderPanel,
            isKakousijiModeAnchorPanel,
            isKakousijiPanel,
            isKakousijiPanelType,
            isKakousijiSampleGroupSummaryItem,
            isKakousijiSamplePanel,
            kakouType,
            kakousijiPanelDisplayOrderValue,
            kakousijiSampleGroupEntryKeys,
            normalizeKakousijiDetailForHinbanPanels,
            panel,
            resolveKakousijiPanelView,
            setIsDragActive,
            tabletype,
            textfields,
            windowDimensions
        };
    }
    // パネル種別ごとの本体描画(BASE/グリッド/画像/ファイル/備考/洗濯表示)をまとめる。
    function buildSectionContentRendererDeps() {
        return {
            DicVal,
            G_id,
            GridData,
            KAKOUSIJI_ANCHOR_PANEL_TYPE,
            KAKOUSIJI_SIJISU_TOTAL_PANEL_TYPE,
            ListRowValueChanged,
            ListValueChanged,
            ValueChanged,
            applyBrandHinbanNumberingLockToFields,
            applyHinbanInputControlToFields,
            applyKakousijiCurrencyInputLockColDef,
            buildBaseSearchField,
            buildHinbanWashSaveRows,
            buildKakousijiDemandColumns,
            buildKakousijiGroupFilterVersion,
            buildKakousijiQualityScopeFilterVersion,
            isKakousijiQualityScopeDisplayPanel,
            isKakousijiQualityScopeRowVisible,
            buildKakousijiSijisuTotalRows,
            buildPdtcSizeSelectionColumns,
            buildWashGridFunctionRef,
            columninfo,
            columns,
            controller,
            doesKakousijiGroupSelectionMatchRow,
            edittingcode,
            ensureGridColRef,
            ensureGridDataRef,
            ensureKakousijiSampleInfoRows,
            ensureTotalColRef,
            ensureTotalDataRef,
            entryInitialFocusRef,
            entrydataRef,
            fileRef,
            filterBaseFields,
            filterDetailHeaderGridColumns,
            findKakousijiEntryValue,
            fnc,
            formid,
            gallery,
            getKakousijiDemandRowStyle,
            getKakousijiGridRowsByType,
            handleKakousijiSampleDisplayBaseValueChanged,
            handleKakousijiSampleInfoValueChanged,
            imageRef,
            isEmpty,
            isHinbanGenkaPanel,
            isHinbanWashPanel,
            isKakousijiDemandNouhinPanel,
            isKakousijiDemandPanel,
            isKakousijiGroupManagedPanelType,
            isKakousijiPanel,
            isKakousijiSampleInfoPanel,
            isKakousijiSijisuPanel,
            isKakousijiSoseiPanel,
            isSection220EmptyGrid,
            kakousijiSampleDisplayEntryDataRef,
            kakousijiSampleUpperFields,
            kakousijiSijisuTotalPanel,
            layoutlock,
            onFirstDataRendered,
            onFirstTotalDataRendered,
            readKakousijiRowValueIgnoreCase,
            renderHinbanGenkaSection,
            renderKakousijiNouhinDateBand,
            renderKakousijiSampleLowerSection,
            rerender,
            sectionHeaderData,
            sectionHeaderFields,
            settextfields,
            shouldUseKakousijiDraftNewFormMode,
            sourcePanelForDisplayPanel,
            storeRowData,
            textfields,
            updateSectionHeaderValue
        };
    }
    // 画面上部の品番見出し帯の描画。
    function buildHinbanHeadlineRendererDeps() {
        return {
            DicVal,
            formatHinbanHeadlineValue,
            headlineColumnInfo,
            headlineEntryData,
            isEmpty
        };
    }
    function renderKakousijiSijisuTotalGrid(panelInfo) {
        return createSectionContentRenderer(buildSectionContentRendererDeps()).renderKakousijiSijisuTotalGrid(panelInfo);
    }
    function isKakousijiSampleInfoType(type) {
        return createKakousijiSampleInfoService(buildKakousijiSampleInfoServiceDeps()).isKakousijiSampleInfoType(type);
    }
    function isKakousijiSampleInfoPanel(panelInfo) {
        return createKakousijiSampleInfoService(buildKakousijiSampleInfoServiceDeps()).isKakousijiSampleInfoPanel(panelInfo);
    }
    function kakousijiSampleKbnInitialValue(type) {
        return createKakousijiSampleInfoService(buildKakousijiSampleInfoServiceDeps()).kakousijiSampleKbnInitialValue(type);
    }
    function kakousijiSampleParentFieldIds() {
        return createKakousijiSampleInfoService(buildKakousijiSampleInfoServiceDeps()).kakousijiSampleParentFieldIds();
    }
    function isKakousijiSampleNestedRow(row) {
        return createKakousijiSampleInfoService(buildKakousijiSampleInfoServiceDeps()).isKakousijiSampleNestedRow(row);
    }
    function resolveKakousijiSampleSsdNo(source) {
        return createKakousijiSampleInfoService(buildKakousijiSampleInfoServiceDeps()).resolveKakousijiSampleSsdNo(source);
    }
    function resolveKakousijiSamplePanelSsdNo(panelInfo, row) {
        return createKakousijiSampleInfoService(buildKakousijiSampleInfoServiceDeps()).resolveKakousijiSamplePanelSsdNo(panelInfo, row);
    }
    function applyKakousijiSampleParentSsdNo(row, ssdNo) {
        return createKakousijiSampleInfoService(buildKakousijiSampleInfoServiceDeps()).applyKakousijiSampleParentSsdNo(row, ssdNo);
    }
    function pickKakousijiSampleParentValues(row, type) {
        return createKakousijiSampleInfoService(buildKakousijiSampleInfoServiceDeps()).pickKakousijiSampleParentValues(row, type);
    }
    function pickKakousijiSampleDetailValues(row) {
        return createKakousijiSampleInfoService(buildKakousijiSampleInfoServiceDeps()).pickKakousijiSampleDetailValues(row);
    }
    function hasKakousijiSampleDetailValues(row) {
        return createKakousijiSampleInfoService(buildKakousijiSampleInfoServiceDeps()).hasKakousijiSampleDetailValues(row);
    }
    function normalizeKakousijiSampleDetailRowsForDisplay(type, rows) {
        return createKakousijiSampleInfoService(buildKakousijiSampleInfoServiceDeps()).normalizeKakousijiSampleDetailRowsForDisplay(type, rows);
    }
    function buildKakousijiSampleNestedRows(type, rows) {
        return createKakousijiSampleInfoService(buildKakousijiSampleInfoServiceDeps()).buildKakousijiSampleNestedRows(type, rows);
    }
    function normalizeKakousijiSampleDetailForDisplayByType(type, rows) {
        return createKakousijiSampleInfoService(buildKakousijiSampleInfoServiceDeps()).normalizeKakousijiSampleDetailForDisplayByType(type, rows);
    }
    function normalizeKakousijiSampleDetailForStoreByType(type, rows) {
        return createKakousijiSampleInfoService(buildKakousijiSampleInfoServiceDeps()).normalizeKakousijiSampleDetailForStoreByType(type, rows);
    }
    function registerKakousijiSampleRenderedPanel(panelInfo) {
        return createKakousijiSampleInfoService(buildKakousijiSampleInfoServiceDeps()).registerKakousijiSampleRenderedPanel(panelInfo);
    }
    function uniqueKakousijiSamplePanels(items) {
        return createKakousijiSampleInfoService(buildKakousijiSampleInfoServiceDeps()).uniqueKakousijiSamplePanels(items);
    }
    function kakousijiSampleSyncPanels() {
        return createKakousijiSampleInfoService(buildKakousijiSampleInfoServiceDeps()).kakousijiSampleSyncPanels();
    }
    function uniqueFieldsByColumnId(fields) {
        return createKakousijiSampleInfoService(buildKakousijiSampleInfoServiceDeps()).uniqueFieldsByColumnId(fields);
    }
    function kakousijiSampleFieldSource(panelInfo) {
        return createKakousijiSampleInfoService(buildKakousijiSampleInfoServiceDeps()).kakousijiSampleFieldSource(panelInfo);
    }
    function findKakousijiSampleField(panelInfo, columnid) {
        return createKakousijiSampleInfoService(buildKakousijiSampleInfoServiceDeps()).findKakousijiSampleField(panelInfo, columnid);
    }
    function kakousijiSampleHeaderFields(panelInfo) {
        return createKakousijiSampleInfoService(buildKakousijiSampleInfoServiceDeps()).kakousijiSampleHeaderFields(panelInfo);
    }
    function kakousijiSampleDetailColumnInfo(fields, panelInfo = null) {
        return createKakousijiSampleInfoService(buildKakousijiSampleInfoServiceDeps()).kakousijiSampleDetailColumnInfo(fields, panelInfo);
    }
    function ensureKakousijiSampleInfoRows(panelInfo) {
        return createKakousijiSampleInfoService(buildKakousijiSampleInfoServiceDeps()).ensureKakousijiSampleInfoRows(panelInfo);
    }
    function syncKakousijiSampleHeaderValue(panelInfo, columnid, value) {
        return createKakousijiSampleInfoService(buildKakousijiSampleInfoServiceDeps()).syncKakousijiSampleHeaderValue(panelInfo, columnid, value);
    }
    function handleKakousijiSampleInfoValueChanged(panelInfo, id, value, edit, options) {
        return createKakousijiSampleInfoService(buildKakousijiSampleInfoServiceDeps()).handleKakousijiSampleInfoValueChanged(panelInfo, id, value, edit, options);
    }
    function kakousijiSampleSuryoTotal(rows) {
        return createKakousijiSampleInfoService(buildKakousijiSampleInfoServiceDeps()).kakousijiSampleSuryoTotal(rows);
    }
    function kakousijiSampleFieldLabel(field) {
        return createKakousijiSampleInfoService(buildKakousijiSampleInfoServiceDeps()).kakousijiSampleFieldLabel(field);
    }
    // 品番原価セクション(ヘッダ帯・明細グリッド・サマリ表)の描画をまとめる。
    function buildGenkaRendererDeps() {
        return {
            DicVal,
            ListRowValueChanged,
            ListValueChanged,
            buildHinbanGenkaFixedColumns,
            buildHinbanGenkaSaveRows,
            buildHinbanGenkaSummaryRows,
            buildWashGridFunctionRef,
            columninfo,
            columns,
            deriveGenkaPatternFromEntry,
            ensureGridColRef,
            ensureGridDataRef,
            ensureHinbanGenkaGridDataRef,
            entrydataRef,
            findGenkaCurrencyLayoutMeta,
            fixedHinbanGenkaDisplayRows,
            fnc,
            formid,
            genkaCurrency,
            genkaCurrencyDisplayLabel,
            genkaCurrencyOptions,
            genkaPattern,
            genkaPatternLabelByNo,
            handleHinbanGenkaCurrencyChanged,
            isEmpty,
            isGenkaCurrencyEditableByLayout,
            onFirstDataRendered,
            resolveGenkaCurrencyFromEntry,
            shouldForceGenkaCurrencyJpy
        };
    }
    // 加工指示サンプル情報セクション(入力欄・ヘッダ・コメント・明細)の描画をまとめる。
    function buildSampleSectionRendererDeps() {
        return {
            DicVal,
            GridData,
            HinbanEntryInput,
            KAKOUSIJI_SAMPLE_COMMENT_FIELD_ID,
            ListRowValueChanged,
            ListValueChanged,
            buildBaseSearchField,
            buildWashGridFunctionRef,
            columninfo,
            columns,
            ensureGridColRef,
            ensureGridDataRef,
            ensureKakousijiSampleGridColRef,
            ensureKakousijiSampleInfoRows,
            entrydataRef,
            entrylock,
            findKakousijiSampleField,
            fnc,
            formid,
            handleKakousijiSampleInfoValueChanged,
            isEmpty,
            kakousijiSampleDetailColumnInfo,
            kakousijiSampleFieldLabel,
            kakousijiSampleFieldSource,
            kakousijiSampleHeaderFields,
            kakousijiSampleSuryoTotal,
            layoutlock,
            onFirstDataRendered,
            registerKakousijiSampleRenderedPanel,
            sectionBodyLocked,
            shouldUseKakousijiDraftNewFormMode,
            syncKakousijiSampleDetailRowsFromPdtc,
            syncKakousijiSampleHeaderValue,
            updateKakousijiSampleComment
        };
    }
    // サステナブルマークの画像プレビューパネルの描画をまとめる。
    function buildSustainablePreviewRendererDeps() {
        return {
            commitSustainableImageFileName,
            entrydataRef,
            entrylock,
            handleSustainableImageFileNameKeyDown,
            layoutlock,
            noimage,
            readSustainableImageFileName,
            sectionBodyLocked,
            setSustainableImageFileInputValue,
            startSustainableImageFileNameEdit,
            sustainableImageFileEditing,
            sustainableImageFileInputValue,
            sustainableServerImageUrl
        };
    }
    function renderKakousijiSampleInput(panelInfo, field, dataRef, sectionLock) {
        return createSampleSectionRenderer(buildSampleSectionRendererDeps()).renderKakousijiSampleInput(panelInfo, field, dataRef, sectionLock);
    }
    function renderKakousijiSampleHeaderCell(panelInfo, field, dataRef, sectionLock) {
        return createSampleSectionRenderer(buildSampleSectionRendererDeps()).renderKakousijiSampleHeaderCell(panelInfo, field, dataRef, sectionLock);
    }
    function renderKakousijiSampleComment(panelInfo, commentField, headerDataRef, locked) {
        return createSampleSectionRenderer(buildSampleSectionRendererDeps()).renderKakousijiSampleComment(panelInfo, commentField, headerDataRef, locked);
    }
    function buildKakousijiSampleDetailKey(colorCode, sizeCode) {
        return createKakousijiSampleInfoService(buildKakousijiSampleInfoServiceDeps()).buildKakousijiSampleDetailKey(colorCode, sizeCode);
    }
    function uniqueKakousijiSampleCodeRows(rows, columnid, orderColumnid) {
        return createKakousijiSampleInfoService(buildKakousijiSampleInfoServiceDeps()).uniqueKakousijiSampleCodeRows(rows, columnid, orderColumnid);
    }
    function hasPdtcRowsForSampleCombination(rows, type) {
        return createKakousijiSampleInfoService(buildKakousijiSampleInfoServiceDeps()).hasPdtcRowsForSampleCombination(rows, type);
    }
    function pdtcRowsForSampleCombination(type) {
        return createKakousijiSampleInfoService(buildKakousijiSampleInfoServiceDeps()).pdtcRowsForSampleCombination(type);
    }
    function kakousijiSampleCombinationSourceRows() {
        return createKakousijiSampleInfoService(buildKakousijiSampleInfoServiceDeps()).kakousijiSampleCombinationSourceRows();
    }
    function hasKakousijiSampleCombinationSourceRows(sourceRows) {
        return createKakousijiSampleInfoService(buildKakousijiSampleInfoServiceDeps()).hasKakousijiSampleCombinationSourceRows(sourceRows);
    }
    function buildKakousijiSampleCombinationRows(panelInfo, sourceRows = null) {
        return createKakousijiSampleInfoService(buildKakousijiSampleInfoServiceDeps()).buildKakousijiSampleCombinationRows(panelInfo, sourceRows);
    }
    function sameKakousijiSampleDetailRows(leftRows, rightRows) {
        return createKakousijiSampleInfoService(buildKakousijiSampleInfoServiceDeps()).sameKakousijiSampleDetailRows(leftRows, rightRows);
    }
    function scheduleKakousijiSampleSyncRetry(panelInfo, remaining = 25) {
        return createKakousijiSampleInfoService(buildKakousijiSampleInfoServiceDeps()).scheduleKakousijiSampleSyncRetry(panelInfo, remaining);
    }
    function syncKakousijiSampleDetailRowsFromPdtc(panelInfo, refreshGrid = true, retryRemaining = 0) {
        return createKakousijiSampleInfoService(buildKakousijiSampleInfoServiceDeps()).syncKakousijiSampleDetailRowsFromPdtc(panelInfo, refreshGrid, retryRemaining);
    }
    function syncKakousijiSamplePanelsFromPdtc(retryRemaining = 25) {
        return createKakousijiSampleInfoService(buildKakousijiSampleInfoServiceDeps()).syncKakousijiSamplePanelsFromPdtc(retryRemaining);
    }
    function updateKakousijiSampleComment(panelInfo, value) {
        return createKakousijiSampleInfoService(buildKakousijiSampleInfoServiceDeps()).updateKakousijiSampleComment(panelInfo, value);
    }
    function renderKakousijiSampleLowerSection(panelInfo) {
        return createSampleSectionRenderer(buildSampleSectionRendererDeps()).renderKakousijiSampleLowerSection(panelInfo);
    }
    function renderKakousijiSampleInfoSection(panelInfo, filteredColumnInfo, filteredColumns) {
        return createSampleSectionRenderer(buildSampleSectionRendererDeps()).renderKakousijiSampleInfoSection(panelInfo, filteredColumnInfo, filteredColumns);
    }
    function renderKakousijiSijisuSection(panelInfo, filteredColumnInfo, filteredColumns) {
        return createSectionContentRenderer(buildSectionContentRendererDeps()).renderKakousijiSijisuSection(panelInfo, filteredColumnInfo, filteredColumns);
    }
    function isDetailHeaderPanel(panel) {
        return String(DicVal(panel, "id", "")) === DETAIL_HEADER_PANEL.id && String(DicVal(panel, "type", "")) === DETAIL_HEADER_PANEL.type;
    }
    function isSustainableDesignPanel(panelInfo) {
        if (isEmpty(panelInfo)) return false;
        const panelType = String(DicVal(panelInfo, "type", "")).trim();
        const panelName = String(DicVal(panelInfo, "name", "")).trim();
        return panelType === "135" || panelName.indexOf("サステナブル") !== -1;
    }
    function isSustainableImageField(field) {
        if (isEmpty(field)) return false;
        const columnId = String(DicVal(field, "columnid", "")).trim().toUpperCase();
        const columnName = String(DicVal(field, "columnnm", "")).trim();
        return columnId.indexOf("SASEGATAFILEMEI") !== -1 || columnName.indexOf("絵型") !== -1;
    }
    function isKakousijiFukushizaiBaseHiddenField(field) {
        if (isEmpty(field)) return false;
        const columnId = String(DicVal(field, "columnid", "")).trim().toUpperCase();
        const columnName = String(DicVal(field, "columnnm", "")).replace(/[\s　]/g, "");
        return KAKOUSIJI_FUKUSHIZAI_BASE_HIDDEN_COLUMN_IDS.includes(columnId)
            || columnName === "#アイテム"
            || columnName === "#カラー"
            || columnName === "#グループ";
    }
    function filterKakousijiFukushizaiBaseFields(fields, panelInfo) {
        if (!isKakousijiFukushizaiBasePanel(panelInfo) || isEmpty(fields)) return fields;
        return fields.filter((field) => !isKakousijiFukushizaiBaseHiddenField(field));
    }
    function filterBaseFields(fields, panelInfo) {
        let filteredFields = fields;
        filteredFields = filterSustainableBaseFields(filteredFields, panelInfo);
        filteredFields = filterKakousijiFukushizaiBaseFields(filteredFields, panelInfo);
        return filteredFields;
    }
    function filterSustainableBaseFields(fields, panelInfo) {
        if (!isSustainableDesignPanel(panelInfo) || isEmpty(fields)) return fields;
        return fields.filter((field) => !isSustainableImageField(field));
    }
    function readSustainableImageFileName(source) {
        return sustainableImageSvc.readSustainableImageFileName(source);
    }
    function isSafeSustainableImageFileNameInput(fileName) {
        return sustainableImageSvc.isSafeSustainableImageFileNameInput(fileName);
    }
    function warnInvalidSustainableImageFileName() {
        sustainableImageSvc.warnInvalidSustainableImageFileName();
    }
    function startSustainableImageFileNameEdit(panelInfo, event) {
        sustainableImageSvc.startSustainableImageFileNameEdit(event, panelInfo);
    }
    function commitSustainableImageFileName() {
        sustainableImageSvc.commitSustainableImageFileName();
    }
    function cancelSustainableImageFileNameEdit() {
        sustainableImageSvc.cancelSustainableImageFileNameEdit();
    }
    function handleSustainableImageFileNameKeyDown(event) {
        sustainableImageSvc.handleSustainableImageFileNameKeyDown(event);
    }
    function loadSustainableImageFromServer(source) {
        const seq = sustainableImageRequestSeqRef.current + 1;
        sustainableImageRequestSeqRef.current = seq;
        setSustainableServerImageUrl("");

        const fileName = readSustainableImageFileName(source || entrydataRef.current);
        if (fileName === "") return;
        if (isEmpty(fnc.current) || typeof fnc.current.postaxios !== "function") return;

        fnc.current.postaxios("kakousiji/GetSustainableImage", {
            corpkey,
            account,
            fileName
        }, {
            onSuccess: function (data) {
                if (sustainableImageRequestSeqRef.current !== seq) return;
                const imageUrl = normalizeKakousijiText(DicVal(DicVal(data, "data", {}), "imageUrl", ""));
                setSustainableServerImageUrl(imageUrl);
            },
            onError: function () {
                if (sustainableImageRequestSeqRef.current !== seq) return;
                setSustainableServerImageUrl("");
            }
        }, true);
    }
    function renderSustainablePreviewPanel(panelInfo) {
        return createSustainablePreviewRenderer(buildSustainablePreviewRendererDeps()).renderSustainablePreviewPanel(panelInfo);
    }
    // 加工指示のアイテム/グループ context の解決・突合・行生成をまとめる。
    function buildKakousijiGroupContextServiceDeps() {
        return {
            AGRef,
            DicVal,
            GridApi,
            GridData,
            KAKOUSIJI_FUKUSHIZAI_BASE_PANEL_TYPE,
            KAKOUSIJI_QUALITY_BASE_PANEL_TYPE,
            SetGridData,
            entrydataRef,
            extractKakousijiMasterName,
            fnc,
            gridlist,
            isEmpty,
            kakousijiGroupControlState,
            kakousijiGroupControlStateRef,
            kakousijiQualityGroupControlState,
            kakousijiQualityGroupControlStateRef,
            setKakousijiQualityGroupControlState,
            normalizeKakousijiGroupNo,
            normalizeKakousijiText,
            panel,
            pdtItemCodesPanel,
            readKakousijiItemGroupFromAnyRow,
            readKakousijiRowValueIgnoreCase,
            resolveItemMasterItemCode,
            resolveKakousijiColorOptionsForDialog,
            runAfterActiveInputCommit,
            setKakousijiGroupControlState,
            setKakousijiGroupDialogState
        };
    }
    // 加工指示明細の代表行を entrydata へ投影する処理をまとめる。
    function buildKakousijiRepresentativeProjectionServiceDeps() {
        return {
            DeepCopy,
            DicVal,
            GridApi,
            GridData,
            KAKOUSIJI_FUKUSHIZAI_BASE_PANEL_TYPE,
            KAKOUSIJI_FUKUSHIZAI_LIST_PANEL_TYPE,
            KAKOUSIJI_QUALITY_BASE_PANEL_TYPE,
            KAKOUSIJI_QUALITY_DISPLAY_PANEL_TYPE,
            SetGridData,
            columninfo,
            columns,
            createKakousijiGroupRow,
            dispatch,
            entrydata,
            entrydataRef,
            entryrerender,
            fnc,
            getKakousijiGridRowsByType,
            isEmpty,
            isKakousijiGroupManagedPanelType,
            nextKakousijiDetailRowId,
            normalizeKakousijiDemandRows,
            normalizeKakousijiGroupNo,
            normalizeKakousijiText,
            normalizeKakousijiUpperColumnId,
            rerender,
            resolveKakousijiActiveGroupSelection,
            resolveKakousijiGridPanelByType,
            resolveKakousijiGroupItemContext,
            rowMatchesKakousijiItemGroup,
            stopKakousijiGridEditing,
            syncKakousijiGridRowsFromApi
        };
    }
    // 加工指示明細の金額計算(ロス率・通貨・丸め規則)をまとめる。
    function buildKakousijiDetailCalcServiceDeps() {
        return {
            DicVal,
            KAKOUSIJI_CURRENCY_INPUT_LOCK_BY_TYPE,
            KAKOUSIJI_DETAIL_CALC_CONFIG_BY_TYPE,
            KAKOUSIJI_DOMESTIC_CURRENCY_CODE,
            KAKOUSIJI_FUKUSHIZAI_LIST_PANEL_TYPE,
            KAKOUSIJI_FUZOKU_MEISAI_PANEL_TYPE,
            KAKOUSIJI_SOZAI_MEISAI_PANEL_TYPE,
            columninfo,
            columns,
            entrydataRef,
            isEmpty,
            kakousijiAmountRoundingRef,
            normalizeKakousijiText,
            normalizeKakousijiUpperColumnId
        };
    }
    // 使用副資材一覧の行組み立てと一括反映・各種アクションをまとめる。
    function buildKakousijiFukushizaiListServiceDeps() {
        return {
            DeepCopy,
            DicVal,
            KAKOUSIJI_DETAIL_COPY_MODE,
            KAKOUSIJI_FUKUSHIZAI_LIST_FIELD_RULES,
            KAKOUSIJI_FUKUSHIZAI_LIST_PANEL_TYPE,
            KAKOUSIJI_FUZOKU_MEISAI_PANEL_TYPE,
            KAKOUSIJI_QUALITY_DISPLAY_PANEL_TYPE,
            KAKOUSIJI_SOZAI_MEISAI_PANEL_TYPE,
            KAKOUSIJI_UI_ACTION,
            buildKakousijiKnownColumnIds,
            columninfo,
            columns,
            entrydataRef,
            extractKakousijiMasterCode,
            extractKakousijiMasterName,
            flushKakousijiListReflectSourcePanels,
            fnc,
            getKakousijiGridRowsByType,
            isEmpty,
            isKakousijiEmptyGridRow,
            kakousijiBulkInputMap,
            normalizeKakousijiGroupNo,
            normalizeKakousijiText,
            normalizeKakousijiUpperColumnId,
            openTemporaryOrderTab,
            readKakousijiRowValueIgnoreCase,
            recalcKakousijiFukushizaiListCalcRow,
            resolveKakousijiGridPanelByType,
            resolveKakousijiSourceFieldName,
            runHinbanSoseiCalc,
            setKakousijiGridRows,
            syncKakousijiGridRowsFromApi
        };
    }
    // 加工指示グループ操作ダイアログの状態遷移と追加/編集/削除/複写の適用をまとめる。
    function buildKakousijiGroupDialogServiceDeps() {
        return {
            DeepCopy,
            DicVal,
            KAKOUSIJI_FUKUSHIZAI_BASE_PANEL_TYPE,
            KAKOUSIJI_QUALITY_BASE_PANEL_TYPE,
            createKakousijiGroupRow,
            fnc,
            getKakousijiGridRowsByType,
            getKnownKakousijiGroupNos,
            initialPdtcDetail220Ref,
            isEmpty,
            kakousijiGroupDialogState,
            nextKakousijiDetailRowId,
            normalizeKakousijiGroupNo,
            normalizeKakousijiText,
            readKakousijiRowValueIgnoreCase,
            resolveDetailRowValue,
            resolveKakousijiGridPanelByType,
            resolveKakousijiGroupItemContext,
            resolveKakousijiSourceFieldName,
            setKakousijiGridRows,
            setKakousijiGroupControlState,
            setKakousijiQualityGroupControlState,
            setKakousijiGroupDialogState,
            syncKakousijiGridRowsFromApi
        };
    }
    // 依頼/取消・帳票出力・メニュー操作・品番確定などの画面アクションをまとめる。
    function buildHinbanActionServiceDeps() {
        return {
            AGRef,
            Delete,
            DicVal,
            EntrybodyRef,
            FIXED_HINBAN_NUMBERING_COLUMNID,
            G_id,
            GridApi,
            HINBAN_NUMBERING_FAILED_MESSAGE,
            LayoutSaveStorage,
            LoadData,
            Save,
            activeKakousijiSummaryItem,
            assignEntryDataCurrent,
            baseref,
            buildCurrentHinbanSavePayload,
            cfFileUpload,
            clearform,
            columninfo,
            confirmPdtcSkuNameSyncOnSave,
            controller,
            dispatch,
            ensureBrandHinbanValuesOnSave,
            ensureOppiHinbanAssigned,
            ensureSubBrandValuesOnSave,
            entrydata,
            entrydataRef,
            entrylock,
            fnc,
            hinbanFixEnabled,
            isEmpty,
            isEnabled,
            navmenu,
            panel,
            primarykeys,
            resolveCurrentOppiCode,
            runAfterActiveInputCommit,
            setHinbanFixEnabled,
            tabletype,
            textfields
        };
    }
    // セクション単位の編集開始/解除と、編集ボタンの表示条件をまとめる。
    function buildSectionEditStateServiceDeps() {
        return {
            DicVal,
            EDIT_UPDATE_TRACKING_PANEL_TYPES,
            G_id,
            KAKOUSIJI_ANCHOR_PANEL_TYPE,
            KAKOUSIJI_EDIT_BUTTON_PANEL_TYPES,
            KAKOUSIJI_NONZERO_EDIT_BUTTON_PANEL_TYPES,
            KAKOUSIJI_ZERO_EDIT_BUTTON_PANEL_TYPES,
            activeKakousijiSummaryItem,
            editableSectionsRef,
            entryFormStartedAtRef,
            entrydataRef,
            fnc,
            formstatus,
            isEmpty,
            isEnabled,
            isKakousijiPanel,
            kakousijiSectionEditStartedRef,
            normalizeKakousijiKubunValue,
            orderedPanels,
            resolveCurrentOppiCode,
            restoreScrollPos,
            saveScrollPos,
            sectionButtonRefs,
            sectionEditStartProcessingRef,
            sectionFieldsetRefs,
            sectionHeaderFieldsetRefs,
            sectionOverlayRefs,
            sectionOverwriteConfirmState,
            setSectionEditInfo,
            setSectionEditRenderVersion,
            setSectionOverwriteConfirmState
        };
    }
    // 明細セクションのヘッダ項目(セクション見出し行)の値保持と更新をまとめる。
    function buildSectionHeaderServiceDeps() {
        return {
            AGRef,
            DETAIL_HEADER_FIELD_IDS,
            DETAIL_HEADER_PANEL,
            DicVal,
            GridApi,
            GridColApi,
            GridData,
            PDT_SIZE_PATTERN_FIELD_IDS,
            SetGridData,
            columninfo,
            columns,
            entrydataRef,
            firstNonEmptyValue,
            isDetailHeaderPanel,
            isEmpty,
            isPdtSizePatternFieldId
        };
    }
    // サイズパターン/展開コードの選択肢取得とサイズ明細への反映をまとめる。
    function buildPdtSizePatternServiceDeps() {
        return {
            AGRef,
            BRAND_HINBAN_COLUMNID,
            BRAND_HINBAN_SERIAL_SELECT_MODE,
            CELLTYPE,
            DETAIL_HEADER_PANEL,
            DicVal,
            GridApi,
            GridColApi,
            GridData,
            KAKOUSIJI_QUALITY_DISPLAY_PANEL_TYPE,
            KAKOUSIJI_SOSEI_CALC_PANEL_TYPE,
            PDTC_SIZE_PATTERN_REQUIRED_MESSAGE,
            PDTC_SIZE_SELECTED_FIELD,
            PDT_ITEM_DETAIL_PANEL,
            PDT_SIZE_PATTERN_FIELD_IDS,
            SUB_BRAND_COLUMNID,
            SetGridData,
            assignEntryDataCurrent,
            columninfo,
            columns,
            createBrandHinbanSerialSearchField,
            dispatch,
            entrydata,
            entrydataRef,
            entryrerender,
            extractKakousijiMasterCode,
            firstNonEmptyValue,
            fnc,
            formstatus,
            getEntryDataValue,
            getHinbanSoseiPanelColumnInfo,
            gridlist,
            initialPdtcDetail220Ref,
            isEmpty,
            isPdtcSizeRowSelected,
            loadItemMasterInfo,
            loadQrcMinHachuTani,
            loadQrcPackIrisu,
            matchesColumnId,
            normalizeKakousijiText,
            normalizeSoseiColumnId,
            pdtSizePatternOptionsRef,
            pdtSizePatternOptionsRequestSeqRef,
            pdtTenkaiCodeChangedAfterLoadRef,
            pdtcDetailPanel,
            pdtcSizeCodesFromSkuRows,
            pdtcSizeOptionsRef,
            pdtcSizePatternRequestSeqRef,
            protectHbSeasonCommit,
            readKakousijiRowValueIgnoreCase,
            rerender,
            resolveBrandGroupBrandCode,
            resolveBrandHinbanPrefix,
            sectionHeaderData,
            setEntryDataValue,
            setEntryGridRows,
            setSubBrandFieldOptions,
            setcolumninfo,
            setcolumns,
            settextfields,
            settextfieldsall,
            textfields,
            textfieldsall,
            updateSectionHeaderSizePatternValue,
            updateSectionHeaderValue
        };
    }
    function isDetailHeaderField(columnid) {
        return createSectionHeaderService(buildSectionHeaderServiceDeps()).isDetailHeaderField(columnid);
    }
    function filterDetailHeaderGridColumns(fields, panel) {
        return createSectionHeaderService(buildSectionHeaderServiceDeps()).filterDetailHeaderGridColumns(fields, panel);
    }
    function filterDetailHeaderGridColDef(panel, coldef) {
        return createSectionHeaderService(buildSectionHeaderServiceDeps()).filterDetailHeaderGridColDef(panel, coldef);
    }
    function sectionHeaderFields(panel) {
        return createSectionHeaderService(buildSectionHeaderServiceDeps()).sectionHeaderFields(panel);
    }
    function sectionHeaderEntryFallbackValue(columnid) {
        return createSectionHeaderService(buildSectionHeaderServiceDeps()).sectionHeaderEntryFallbackValue(columnid);
    }
    function mergeSectionHeaderEntryFallback(data) {
        return createSectionHeaderService(buildSectionHeaderServiceDeps()).mergeSectionHeaderEntryFallback(data);
    }
    function sectionHeaderData(panel) {
        return createSectionHeaderService(buildSectionHeaderServiceDeps()).sectionHeaderData(panel);
    }
    function createSectionHeaderRow(panel, initialValues = {}) {
        return createSectionHeaderService(buildSectionHeaderServiceDeps()).createSectionHeaderRow(panel, initialValues);
    }
    function updateSectionHeaderValue(panel, columnid, value) {
        return createSectionHeaderService(buildSectionHeaderServiceDeps()).updateSectionHeaderValue(panel, columnid, value);
    }
    function updateSectionHeaderSizePatternValue(value) {
        return createSectionHeaderService(buildSectionHeaderServiceDeps()).updateSectionHeaderSizePatternValue(value);
    }
    function renderDetailSectionHeaderInline(panelInfo, sectionLock) {
        return createSectionContentRenderer(buildSectionContentRendererDeps()).renderDetailSectionHeaderInline(panelInfo, sectionLock);
    }
    function isFixedHinbanNumberingTarget(field) {
        return createFieldNormalizeService(buildFieldNormalizeServiceDeps()).isFixedHinbanNumberingTarget(field);
    }
    function normalizePdtSynFlg1Field(field) {
        return createFieldNormalizeService(buildFieldNormalizeServiceDeps()).normalizePdtSynFlg1Field(field);
    }
    function normalizePdtSynFlg1_2Field(field) {
        return createFieldNormalizeService(buildFieldNormalizeServiceDeps()).normalizePdtSynFlg1_2Field(field);
    }
    function normalizePdtSynOnOffFlgField(field) {
        return createFieldNormalizeService(buildFieldNormalizeServiceDeps()).normalizePdtSynOnOffFlgField(field);
    }
    function normalizePdtTenkaiCodeOptions(options) {
        return createFieldNormalizeService(buildFieldNormalizeServiceDeps()).normalizePdtTenkaiCodeOptions(options);
    }
    function normalizeDisplayField(field) {
        return createFieldNormalizeService(buildFieldNormalizeServiceDeps()).normalizeDisplayField(field);
    }
    function removePdtItmcItemCdTriggerOnEntryForm(field) {
        return createFieldNormalizeService(buildFieldNormalizeServiceDeps()).removePdtItmcItemCdTriggerOnEntryForm(field);
    }
    function normalizeField(field) {
        return createFieldNormalizeService(buildFieldNormalizeServiceDeps()).normalizeField(field);
    }
    function normalizeDisplayFields(fields) {
        return createFieldNormalizeService(buildFieldNormalizeServiceDeps()).normalizeDisplayFields(fields);
    }
    function resolveHinbanInputControlData() {
        return createFieldNormalizeService(buildFieldNormalizeServiceDeps()).resolveHinbanInputControlData();
    }
    function isTruthyHinbanControlValue(value) {
        return createFieldNormalizeService(buildFieldNormalizeServiceDeps()).isTruthyHinbanControlValue(value);
    }
    function resolveHinbanInputControlStatus(data = resolveHinbanInputControlData()) {
        return createFieldNormalizeService(buildFieldNormalizeServiceDeps()).resolveHinbanInputControlStatus(data);
    }
    function shouldLockHinbanConditionalField(field, columnid, status, data) {
        return createFieldNormalizeService(buildFieldNormalizeServiceDeps()).shouldLockHinbanConditionalField(field, columnid, status, data);
    }
    function shouldLockHinbanInputControlField(field, columnid, status, data) {
        return createFieldNormalizeService(buildFieldNormalizeServiceDeps()).shouldLockHinbanInputControlField(field, columnid, status, data);
    }
    function applyHinbanManualInputLockToField(field) {
        return createFieldNormalizeService(buildFieldNormalizeServiceDeps()).applyHinbanManualInputLockToField(field);
    }
    function applyHinbanInputControlToFields(fields, data = resolveHinbanInputControlData()) {
        return createFieldNormalizeService(buildFieldNormalizeServiceDeps()).applyHinbanInputControlToFields(fields, data);
    }
    function createFixedHinbanNumberingField() {
        return createFieldNormalizeService(buildFieldNormalizeServiceDeps()).createFixedHinbanNumberingField();
    }
    function normalizeNumberText(value) {
        return createFieldNormalizeService(buildFieldNormalizeServiceDeps()).normalizeNumberText(value);
    }
    function matchesColumnId(columnid, target) {
        return createFieldNormalizeService(buildFieldNormalizeServiceDeps()).matchesColumnId(columnid, target);
    }
    function matchesColumnToken(columnid, target) {
        return createFieldNormalizeService(buildFieldNormalizeServiceDeps()).matchesColumnToken(columnid, target);
    }
    function resolveEntryDataKey(targetData, columnid) {
        return createFieldNormalizeService(buildFieldNormalizeServiceDeps()).resolveEntryDataKey(targetData, columnid);
    }
    function getEntryDataValue(targetData, columnid, defaultValue) {
        return createFieldNormalizeService(buildFieldNormalizeServiceDeps()).getEntryDataValue(targetData, columnid, defaultValue);
    }
    function setEntryDataValue(targetData, columnid, value) {
        return createFieldNormalizeService(buildFieldNormalizeServiceDeps()).setEntryDataValue(targetData, columnid, value);
    }
    function applyFixedHinbanNumberingValue(targetData, sourceData) {
        return createFieldNormalizeService(buildFieldNormalizeServiceDeps()).applyFixedHinbanNumberingValue(targetData, sourceData);
    }
    function setDetailRowValue(targetRow, columnid, value) {
        return createPdtcDetailService(buildPdtcDetailServiceDeps()).setDetailRowValue(targetRow, columnid, value);
    }
    function resolveDetailRowValue(row, columnid, defaultValue = "") {
        return createPdtcDetailService(buildPdtcDetailServiceDeps()).resolveDetailRowValue(row, columnid, defaultValue);
    }
    function pdtcDetailFieldsByType(type) {
        return createPdtcDetailService(buildPdtcDetailServiceDeps()).pdtcDetailFieldsByType(type);
    }
    function ensurePdtcDetailRowIds(type, rows) {
        return createPdtcDetailService(buildPdtcDetailServiceDeps()).ensurePdtcDetailRowIds(type, rows);
    }
    function isPdtcSizeRowSelected(row) {
        return createPdtcDetailService(buildPdtcDetailServiceDeps()).isPdtcSizeRowSelected(row);
    }
    function pdtcSizeCodesFromSkuRows(skuRows) {
        return createPdtcDetailService(buildPdtcDetailServiceDeps()).pdtcSizeCodesFromSkuRows(skuRows);
    }
    function hasPdtcSizeSelectionValue(row) {
        return createPdtcDetailService(buildPdtcDetailServiceDeps()).hasPdtcSizeSelectionValue(row);
    }
    function pdtcSizeSelectionValue(row, skuSelected) {
        return createPdtcDetailService(buildPdtcDetailServiceDeps()).pdtcSizeSelectionValue(row, skuSelected);
    }
    function ensurePdtcSizeSelectionDefaults(rows, skuRows = null) {
        return createPdtcDetailService(buildPdtcDetailServiceDeps()).ensurePdtcSizeSelectionDefaults(rows, skuRows);
    }
    function selectedPdtcSizeRows(rows) {
        return createPdtcDetailService(buildPdtcDetailServiceDeps()).selectedPdtcSizeRows(rows);
    }
    function canEditPdtcSizeSelectionRow(row) {
        return createPdtcDetailService(buildPdtcDetailServiceDeps()).canEditPdtcSizeSelectionRow(row);
    }
    function buildPdtcSizeSelectionColumns(colDef) {
        return createPdtcDetailService(buildPdtcDetailServiceDeps()).buildPdtcSizeSelectionColumns(colDef);
    }
    function createDerivedPdtcDetailRow(type) {
        return createPdtcDetailService(buildPdtcDetailServiceDeps()).createDerivedPdtcDetailRow(type);
    }
    function mergeDerivedPdtcDetailRow(targetRow, sourceRow, type) {
        return createPdtcDetailService(buildPdtcDetailServiceDeps()).mergeDerivedPdtcDetailRow(targetRow, sourceRow, type);
    }
    function comparePdtcDerivedDetailRows(left, right, orderColumn, keyColumn) {
        return createPdtcDetailService(buildPdtcDetailServiceDeps()).comparePdtcDerivedDetailRows(left, right, orderColumn, keyColumn);
    }
    function buildDerivedPdtcDetails(detailSource, targetType, keyColumn, orderColumn) {
        return createPdtcDetailService(buildPdtcDetailServiceDeps()).buildDerivedPdtcDetails(detailSource, targetType, keyColumn, orderColumn);
    }
    function buildPdtcSkuDetailKey(colorCode, sizeCode) {
        return createPdtcDetailService(buildPdtcDetailServiceDeps()).buildPdtcSkuDetailKey(colorCode, sizeCode);
    }
    function comparePdtcDetailOrderValue(left, right) {
        return createPdtcDetailService(buildPdtcDetailServiceDeps()).comparePdtcDetailOrderValue(left, right);
    }
    function buildCombinedPdtcSkuDetails(detailSource) {
        return createPdtcDetailService(buildPdtcDetailServiceDeps()).buildCombinedPdtcSkuDetails(detailSource);
    }
    function pdtcDetailPanel(type) {
        return createPdtcDetailService(buildPdtcDetailServiceDeps()).pdtcDetailPanel(type);
    }
    function captureInitialPdtName(data) {
        return createPdtcDetailService(buildPdtcDetailServiceDeps()).captureInitialPdtName(data);
    }
    function hasPdtNameChangedFromInitial(data) {
        return createPdtcDetailService(buildPdtcDetailServiceDeps()).hasPdtNameChangedFromInitial(data);
    }
    function applyPdtNameToPdtcSkuRows() {
        return createPdtcDetailService(buildPdtcDetailServiceDeps()).applyPdtNameToPdtcSkuRows();
    }
    function confirmPdtcSkuNameSyncOnSave(onContinue, skipConfirm) {
        return createPdtcDetailService(buildPdtcDetailServiceDeps()).confirmPdtcSkuNameSyncOnSave(onContinue, skipConfirm);
    }
    function closeSkuNameConfirmDialog() {
        return createPdtcDetailService(buildPdtcDetailServiceDeps()).closeSkuNameConfirmDialog();
    }
    function handleSkuNameConfirmYes() {
        return createPdtcDetailService(buildPdtcDetailServiceDeps()).handleSkuNameConfirmYes();
    }
    function handleSkuNameConfirmNo() {
        return createPdtcDetailService(buildPdtcDetailServiceDeps()).handleSkuNameConfirmNo();
    }
    function synchronizePdtcSkuDetails() {
        return createPdtcDetailService(buildPdtcDetailServiceDeps()).synchronizePdtcSkuDetails();
    }
    function normalizePdtcDetailSections(detailSource) {
        return createPdtcDetailService(buildPdtcDetailServiceDeps()).normalizePdtcDetailSections(detailSource);
    }
    function calculateCostRateValue(price, plannedCost) {
        return createDerivedFieldService(buildDerivedFieldServiceDeps()).calculateCostRateValue(price, plannedCost);
    }
    function createCostRateField() {
        return createDerivedFieldService(buildDerivedFieldServiceDeps()).createCostRateField();
    }
    function createSubBrandField() {
        return createDerivedFieldService(buildDerivedFieldServiceDeps()).createSubBrandField();
    }
    function normalizeSubBrandField(field) {
        return createDerivedFieldService(buildDerivedFieldServiceDeps()).normalizeSubBrandField(field);
    }
    function resolveSubBrandField(basefields) {
        return createDerivedFieldService(buildDerivedFieldServiceDeps()).resolveSubBrandField(basefields);
    }
    function insertSubBrandField(fields, subBrandField) {
        return createDerivedFieldService(buildDerivedFieldServiceDeps()).insertSubBrandField(fields, subBrandField);
    }
    function normalizeCostRateField(field) {
        return createDerivedFieldService(buildDerivedFieldServiceDeps()).normalizeCostRateField(field);
    }
    function resolveCostRateField(basefields) {
        return createDerivedFieldService(buildDerivedFieldServiceDeps()).resolveCostRateField(basefields);
    }
    function insertCostRateField(fields, costRateField) {
        return createDerivedFieldService(buildDerivedFieldServiceDeps()).insertCostRateField(fields, costRateField);
    }
    function applyCostRateToEntryData(data) {
        return createDerivedFieldService(buildDerivedFieldServiceDeps()).applyCostRateToEntryData(data);
    }
    function createBrandHinbanField() {
        return createDerivedFieldService(buildDerivedFieldServiceDeps()).createBrandHinbanField();
    }
    function normalizeBrandHinbanField(field) {
        return createDerivedFieldService(buildDerivedFieldServiceDeps()).normalizeBrandHinbanField(field);
    }
    function resolveBrandHinbanField(basefields) {
        return createDerivedFieldService(buildDerivedFieldServiceDeps()).resolveBrandHinbanField(basefields);
    }
    function insertBrandHinbanField(fields, brandHinbanField) {
        return createDerivedFieldService(buildDerivedFieldServiceDeps()).insertBrandHinbanField(fields, brandHinbanField);
    }
    function buildHinbanHeadlineColumnInfo(fields) {
        return createDerivedFieldService(buildDerivedFieldServiceDeps()).buildHinbanHeadlineColumnInfo(fields);
    }
    function formatHinbanHeadlineValue(field, sourceData) {
        return createDerivedFieldService(buildDerivedFieldServiceDeps()).formatHinbanHeadlineValue(field, sourceData);
    }
    function renderHinbanHeadline() {
        return createHinbanHeadlineRenderer(buildHinbanHeadlineRendererDeps()).renderHinbanHeadline();
    }
    function resolveBrandHinbanPrefix(targetData) {
        return createDerivedFieldService(buildDerivedFieldServiceDeps()).resolveBrandHinbanPrefix(targetData);
    }
    function normalizeBrandHinbanSerialValue(value) {
        return createDerivedFieldService(buildDerivedFieldServiceDeps()).normalizeBrandHinbanSerialValue(value);
    }
    function buildBrandHinbanCode(prefix, serialValue) {
        return createDerivedFieldService(buildDerivedFieldServiceDeps()).buildBrandHinbanCode(prefix, serialValue);
    }
    function createBrandHinbanSerialSearchField(field, selectMode) {
        return createDerivedFieldService(buildDerivedFieldServiceDeps()).createBrandHinbanSerialSearchField(field, selectMode);
    }
    function handleBrandHinbanSerialSelection(id, value, options) {
        return createDerivedFieldService(buildDerivedFieldServiceDeps()).handleBrandHinbanSerialSelection(id, value, options);
    }
    function hasBrandHinbanPrerequisites(targetData) {
        return createDerivedFieldService(buildDerivedFieldServiceDeps()).hasBrandHinbanPrerequisites(targetData);
    }
    function applyBrandHinbanCodeToEntryData(targetData, serialValue) {
        return createDerivedFieldService(buildDerivedFieldServiceDeps()).applyBrandHinbanCodeToEntryData(targetData, serialValue);
    }
    function normalizeFixedHinbanNumberingField(field) {
        return createDerivedFieldService(buildDerivedFieldServiceDeps()).normalizeFixedHinbanNumberingField(field);
    }
    function resolveFixedHinbanNumberingField(basefields) {
        return createDerivedFieldService(buildDerivedFieldServiceDeps()).resolveFixedHinbanNumberingField(basefields);
    }
    function insertFixedHinbanNumberingField(fields, fixedField) {
        return createDerivedFieldService(buildDerivedFieldServiceDeps()).insertFixedHinbanNumberingField(fields, fixedField);
    }
    function buildBaseFieldSet(colinfo, columns) {
        return createEntryDefaultsService(buildEntryDefaultsServiceDeps()).buildBaseFieldSet(colinfo, columns);
    }
    function baseFieldsForInit(fields) {
        return createEntryDefaultsService(buildEntryDefaultsServiceDeps()).baseFieldsForInit(fields);
    }
    function createBaseInitialData(fields) {
        return createEntryDefaultsService(buildEntryDefaultsServiceDeps()).createBaseInitialData(fields);
    }
    function applyKonpoGrpDefault(data) {
        return createEntryDefaultsService(buildEntryDefaultsServiceDeps()).applyKonpoGrpDefault(data);
    }
    function extractYearMonthFromControlDate(controlDate) {
        return createEntryDefaultsService(buildEntryDefaultsServiceDeps()).extractYearMonthFromControlDate(controlDate);
    }
    function resolvePdtYearFromControlDate(controlDate, season) {
        return createEntryDefaultsService(buildEntryDefaultsServiceDeps()).resolvePdtYearFromControlDate(controlDate, season);
    }
    function applyPdtYearFromControlDate(data, controlDate) {
        return createEntryDefaultsService(buildEntryDefaultsServiceDeps()).applyPdtYearFromControlDate(data, controlDate);
    }
    function syncPdtYear(controlDate) {
        return createEntryDefaultsService(buildEntryDefaultsServiceDeps()).syncPdtYear(controlDate);
    }
    function syncPdtBrandCodeAlias(targetData, explicitValue) {
        return createEntryDefaultsService(buildEntryDefaultsServiceDeps()).syncPdtBrandCodeAlias(targetData, explicitValue);
    }
    function applyClientOnlyEntryDefaults(data) {
        return createEntryDefaultsService(buildEntryDefaultsServiceDeps()).applyClientOnlyEntryDefaults(data);
    }
    function resolveRotRoundRule(flagValue) {
        return createEntryDefaultsService(buildEntryDefaultsServiceDeps()).resolveRotRoundRule(flagValue);
    }
    function applyRotRoundRuleToEntryData(targetData) {
        return createEntryDefaultsService(buildEntryDefaultsServiceDeps()).applyRotRoundRuleToEntryData(targetData);
    }
    function resolveZaikoHyokaKbnFromShohinKbn(shohinKbn) {
        return createEntryDefaultsService(buildEntryDefaultsServiceDeps()).resolveZaikoHyokaKbnFromShohinKbn(shohinKbn);
    }
    function applyZaikoHyokaKbnFromShohinKbn(targetData) {
        return createEntryDefaultsService(buildEntryDefaultsServiceDeps()).applyZaikoHyokaKbnFromShohinKbn(targetData);
    }
    function syncMakerHyojyunJyodaiFromPrice(targetData) {
        return createEntryDefaultsService(buildEntryDefaultsServiceDeps()).syncMakerHyojyunJyodaiFromPrice(targetData);
    }
    function sanitizeEntryData(data) {
        return createEntryDefaultsService(buildEntryDefaultsServiceDeps()).sanitizeEntryData(data);
    }
    function numericPayloadColumnIds() {
        return createEntryDefaultsService(buildEntryDefaultsServiceDeps()).numericPayloadColumnIds();
    }
    function normalizeNumericPayloadObject(data) {
        return createEntryDefaultsService(buildEntryDefaultsServiceDeps()).normalizeNumericPayloadObject(data);
    }
    function createJyutakuHasuShoriSaveColumnInfo(columnid, columnnm) {
        return createEntryDefaultsService(buildEntryDefaultsServiceDeps()).createJyutakuHasuShoriSaveColumnInfo(columnid, columnnm);
    }

    function ensureSaveColumnInfoField(fields, columnid, columnnm) {
        return createEntryDefaultsService(buildEntryDefaultsServiceDeps()).ensureSaveColumnInfoField(fields, columnid, columnnm);
    }

    function buildSaveColumnInfo(sourceColumnInfo) {
        return createEntryDefaultsService(buildEntryDefaultsServiceDeps()).buildSaveColumnInfo(sourceColumnInfo);
    }
    function findBrandHinbanSerialField() {
        return createHinbanNumberingService(buildHinbanNumberingServiceDeps()).findBrandHinbanSerialField();
    }
    function isAutomaticHinbanNumberingSelected(targetData) {
        return createHinbanNumberingService(buildHinbanNumberingServiceDeps()).isAutomaticHinbanNumberingSelected(targetData);
    }
    function isManualHinbanNumberingSelected(targetData) {
        return createHinbanNumberingService(buildHinbanNumberingServiceDeps()).isManualHinbanNumberingSelected(targetData);
    }
    function isBrandHinbanNumberingControlledField(field) {
        return createHinbanNumberingService(buildHinbanNumberingServiceDeps()).isBrandHinbanNumberingControlledField(field);
    }
    function applyBrandHinbanNumberingLockToField(field) {
        return createHinbanNumberingService(buildHinbanNumberingServiceDeps()).applyBrandHinbanNumberingLockToField(field);
    }
    function applyBrandHinbanNumberingLockToFields(fields) {
        return createHinbanNumberingService(buildHinbanNumberingServiceDeps()).applyBrandHinbanNumberingLockToFields(fields);
    }
    function ensureBrandHinbanValuesOnSave(onSuccess, onError) {
        return createHinbanNumberingService(buildHinbanNumberingServiceDeps()).ensureBrandHinbanValuesOnSave(onSuccess, onError);
    }
    function ensureSubBrandValuesOnSave(onSuccess) {
        return createHinbanNumberingService(buildHinbanNumberingServiceDeps()).ensureSubBrandValuesOnSave(onSuccess);
    }
    function loadControlDate(callback, errorCallback) {
        return createEntryLifecycleService(buildEntryLifecycleServiceDeps()).loadControlDate(callback, errorCallback);
    }
    function refreshControlDate(shouldUpdatePdtYear, errorCallback) {
        return createEntryLifecycleService(buildEntryLifecycleServiceDeps()).refreshControlDate(shouldUpdatePdtYear, errorCallback);
    }
    function syncNewFormPdtYear() {
        return createEntryLifecycleService(buildEntryLifecycleServiceDeps()).syncNewFormPdtYear();
    }
    function resolveCurrentOppiCode() {
        return createEntryLifecycleService(buildEntryLifecycleServiceDeps()).resolveCurrentOppiCode();
    }
    // 加工指示区分の選択肢解決と表示ラベル生成をまとめる。
    function buildKubunOptionServiceDeps() {
        return {
            DicVal,
            columninfo,
            isEmpty
        };
    }
    // 加工指示サマリ一覧(区分バンド/アンカーグリッド行)の組み立てと再取得をまとめる。
    function buildKakousijiSummaryListServiceDeps() {
        return {
            DeepCopy,
            DicVal,
            GridData,
            KAKOUSIJI_ANCHOR_PANEL_TYPE,
            KAKOUSIJI_SAMPLE_GROUP_KEY,
            KAKOUSIJI_S_LO_TYPE_OFFSET,
            activeKakousijiKey,
            activeKakousijiSummaryItem,
            buildKakousijiKnownColumnIds,
            collectKakousijiPanelColumnIds,
            entrydataRef,
            firstNonEmptyValue,
            fnc,
            getKakousijiEntryCache,
            getKakousijiEntryCacheForSummaryItem,
            gridlist,
            isEmpty,
            isKakousijiPanelType,
            isKakousijiSampleKubunValue,
            kakousijiImportedSummaryRowsRef,
            kakousijiSummaryList,
            normalizeKakousijiKubunValue,
            normalizeKakousijiSampleDetailForStoreByType,
            resolveKakousijiGridPanelByType,
            resolveKakousijiSummaryKubunLabel,
            resolvePanelTypeColumnIdByName,
            setActiveKakousijiKey,
            setKakousijiGridRows,
            setKakousijiSummaryList,
            setKakousijiSummaryLoading
        };
    }
    // 加工指示エントリのスナップショット生成・キャッシュ・切り替え適用をまとめる。
    function buildKakousijiEntrySnapshotServiceDeps() {
        return {
            DeepCopy,
            DicVal,
            G_id,
            GridData,
            KAKOUSIJI_FUKUSHIZAI_BASE_PANEL_TYPE,
            KAKOUSIJI_SAMPLE_GROUP_KEY,
            KAKOUSIJI_S_LO_TYPE_OFFSET,
            SetGridData,
            activeKakousijiKeyRef,
            activeKakousijiSampleGroupEntryKey,
            activeKakousijiSummaryItem,
            applyClientOnlyEntryDefaults,
            assignEntryDataCurrent,
            buildKakousijiSummaryRowFromEntry,
            clearKakousijiSnapshotSystemValues,
            columninfo,
            columns,
            dispatch,
            entrydata,
            entrydataRef,
            entryrerender,
            gridlist,
            groupKakousijiSampleSummaryRows,
            isEmpty,
            isKakousijiPanelType,
            isKakousijiSampleGroupSummaryItem,
            kakousijiEntryCacheRef,
            kakousijiGroupControlStateRef,
            KAKOUSIJI_QUALITY_BASE_PANEL_TYPE,
            kakousijiQualityGroupControlStateRef,
            setKakousijiQualityGroupControlState,
            setKakousijiOrderHistoryData,
            applyFukushizaiScopeDisplayRows,
            normalizeKakousijiDemeritDisplayRows,
            pickKakousijiQualityScopeRepresentativeRows,
            kakousijiWashSourceRowsRef,
            buildHinbanWashSaveRows,
            HINBAN_WASH_PANEL_TYPE,
            refreshKakousijiNouhinGridColumns,
            kakousijiImportedSummaryRowsRef,
            kakousijiSampleGroupEntryKeys,
            kakousijiSummaryList,
            mergeKakousijiRepresentativeRowToEntry,
            normalizeKakousijiDemandRows,
            normalizeKakousijiKubunValue,
            normalizeKakousijiSampleDetailForDisplayByType,
            normalizeKakousijiSampleDetailForStoreByType,
            resolveCurrentOppiCode,
            resolveKakousijiGridPanelByType,
            resolveKakousijiGroupItemContext,
            setActiveKakousijiKey,
            setEntryGridRows,
            setKakousijiGroupControlState,
            setKakousijiSummaryList,
            snapshotKakousijiSampleGroupDisplayEntry,
            storeRowData,
            syncKakousijiAnchorGridRows,
            syncKakousijiSamplePanelsFromPdtc,
            textfields,
            textfieldsall
        };
    }
    // 加工指示の追加ドラフト生成と採番予約をまとめる。
    function buildKakousijiDraftServiceDeps() {
        return {
            DeepCopy,
            DicVal,
            KAKOUSIJI_SAMPLE_GROUP_KEY,
            activeKakousijiKeyRef,
            applyActiveKakousijiSelectionData,
            buildKakousijiEntrySnapshotData,
            buildKakousijiEntrySnapshotDetail,
            buildKakousijiSampleGroupSummaryItem,
            emptyKakousijiSnapshot,
            firstNonEmptyValue,
            fnc,
            isEmpty,
            isKakousijiSampleGroupSummaryItem,
            kakousijiDraftSeqRef,
            kakousijiSampleGroupEntryKeys,
            kakousijiSummaryList,
            lastLoadedKakousijiCodeRef,
            normalizeKakousijiKubunValue,
            normalizeKakousijiSummaryRow,
            resolveCurrentOppiCode,
            setActiveKakousijiKey,
            setKakousijiEntryCache,
            setKakousijiSummaryList,
            syncKakousijiAnchorGridRows
        };
    }
    function normalizeKakousijiKubunValue(rawValue) {
        return createKubunOptionService(buildKubunOptionServiceDeps()).normalizeKakousijiKubunValue(rawValue);
    }
    function isKakousijiSampleKubunValue(rawValue) {
        return createKubunOptionService(buildKubunOptionServiceDeps()).isKakousijiSampleKubunValue(rawValue);
    }
    function parseKakousijiKubunOptionToken(token) {
        return createKubunOptionService(buildKubunOptionServiceDeps()).parseKakousijiKubunOptionToken(token);
    }
    function getKakousijiKubunOptions() {
        return createKubunOptionService(buildKubunOptionServiceDeps()).getKakousijiKubunOptions();
    }
    function resolveKakousijiKubunLabel(value, index) {
        return createKubunOptionService(buildKubunOptionServiceDeps()).resolveKakousijiKubunLabel(value, index);
    }
    function resolveKakousijiSummaryKubunLabel(item, index) {
        return createKubunOptionService(buildKubunOptionServiceDeps()).resolveKakousijiSummaryKubunLabel(item, index);
    }
    function normalizeKakousijiSummaryRow(row, index) {
        return createKakousijiSummaryListService(buildKakousijiSummaryListServiceDeps()).normalizeKakousijiSummaryRow(row, index);
    }
    function ensureKakousijiSummaryRows(rows) {
        return createKakousijiSummaryListService(buildKakousijiSummaryListServiceDeps()).ensureKakousijiSummaryRows(rows);
    }
    function isKakousijiSampleGroupSummaryItem(item) {
        return createKakousijiSummaryListService(buildKakousijiSummaryListServiceDeps()).isKakousijiSampleGroupSummaryItem(item);
    }
    function kakousijiSampleGroupEntryKeys(item) {
        return createKakousijiSummaryListService(buildKakousijiSummaryListServiceDeps()).kakousijiSampleGroupEntryKeys(item);
    }
    function activeKakousijiSampleGroupEntryKey(item) {
        return createKakousijiSummaryListService(buildKakousijiSummaryListServiceDeps()).activeKakousijiSampleGroupEntryKey(item);
    }
    function buildKakousijiSampleGroupSummaryItem(sourceItem, sampleEntryKeys, activeSampleEntryKey, index) {
        return createKakousijiSummaryListService(buildKakousijiSummaryListServiceDeps()).buildKakousijiSampleGroupSummaryItem(sourceItem, sampleEntryKeys, activeSampleEntryKey, index);
    }
    function groupKakousijiSampleSummaryRows(rows) {
        return createKakousijiSummaryListService(buildKakousijiSummaryListServiceDeps()).groupKakousijiSampleSummaryRows(rows);
    }
    function mergeKakousijiSummaryRows(primaryRows, fallbackRows) {
        return createKakousijiSummaryListService(buildKakousijiSummaryListServiceDeps()).mergeKakousijiSummaryRows(primaryRows, fallbackRows);
    }
    function buildKakousijiSummaryRowFromEntry(entry, index, fallbackOppiCode) {
        return createKakousijiSummaryListService(buildKakousijiSummaryListServiceDeps()).buildKakousijiSummaryRowFromEntry(entry, index, fallbackOppiCode);
    }
    function buildKakousijiSummaryRowFromSnapshot(summaryItem, snapshot, index) {
        return createKakousijiSummaryListService(buildKakousijiSummaryListServiceDeps()).buildKakousijiSummaryRowFromSnapshot(summaryItem, snapshot, index);
    }
    function buildLiveActiveKakousijiSnapshot() {
        return createKakousijiSummaryListService(buildKakousijiSummaryListServiceDeps()).buildLiveActiveKakousijiSnapshot();
    }
    function getKakousijiSnapshotForSummaryItem(summaryItem) {
        return createKakousijiSummaryListService(buildKakousijiSummaryListServiceDeps()).getKakousijiSnapshotForSummaryItem(summaryItem);
    }
    function expandKakousijiSummaryItemsForAnchor(summaryItems) {
        return createKakousijiSummaryListService(buildKakousijiSummaryListServiceDeps()).expandKakousijiSummaryItemsForAnchor(summaryItems);
    }
    function buildKakousijiAnchorGridRowsFromSummary(mainData, summaryItems) {
        return createKakousijiSummaryListService(buildKakousijiSummaryListServiceDeps()).buildKakousijiAnchorGridRowsFromSummary(mainData, summaryItems);
    }
    function syncKakousijiAnchorGridRows(summaryItems) {
        return createKakousijiSummaryListService(buildKakousijiSummaryListServiceDeps()).syncKakousijiAnchorGridRows(summaryItems);
    }
    // マスタ応答のたびに集計行→アンカーグリッド→再表示の一式が走るため、
    // 短時間の連続呼び出しは1回に合流させる(反映が最大150ms遅れるだけ)。
    // 遅延実行時に古い state を掴まないよう、実体は毎レンダー ref に載せ替える。
    const refreshKakousijiSummaryExecRef = useRef(null);
    refreshKakousijiSummaryExecRef.current = (targetSsdNo) =>
        createKakousijiSummaryListService(buildKakousijiSummaryListServiceDeps()).refreshKakousijiSummaryState(targetSsdNo);
    const refreshKakousijiSummaryDebounceRef = useRef({ timer: null, targets: [] });
    function refreshKakousijiSummaryState(targetSsdNo = '') {
        const state = refreshKakousijiSummaryDebounceRef.current;
        const target = String(targetSsdNo ?? '').trim();
        if (!state.targets.includes(target)) state.targets.push(target);
        if (state.timer !== null) clearTimeout(state.timer);
        state.timer = setTimeout(() => {
            state.timer = null;
            const targets = state.targets;
            state.targets = [];
            // 対象が複数溜まった場合は全件更新('')に落とす
            const mergedTarget = targets.length === 1 ? targets[0] : '';
            unstable_batchedUpdates(() => {
                if (refreshKakousijiSummaryExecRef.current !== null) {
                    refreshKakousijiSummaryExecRef.current(mergedTarget);
                }
            });
        }, 150);
    }
    function resolveKakousijiSummaryTargetSsdNo(targetData) {
        return createKakousijiSummaryListService(buildKakousijiSummaryListServiceDeps()).resolveKakousijiSummaryTargetSsdNo(targetData);
    }
    function shouldSyncKakousijiSummaryByFieldId(fieldId) {
        return createKakousijiSummaryListService(buildKakousijiSummaryListServiceDeps()).shouldSyncKakousijiSummaryByFieldId(fieldId);
    }

    function resolvePanelTypeColumnIdByName(type, names) {
        const targetType = String(type ?? '').trim();
        const source = []
            .concat(Array.isArray(columninfo) ? columninfo : [])
            .concat(Array.isArray(columns) ? columns : []);

        const candidates = (Array.isArray(names) ? names : [])
            .map((v) => String(v ?? '').trim())
            .filter((v) => v !== '');

        const hit = source.find((col) => {
            if (String(DicVal(col, 'type', '')).trim() !== targetType) return false;
            const label = String(DicVal(col, 'columnnm', DicVal(col, 'headerName', ''))).trim();
            return candidates.includes(label);
        });

        return isEmpty(hit) ? '' : String(DicVal(hit, 'columnid', DicVal(hit, 'field', ''))).trim();
    }
    function buildKakousijiAnchorGridRows(mainData, entries) {
        return createKakousijiSummaryListService(buildKakousijiSummaryListServiceDeps()).buildKakousijiAnchorGridRows(mainData, entries);
    }
    function loadKakousijiSummaryList(oppiCode, options) {
        return createKakousijiSummaryListService(buildKakousijiSummaryListServiceDeps()).loadKakousijiSummaryList(oppiCode, options);
    }
    function openKakousijiAddDialog() {
        return createKakousijiAddDialogService(buildKakousijiAddDialogServiceDeps()).openKakousijiAddDialog();
    }
    function mapKakousijiPanelTypeToHinban(type) {
        return createKakousijiEntrySnapshotService(buildKakousijiEntrySnapshotServiceDeps()).mapKakousijiPanelTypeToHinban(type);
    }
    function mapHinbanPanelTypeToKakousiji(type) {
        return createKakousijiEntrySnapshotService(buildKakousijiEntrySnapshotServiceDeps()).mapHinbanPanelTypeToKakousiji(type);
    }
    function collectKakousijiPanelColumnIds() {
        return createKakousijiEntrySnapshotService(buildKakousijiEntrySnapshotServiceDeps()).collectKakousijiPanelColumnIds();
    }
    function collectBasePanelColumnIds() {
        return createKakousijiEntrySnapshotService(buildKakousijiEntrySnapshotServiceDeps()).collectBasePanelColumnIds();
    }
    function clearActiveKakousijiSelectionData() {
        return createKakousijiEntrySnapshotService(buildKakousijiEntrySnapshotServiceDeps()).clearActiveKakousijiSelectionData();
    }
    function buildKakousijiEntrySnapshotData(sourceData, oppiCode, kubunValue) {
        return createKakousijiEntrySnapshotService(buildKakousijiEntrySnapshotServiceDeps()).buildKakousijiEntrySnapshotData(sourceData, oppiCode, kubunValue);
    }
    function buildKakousijiEntrySnapshotDetail(sourceDetail, oppiCode, kubunValue) {
        return createKakousijiEntrySnapshotService(buildKakousijiEntrySnapshotServiceDeps()).buildKakousijiEntrySnapshotDetail(sourceDetail, oppiCode, kubunValue);
    }
    function emptyKakousijiSnapshot(oppiCode, kubunValue) {
        return createKakousijiEntrySnapshotService(buildKakousijiEntrySnapshotServiceDeps()).emptyKakousijiSnapshot(oppiCode, kubunValue);
    }
    function setKakousijiEntryCache(key, snapshot) {
        return createKakousijiEntrySnapshotService(buildKakousijiEntrySnapshotServiceDeps()).setKakousijiEntryCache(key, snapshot);
    }
    function getKakousijiEntryCache(key) {
        return createKakousijiEntrySnapshotService(buildKakousijiEntrySnapshotServiceDeps()).getKakousijiEntryCache(key);
    }
    function getKakousijiEntryCacheForSummaryItem(summaryItem) {
        return createKakousijiEntrySnapshotService(buildKakousijiEntrySnapshotServiceDeps()).getKakousijiEntryCacheForSummaryItem(summaryItem);
    }

    function resolveKakousijiDetailTargetPanelType(rawType) {
        return createKakousijiEntrySnapshotService(buildKakousijiEntrySnapshotServiceDeps()).resolveKakousijiDetailTargetPanelType(rawType);
    }
    function normalizeKakousijiDetailForHinbanPanels(sourceDetail) {
        return createKakousijiEntrySnapshotService(buildKakousijiEntrySnapshotServiceDeps()).normalizeKakousijiDetailForHinbanPanels(sourceDetail);
    }
    function normalizeKakousijiDetailForSave(sourceDetail) {
        return createKakousijiEntrySnapshotService(buildKakousijiEntrySnapshotServiceDeps()).normalizeKakousijiDetailForSave(sourceDetail);
    }
    function importKakousijiEntriesFromHinbanData(entries) {
        return createKakousijiEntrySnapshotService(buildKakousijiEntrySnapshotServiceDeps()).importKakousijiEntriesFromHinbanData(entries);
    }
    function snapshotActiveKakousijiSelectionData() {
        return createKakousijiEntrySnapshotService(buildKakousijiEntrySnapshotServiceDeps()).snapshotActiveKakousijiSelectionData();
    }
    function switchActiveKakousijiKey(nextKey) {
        return createKakousijiEntrySnapshotService(buildKakousijiEntrySnapshotServiceDeps()).switchActiveKakousijiKey(nextKey);
    }
    function applyActiveKakousijiSelectionData(sourceData, sourceDetail, sourceOrderHistory = null) {
        return createKakousijiEntrySnapshotService(buildKakousijiEntrySnapshotServiceDeps()).applyActiveKakousijiSelectionData(sourceData, sourceDetail, sourceOrderHistory);
    }
    // 副資材スコープ(121-124)の表示行を副資材ベース行(120)から組み立てる(加工指示の114-117相当)。
    function buildFukushizaiScopeDisplayServiceDeps() {
        return {
            DicVal,
            isEmpty,
            fnc,
            corpkey,
            account,
            entrydataRef,
            GridData,
            setEntryGridRows,
            resolveKakousijiGridPanelByType,
            kakousijiGroupControlStateRef,
            komonoFudaLabelCacheRef,
            komonoFudaLabelLoadingRef,
            KAKOUSIJI_FUKUSHIZAI_BASE_PANEL_TYPE
        };
    }
    function applyFukushizaiScopeDisplayRows(baseRowsOverride = null) {
        return createFukushizaiScopeDisplayService(buildFukushizaiScopeDisplayServiceDeps()).applyFukushizaiScopeDisplayRows(baseRowsOverride);
    }
    // 品質表示スコープ明細(126-130)の表示行絞り込み(加工指示の代表行表示相当)。行データは全件保持し外部フィルタで絞る。
    function buildQualityScopeDisplayServiceDeps() {
        return {
            DicVal,
            isEmpty,
            GridData,
            resolveKakousijiGridPanelByType,
            kakousijiQualityGroupControlStateRef,
            getColumnInfo: () => columninfo
        };
    }
    function isKakousijiQualityScopeDisplayPanel(panelInfo) {
        return createQualityScopeDisplayService(buildQualityScopeDisplayServiceDeps()).isQualityScopeDisplayPanel(panelInfo);
    }
    function buildKakousijiQualityScopeFilterVersion(panelType) {
        return createQualityScopeDisplayService(buildQualityScopeDisplayServiceDeps()).buildQualityScopeFilterVersion(panelType);
    }
    function isKakousijiQualityScopeRowVisible(panelType, row) {
        return createQualityScopeDisplayService(buildQualityScopeDisplayServiceDeps()).isQualityScopeRowVisible(panelType, row);
    }
    function normalizeKakousijiDemeritDisplayRows(panelType, rows) {
        const svc = createQualityScopeDisplayService(buildQualityScopeDisplayServiceDeps());
        return svc.isDemeritScopePanelType(panelType) ? svc.normalizeDemeritDisplayRows(rows) : rows;
    }
    function pickKakousijiQualityScopeRepresentativeRows(panelType, rows) {
        return createQualityScopeDisplayService(buildQualityScopeDisplayServiceDeps()).pickQualityScopeRepresentativeRows(panelType, rows);
    }
    // 納品予定(138)の2段日付ヘッダは列定義構築時に行データの日付(SSDNY_NOUHINYOTEI等)を読む。
    // グリッドは行投入前にマウントされ列定義が先に出来上がるため、行投入後に列定義を作り直す
    // (加工指示は初回描画時に列定義を再構築している。品番マスタは rerendergrid で同じ効果を得る)。
    function refreshKakousijiNouhinGridColumns() {
        const panelInfo = resolveKakousijiGridPanelByType(KAKOUSIJI_DEMAND_NOUHIN_PANEL_TYPE);
        if (isEmpty(panelInfo) || isEmpty(fnc.current) || typeof fnc.current.GridID !== 'function') return;
        dispatch(rerendergrid({ rerendergrid: fnc.current.GridID(panelInfo) }));
    }
    // 洗濯表示(131): 保持している全ソース行から現在の品質選択の代表行を選び、WashGridの表示行を作り直す。
    function applyKakousijiWashScopeDisplay() {
        const panelInfo = resolveKakousijiGridPanelByType(HINBAN_WASH_PANEL_TYPE);
        if (isEmpty(panelInfo)) return;
        const sourceRows = Array.isArray(kakousijiWashSourceRowsRef.current) ? kakousijiWashSourceRowsRef.current : [];
        if (sourceRows.length === 0) return;
        const representative = pickKakousijiQualityScopeRepresentativeRows(HINBAN_WASH_PANEL_TYPE, sourceRows);
        setEntryGridRows({ id: panelInfo.id, type: HINBAN_WASH_PANEL_TYPE }, representative.length === 0 ? [] : [representative[0]]);
    }
    function resolveInitialProductionKakousijiItem() {
        return createKakousijiEntrySnapshotService(buildKakousijiEntrySnapshotServiceDeps()).resolveInitialProductionKakousijiItem();
    }
    function applyKakousijiNoToSnapshot(snapshot, ssdNo) {
        return createKakousijiDraftService(buildKakousijiDraftServiceDeps()).applyKakousijiNoToSnapshot(snapshot, ssdNo);
    }
    function appendKakousijiSampleDraft(option, sourceSnapshot, assignedSsdNo, draftNo) {
        return createKakousijiDraftService(buildKakousijiDraftServiceDeps()).appendKakousijiSampleDraft(option, sourceSnapshot, assignedSsdNo, draftNo);
    }
    function appendKakousijiDraft(option, sourceSnapshot, assignedSsdNo) {
        return createKakousijiDraftService(buildKakousijiDraftServiceDeps()).appendKakousijiDraft(option, sourceSnapshot, assignedSsdNo);
    }
    function reserveKakousijiSequence(onSuccess, onError) {
        return createKakousijiDraftService(buildKakousijiDraftServiceDeps()).reserveKakousijiSequence(onSuccess, onError);
    }
    function commitKakousijiAddDialog() {
        return createKakousijiAddDialogService(buildKakousijiAddDialogServiceDeps()).commitKakousijiAddDialog();
    }
    function loadActiveKakousijiSelectionData(summaryItem) {
        return createKakousijiAddDialogService(buildKakousijiAddDialogServiceDeps()).loadActiveKakousijiSelectionData(summaryItem);
    }
    function loadPriceChangeEnable(oppiCode, options) {
        return createHinbanPermissionService(buildHinbanPermissionServiceDeps()).loadPriceChangeEnable(oppiCode, options);
    }
    function loadHinbanFixEnableByBrand(brandCode) {
        return createHinbanPermissionService(buildHinbanPermissionServiceDeps()).loadHinbanFixEnableByBrand(brandCode);
    }
    function setHinbanDeleteDisabled(disabled) {
        return createHinbanPermissionService(buildHinbanPermissionServiceDeps()).setHinbanDeleteDisabled(disabled);
    }
    function refreshHinbanDeleteDisabled() {
        return createHinbanPermissionService(buildHinbanPermissionServiceDeps()).refreshHinbanDeleteDisabled();
    }
    function setBrandDepartmentDeleteDisabled(disabled) {
        return createHinbanPermissionService(buildHinbanPermissionServiceDeps()).setBrandDepartmentDeleteDisabled(disabled);
    }
    function updateSynFlg1DeleteDisabled(targetData) {
        return createHinbanPermissionService(buildHinbanPermissionServiceDeps()).updateSynFlg1DeleteDisabled(targetData);
    }
    function applyHinbanDeleteMenuDisabled(disabled = hinbanDeleteMenuDisabled) {
        return createHinbanPermissionService(buildHinbanPermissionServiceDeps()).applyHinbanDeleteMenuDisabled(disabled);
    }
    function loadUserAllowedBrandDepartment(brandCode) {
        return createHinbanPermissionService(buildHinbanPermissionServiceDeps()).loadUserAllowedBrandDepartment(brandCode);
    }
    function firstNonEmptyValue(data, keys) {
        if (isEmpty(data) || isEmpty(keys)) return "";
        for (let i = 0; i < keys.length; i++) {
            const value = String(DicVal(data, keys[i], "")).trim();
            if (!isEmpty(value)) return value;
        }
        const entries = Object.entries(data);
        for (let i = 0; i < keys.length; i++) {
            const found = entries.find(([key]) => String(key).toUpperCase() === String(keys[i]).toUpperCase());
            if (isEmpty(found)) continue;
            const value = String(isEmpty(found[1]) ? "" : found[1]).trim();
            if (!isEmpty(value)) return value;
        }
        return "";
    }
    function resolveItemMasterBrandCode(data) {
        return firstNonEmptyValue(data, ["PDT_BRDCODE", "PDT_BRDCODE_cd", "PDT_BRANDCD", "PDT_BRAND", "BRAND", "BRANDCD", "BRDCODE"]);
    }
    function resolveBrandGroupBrandCode(data) {
        return firstNonEmptyValue(data, ["PDT_BRDCODE", "PDT_BRDCODE_cd", "PDT_BRANDCD", "PDT_BRAND", "BRDCODE", "BRANDCD", "BRAND"]);
    }
    function normalizePsHinbanYearSuffix(yearValue) {
        return createHinbanNumberingService(buildHinbanNumberingServiceDeps()).normalizePsHinbanYearSuffix(yearValue);
    }
    function normalizePsHinbanSeasonCode(seasonValue) {
        return createHinbanNumberingService(buildHinbanNumberingServiceDeps()).normalizePsHinbanSeasonCode(seasonValue);
    }
    function normalizePsHinbanBrandCode(brandValue) {
        return createHinbanNumberingService(buildHinbanNumberingServiceDeps()).normalizePsHinbanBrandCode(brandValue);
    }
    function buildPsHinbanPrefix(data) {
        return createHinbanNumberingService(buildHinbanNumberingServiceDeps()).buildPsHinbanPrefix(data);
    }
    function normalizePsHinbanSequence(sequenceValue) {
        return createHinbanNumberingService(buildHinbanNumberingServiceDeps()).normalizePsHinbanSequence(sequenceValue);
    }
    function requestOppiHinbanSequence(prefix, numberingSource, callbacks) {
        return createHinbanNumberingService(buildHinbanNumberingServiceDeps()).requestOppiHinbanSequence(prefix, numberingSource, callbacks);
    }
    function resolveItemMasterItemCode(data) {
        return createPdtSizePatternService(buildPdtSizePatternServiceDeps()).resolveItemMasterItemCode(data);
    }
    function applyFirstExistingValue(data, targets, value) {
        return createPdtSizePatternService(buildPdtSizePatternServiceDeps()).applyFirstExistingValue(data, targets, value);
    }
    function setPdtItmcItemCdOnEntryData(targetData, value) {
        return createPdtSizePatternService(buildPdtSizePatternServiceDeps()).setPdtItmcItemCdOnEntryData(targetData, value);
    }
    function clearPdtTenkaiCodeValue(targetData) {
        return createPdtSizePatternService(buildPdtSizePatternServiceDeps()).clearPdtTenkaiCodeValue(targetData);
    }
    function applyPdtTenkaiCodeAutoSelection(targetData, value) {
        return createPdtSizePatternService(buildPdtSizePatternServiceDeps()).applyPdtTenkaiCodeAutoSelection(targetData, value);
    }
    function pdtTenkaiCodeOptionsFromReturnData(returnData) {
        return createPdtSizePatternService(buildPdtSizePatternServiceDeps()).pdtTenkaiCodeOptionsFromReturnData(returnData);
    }
    function loadPdtTenkaiCodeOptionsForData(targetData, options) {
        return createPdtSizePatternService(buildPdtSizePatternServiceDeps()).loadPdtTenkaiCodeOptionsForData(targetData, options);
    }
    function refreshPdtItmcItemCdDependentOptions(targetData, options) {
        return createPdtSizePatternService(buildPdtSizePatternServiceDeps()).refreshPdtItmcItemCdDependentOptions(targetData, options);
    }
    function buildPdtTenkaiSearchField(field, currentData) {
        return createPdtSizePatternService(buildPdtSizePatternServiceDeps()).buildPdtTenkaiSearchField(field, currentData);
    }
    function normalizeSubBrandOptions(rows) {
        return createPdtSizePatternService(buildPdtSizePatternServiceDeps()).normalizeSubBrandOptions(rows);
    }
    function currentSubBrandOptions() {
        return createPdtSizePatternService(buildPdtSizePatternServiceDeps()).currentSubBrandOptions();
    }
    function applySubBrandNameToEntryData(targetData, options) {
        return createPdtSizePatternService(buildPdtSizePatternServiceDeps()).applySubBrandNameToEntryData(targetData, options);
    }
    function loadSubBrandName(options) {
        return createPdtSizePatternService(buildPdtSizePatternServiceDeps()).loadSubBrandName(options);
    }
    function buildSubBrandSearchField(field, currentData) {
        return createPdtSizePatternService(buildPdtSizePatternServiceDeps()).buildSubBrandSearchField(field, currentData);
    }
    function buildBrandHinbanSearchField(field, currentData) {
        return createPdtSizePatternService(buildPdtSizePatternServiceDeps()).buildBrandHinbanSearchField(field, currentData);
    }
    function isKakousijiSubSoseiSearchField(field) {
        return createPdtSizePatternService(buildPdtSizePatternServiceDeps()).isKakousijiSubSoseiSearchField(field);
    }
    function ensureSubSoseiSearchParentCode(field, currentData) {
        return createPdtSizePatternService(buildPdtSizePatternServiceDeps()).ensureSubSoseiSearchParentCode(field, currentData);
    }
    function buildBaseSearchField(field, currentData) {
        return createPdtSizePatternService(buildPdtSizePatternServiceDeps()).buildBaseSearchField(field, currentData);
    }
    function syncItemDependentData(options) {
        return createPdtSizePatternService(buildPdtSizePatternServiceDeps()).syncItemDependentData(options);
    }
    function pdtItemCodesPanel() {
        return createPdtSizePatternService(buildPdtSizePatternServiceDeps()).pdtItemCodesPanel();
    }
    function pdtcSizeCodePanels() {
        return createPdtSizePatternService(buildPdtSizePatternServiceDeps()).pdtcSizeCodePanels();
    }
    function setDetailColumnValues(panelRef, columnid, values) {
        return createPdtSizePatternService(buildPdtSizePatternServiceDeps()).setDetailColumnValues(panelRef, columnid, values);
    }
    function setPdtItemCodesToDetailGrid(itemCodes) {
        return createPdtSizePatternService(buildPdtSizePatternServiceDeps()).setPdtItemCodesToDetailGrid(itemCodes);
    }
    function normalizeDetailColumnValues(values) {
        return createPdtSizePatternService(buildPdtSizePatternServiceDeps()).normalizeDetailColumnValues(values);
    }
    function displayInitialBlankDetailGridRow(panelRef) {
        return createPdtSizePatternService(buildPdtSizePatternServiceDeps()).displayInitialBlankDetailGridRow(panelRef);
    }
    function overwriteDetailColumnValues(panelRef, columnValues) {
        return createPdtSizePatternService(buildPdtSizePatternServiceDeps()).overwriteDetailColumnValues(panelRef, columnValues);
    }
    function setPdtcSizeCodesToDetailGrid(sizeCodes, posSizeCodes = [], options = {}) {
        return createPdtSizePatternService(buildPdtSizePatternServiceDeps()).setPdtcSizeCodesToDetailGrid(sizeCodes, posSizeCodes, options);
    }
    function normalizePdtcSizeOptions(sizeInfoList) {
        return createPdtSizePatternService(buildPdtSizePatternServiceDeps()).normalizePdtcSizeOptions(sizeInfoList);
    }
    function samePdtcSizeOptions(left, right) {
        return createPdtSizePatternService(buildPdtSizePatternServiceDeps()).samePdtcSizeOptions(left, right);
    }
    function applyPdtcSizeOptions(sizeInfoList) {
        return createPdtSizePatternService(buildPdtSizePatternServiceDeps()).applyPdtcSizeOptions(sizeInfoList);
    }
    function isPdtSizePatternFieldId(columnid) {
        return createPdtSizePatternService(buildPdtSizePatternServiceDeps()).isPdtSizePatternFieldId(columnid);
    }
    function hasPdtSizeDetailListData() {
        return createPdtSizePatternService(buildPdtSizePatternServiceDeps()).hasPdtSizeDetailListData();
    }
    function canEditPdtSizePattern() {
        return createPdtSizePatternService(buildPdtSizePatternServiceDeps()).canEditPdtSizePattern();
    }
    function refreshPdtSizePatternEditableState() {
        return createPdtSizePatternService(buildPdtSizePatternServiceDeps()).refreshPdtSizePatternEditableState();
    }
    function normalizePdtSizePatternOptions(sizePatternList) {
        return createPdtSizePatternService(buildPdtSizePatternServiceDeps()).normalizePdtSizePatternOptions(sizePatternList);
    }
    function sameCodeNameOptions(left, right) {
        return createPdtSizePatternService(buildPdtSizePatternServiceDeps()).sameCodeNameOptions(left, right);
    }
    function applyPdtSizePatternOptions(sizePatternList, currentData) {
        return createPdtSizePatternService(buildPdtSizePatternServiceDeps()).applyPdtSizePatternOptions(sizePatternList, currentData);
    }
    function loadPdtSizePatternOptions(options) {
        return createPdtSizePatternService(buildPdtSizePatternServiceDeps()).loadPdtSizePatternOptions(options);
    }
    function buildPdtSizePatternSearchField(field, currentData) {
        return createPdtSizePatternService(buildPdtSizePatternServiceDeps()).buildPdtSizePatternSearchField(field, currentData);
    }
    function currentPdtSizePatternCode(source) {
        return createPdtSizePatternService(buildPdtSizePatternServiceDeps()).currentPdtSizePatternCode(source);
    }
    function loadPdtSizePatternSizeOptions(sizePatternCode, options) {
        return createPdtSizePatternService(buildPdtSizePatternServiceDeps()).loadPdtSizePatternSizeOptions(sizePatternCode, options);
    }
    function buildPdtcSizeSearchField(field, currentData) {
        return createPdtSizePatternService(buildPdtSizePatternServiceDeps()).buildPdtcSizeSearchField(field, currentData);
    }
    function setPdtSizePatternOnData(targetData, sizePatternCode) {
        return createPdtSizePatternService(buildPdtSizePatternServiceDeps()).setPdtSizePatternOnData(targetData, sizePatternCode);
    }
    function loadPdtTenkaiSizePatternInfo(tenkaiCode, options) {
        return createPdtSizePatternService(buildPdtSizePatternServiceDeps()).loadPdtTenkaiSizePatternInfo(tenkaiCode, options);
    }
    // アイテムマスタ照会と、そこから entrydata / 明細へ反映する処理をまとめる。
    function buildItemMasterServiceDeps() {
        return {
            DicVal,
            PDT_SIZE_PATTERN_FIELD_IDS,
            applyFirstExistingValue,
            assignEntryDataCurrent,
            currentPdtSizePatternCode,
            dispatch,
            entrydata,
            entrydataRef,
            entryrerender,
            fnc,
            formstatus,
            isEmpty,
            isSyohin2SectionEditable,
            loadPdtSizePatternOptions,
            loadPdtSizePatternSizeOptions,
            loadPdtTenkaiSizePatternInfoAfterEntryLoad,
            protectHbSeasonCommit,
            refreshPdtItmcItemCdDependentOptions,
            rerender,
            resolveBrandGroupBrandCode,
            resolveCurrentOppiCode,
            resolveItemMasterBrandCode,
            resolveItemMasterItemCode,
            setPdtItemCodesToDetailGrid,
            setPdtItmcItemCdOnEntryData,
            syncItemDependentData
        };
    }
    // 商品情報2セクションが編集可かどうか(主アイテムの自動反映可否の判定に使用)
    function isSyohin2SectionEditable() {
        const targetPanel = (Array.isArray(panel) ? panel : []).find((item) =>
            String(DicVal(item, 'id', '')) === G_id.BASE && String(DicVal(item, 'type', '')).trim() === '101');
        if (isEmpty(targetPanel)) return false;
        return sectionEditable(targetPanel);
    }
    function applyItemMasterInfoToEntryData(itemMasterInfo) {
        return createItemMasterService(buildItemMasterServiceDeps()).applyItemMasterInfoToEntryData(itemMasterInfo);
    }
    function loadItemMasterInfo(options) {
        return createItemMasterService(buildItemMasterServiceDeps()).loadItemMasterInfo(options);
    }
    function loadBitmSubCode(options) {
        return createItemMasterService(buildItemMasterServiceDeps()).loadBitmSubCode(options);
    }
    function loadPdtItemCodes(options) {
        return createItemMasterService(buildItemMasterServiceDeps()).loadPdtItemCodes(options);
    }
    // カラーマスタ照会と、明細行への反映/クリアをまとめる。
    function buildColorMasterServiceDeps() {
        return {
            DicVal,
            GridApi,
            dispatch,
            entrydata,
            entrydataRef,
            entryrerender,
            fnc,
            isEmpty,
            rerender,
            resolveItemMasterBrandCode,
            storeRowData
        };
    }
    function applyColorMasterInfoToData(targetData, colorMasterInfo) {
        return createColorMasterService(buildColorMasterServiceDeps()).applyColorMasterInfoToData(targetData, colorMasterInfo);
    }
    function clearColorMasterInfoOnData(targetData) {
        return createColorMasterService(buildColorMasterServiceDeps()).clearColorMasterInfoOnData(targetData);
    }
    function reflectColorMasterInfoChange(targetData, rowNode, panel) {
        return createColorMasterService(buildColorMasterServiceDeps()).reflectColorMasterInfoChange(targetData, rowNode, panel);
    }
    function loadColorMasterInfo(colorCode, options) {
        return createColorMasterService(buildColorMasterServiceDeps()).loadColorMasterInfo(colorCode, options);
    }
    // ブランドグループ照会と entrydata への反映/クリアをまとめる。
    function buildBrandGroupServiceDeps() {
        return {
            DicVal,
            FIXED_HINBAN_NUMBERING_COLUMNID,
            applyFirstExistingValue,
            applyFixedHinbanNumberingValue,
            assignEntryDataCurrent,
            brandGroupInfoRequestSeqRef,
            dispatch,
            entrydata,
            entrydataRef,
            entryrerender,
            fnc,
            isEmpty,
            lastBrandGroupBrandCodeRef,
            protectHbSeasonCommit,
            rerender,
            resolveBrandGroupBrandCode,
            setEntryDataValue
        };
    }
    function applyBrandGroupInfoToEntryData(targetData, brandGroupInfo) {
        return createBrandGroupService(buildBrandGroupServiceDeps()).applyBrandGroupInfoToEntryData(targetData, brandGroupInfo);
    }
    function clearBrandGroupInfoOnEntryData(targetData, options) {
        return createBrandGroupService(buildBrandGroupServiceDeps()).clearBrandGroupInfoOnEntryData(targetData, options);
    }
    function loadBrandGroupInfo(options) {
        return createBrandGroupService(buildBrandGroupServiceDeps()).loadBrandGroupInfo(options);
    }
    // 受託仕入先情報の照会と entrydata への反映をまとめる。
    function buildJyutakuSupplierServiceDeps() {
        return {
            DicVal,
            assignEntryDataCurrent,
            dispatch,
            entrydata,
            entrydataRef,
            entryrerender,
            fnc,
            isEmpty,
            lastJyutakuSupplierCodeRef,
            protectHbSeasonCommit,
            syncHinbanGenkaCurrencyState,
            syncHinbanGenkaPatternByEntry
        };
    }
    function setJyutakuSupplierInfoOnEntryData(targetData, data) {
        return createJyutakuSupplierService(buildJyutakuSupplierServiceDeps()).setJyutakuSupplierInfoOnEntryData(targetData, data);
    }
    function loadJyutakuSupplierInfo(options) {
        return createJyutakuSupplierService(buildJyutakuSupplierServiceDeps()).loadJyutakuSupplierInfo(options);
    }
    // QRC 由来項目(内数・最低発注単位・商品分類・商品コメント)の照会と反映をまとめる。
    function buildQrcInfoServiceDeps() {
        return {
            DicVal,
            assignEntryDataCurrent,
            dispatch,
            entrydata,
            entrydataRef,
            entryrerender,
            firstNonEmptyValue,
            fnc,
            isEmpty,
            lastQrcMinHachuTaniKeyRef,
            lastQrcPackIrisuKeyRef,
            lastQrcSyohinBunruiCdKeyRef,
            lastQrcSyohinComentKeyRef,
            protectHbSeasonCommit,
            rerender,
            resolveBrandGroupBrandCode
        };
    }
    function setQrcPackIrisuOnEntryData(targetData, value) {
        return createQrcInfoService(buildQrcInfoServiceDeps()).setQrcPackIrisuOnEntryData(targetData, value);
    }
    function loadQrcPackIrisu(options) {
        return createQrcInfoService(buildQrcInfoServiceDeps()).loadQrcPackIrisu(options);
    }
    function setQrcMinHachuTaniOnEntryData(targetData, value) {
        return createQrcInfoService(buildQrcInfoServiceDeps()).setQrcMinHachuTaniOnEntryData(targetData, value);
    }
    function loadQrcMinHachuTani(options) {
        return createQrcInfoService(buildQrcInfoServiceDeps()).loadQrcMinHachuTani(options);
    }
    function setQrcSyohinBunruiCdOnEntryData(targetData, value) {
        return createQrcInfoService(buildQrcInfoServiceDeps()).setQrcSyohinBunruiCdOnEntryData(targetData, value);
    }
    function loadQrcSyohinBunruiCd(options) {
        return createQrcInfoService(buildQrcInfoServiceDeps()).loadQrcSyohinBunruiCd(options);
    }
    function setQrcSyohinComentOnEntryData(targetData, value) {
        return createQrcInfoService(buildQrcInfoServiceDeps()).setQrcSyohinComentOnEntryData(targetData, value);
    }
    function loadQrcSyohinComent(options) {
        return createQrcInfoService(buildQrcInfoServiceDeps()).loadQrcSyohinComent(options);
    }
    // JAN シーズンコードの照会と entrydata への反映をまとめる。
    function buildJanSeasonServiceDeps() {
        return {
            DicVal,
            assignEntryDataCurrent,
            dispatch,
            entrydata,
            entrydataRef,
            entryrerender,
            fnc,
            isEmpty,
            lastHbSeasonCodeRef,
            protectHbSeasonCommit,
            rerender
        };
    }
    function setJanSeasonCodeOnEntryData(targetData, value) {
        return createJanSeasonService(buildJanSeasonServiceDeps()).setJanSeasonCodeOnEntryData(targetData, value);
    }
    function loadJanSeasonCode(hbSeasonCode, options) {
        return createJanSeasonService(buildJanSeasonServiceDeps()).loadJanSeasonCode(hbSeasonCode, options);
    }
    function loadPdtTenkaiSizePatternInfoAfterEntryLoad() {
        if (isEmpty(DicVal(entrydataRef.current, "PDT_TENKAICODE", ""))) return;
        setTimeout(() => {
            if (isEmpty(DicVal(entrydataRef.current, "PDT_TENKAICODE", ""))) return;
            loadPdtTenkaiSizePatternInfo(DicVal(entrydataRef.current, "PDT_TENKAICODE", ""), {
                silent: true,
                targetData: entrydataRef.current
            });
        }, 0);
    }
    function applyKakousijiDetailPostEdit(panel) {
        return createValueChangedService(buildValueChangedServiceDeps()).applyKakousijiDetailPostEdit(panel);
    }
    function ListValueChanged(params, panel) {
        return createValueChangedService(buildValueChangedServiceDeps()).ListValueChanged(params, panel);
    }
    function ListRowValueChanged(colid, rows, panel) {
        return createValueChangedService(buildValueChangedServiceDeps()).ListRowValueChanged(colid, rows, panel);
    }

    const actionurl = {
        "delete": "hinbanmaster/DeleteHinbanMaster",
        "upload": "hinbanmaster/Upload",
        "getlist": "hinbanmaster/GetListData",
    }

    const navmenu = [
        { status: "ENTRY FORM", menuid: "formupload", icon: "upload_file", label: "関連ファイルUpload", title: "関連ファイルをアップロードします" },
        { status: "ENTRY FORM", menuid: "sozaitenhaisho", icon: "", label: "素材手配書発行", title: "" },
        { status: "ENTRY FORM", menuid: "fuzokutenhaisho", icon: "", label: "附属手配書発行", title: "" },
        { status: "ENTRY FORM", menuid: "fukushizaitenhaisho", icon: "", label: "副資材手配書発行", title: "" },
        { status: "ENTRY FORM", menuid: "shinsei", icon: "", label: "申請", title: "" },
        { status: "ENTRY FORM", menuid: "shinseikaijo", icon: "", label: "申請解除", title: "" },
        { status: "VIEW", menuid: "excel", icon: "file_download", label: "Excel", title: "現在のシート内容をExcelに出力します" },
        { status: "VIEW", menuid: "sep" },
        { status: "VIEW", menuid: "print", icon: "print", label: "納品予定出力" },
        { status: "VIEW", menuid: "sep" },
        { status: "VIEW", menuid: "imagesave", icon: "image", label: "画像一括登録" },
   ]

    function normalizeRequestFlagForMenu(value) {
        return createHinbanActionService(buildHinbanActionServiceDeps()).normalizeRequestFlagForMenu(value);
    }


    function requestStatusNavMenu() {
        return createHinbanActionService(buildHinbanActionServiceDeps()).requestStatusNavMenu();
    }
    function currentRequestStatusNavMenu() {
        return createHinbanActionService(buildHinbanActionServiceDeps()).currentRequestStatusNavMenu();
    }
    //動作抑止
    const suppressaction = [
        { type: "0", action: "INSERT" },
        { type: "0", action: "UPDATE" },
    ];

    function rerender() {
        // 閉包の update を読むのは意図的。同じ描画周期で複数回呼ばれても同じ値になり、
        // React が更新を打ち切るため再描画のループが止まる。
        // 関数形式 setUpdata((prev) => !prev) にすると毎回値が変わり、
        // Maximum update depth exceeded になるので変更しないこと。
        perfActionOrigin('rerender', new Error().stack);
        setUpdata(update ? false : true);
    }
    function setPriceFieldLocked(locked) {
        return createValueChangedService(buildValueChangedServiceDeps()).setPriceFieldLocked(locked);
    }
    function sectionKey(panel) {
        return createSectionEditStateService(buildSectionEditStateServiceDeps()).sectionKey(panel);
    }
    function setSectionRef(refMap, key, node) {
        return createSectionEditStateService(buildSectionEditStateServiceDeps()).setSectionRef(refMap, key, node);
    }
    function isKakousijiEditButtonPanel(panel) {
        return createSectionEditStateService(buildSectionEditStateServiceDeps()).isKakousijiEditButtonPanel(panel);
    }
    function currentKakousijiEditButtonPanelTypes() {
        return createSectionEditStateService(buildSectionEditStateServiceDeps()).currentKakousijiEditButtonPanelTypes();
    }
    function selectedKakousijiKubunValue() {
        return createSectionEditStateService(buildSectionEditStateServiceDeps()).selectedKakousijiKubunValue();
    }
    function selectedKakousijiNo() {
        return createSectionEditStateService(buildSectionEditStateServiceDeps()).selectedKakousijiNo();
    }
    function showKakousijiSectionEditButton(panel) {
        return createSectionEditStateService(buildSectionEditStateServiceDeps()).showKakousijiSectionEditButton(panel);
    }
    function isKakousijiSectionEditActive() {
        return createSectionEditStateService(buildSectionEditStateServiceDeps()).isKakousijiSectionEditActive();
    }
    function sectionEditable(panel) {
        return createSectionEditStateService(buildSectionEditStateServiceDeps()).sectionEditable(panel);
    }
    function sectionBodyLocked(panel) {
        return createSectionEditStateService(buildSectionEditStateServiceDeps()).sectionBodyLocked(panel);
    }
    function setSectionButtonState(panel, editable) {
        return createSectionEditStateService(buildSectionEditStateServiceDeps()).setSectionButtonState(panel, editable);
    }
    function applySectionEditState(panel, editable) {
        return createSectionEditStateService(buildSectionEditStateServiceDeps()).applySectionEditState(panel, editable);
    }
    function applySectionEditToggle(panel) {
        return createSectionEditStateService(buildSectionEditStateServiceDeps()).applySectionEditToggle(panel);
    }
    function applyKakousijiSectionEditStart() {
        return createSectionEditStateService(buildSectionEditStateServiceDeps()).applyKakousijiSectionEditStart();
    }
    function isEditTrackedSectionPanel(panel) {
        return createSectionEditStateService(buildSectionEditStateServiceDeps()).isEditTrackedSectionPanel(panel);
    }
    function beginTrackedSectionEdit(panel, force) {
        return createSectionEditStateService(buildSectionEditStateServiceDeps()).beginTrackedSectionEdit(panel, force);
    }
    function toggleSectionEdit(panel) {
        return createSectionEditStateService(buildSectionEditStateServiceDeps()).toggleSectionEdit(panel);
    }
    function closeSectionOverwriteConfirmDialog() {
        return createSectionEditStateService(buildSectionEditStateServiceDeps()).closeSectionOverwriteConfirmDialog();
    }
    function handleSectionOverwriteConfirmOk() {
        return createSectionEditStateService(buildSectionEditStateServiceDeps()).handleSectionOverwriteConfirmOk();
    }
    function resetSectionEdit() {
        return createSectionEditStateService(buildSectionEditStateServiceDeps()).resetSectionEdit();
    }
        function isKakousijiPanelType(type) {
        const numericType = Number(String(isEmpty(type) ? "" : type).trim());
        if (!Number.isFinite(numericType)) return false;
        return numericType === Number(KAKOUSIJI_HEADER_PANEL_TYPE) || (numericType >= KAKOUSIJI_PANEL_TYPE_MIN && numericType <= KAKOUSIJI_PANEL_TYPE_MAX);
    }
    function isKakousijiPanel(panelInfo) {
        if (isEmpty(panelInfo)) return false;
        return isKakousijiPanelType(panelInfo.type);
    }
    function kakousijiPanelDisplayOrderValue(panelInfo) {
        const type = String(DicVal(panelInfo, 'type', '')).trim();
        const sampleOrderIndex = KAKOUSIJI_SAMPLE_PANEL_DISPLAY_ORDER.indexOf(type);
        if (sampleOrderIndex !== -1) return 140000 + sampleOrderIndex;
        const numericType = Number(type);
        return Number.isFinite(numericType) ? numericType * 1000 : Number.MAX_SAFE_INTEGER;
    }
    function isKakousijiHeaderPanel(panelInfo) {
        if (isEmpty(panelInfo)) return false;
        return String(DicVal(panelInfo, 'type', '')).trim() === KAKOUSIJI_HEADER_PANEL_TYPE;
    }
    function isKakousijiModeAnchorPanel(panelInfo) {
        return String(DicVal(panelInfo, 'type', '')).trim() === KAKOUSIJI_MODE_ANCHOR_PANEL_TYPE;
    }
    function isKakousijiSijisuPanel(panelInfo) {
        if (isEmpty(panelInfo)) return false;
        return String(DicVal(panelInfo, 'type', '')).trim() === KAKOUSIJI_SIJISU_PANEL_TYPE;
    }
    function isKakousijiSozaiMeisaiPanel(panelInfo) {
        if (isEmpty(panelInfo)) return false;
        return String(DicVal(panelInfo, 'type', '')).trim() === KAKOUSIJI_SOZAI_MEISAI_PANEL_TYPE;
    }
    function isKakousijiFuzokuMeisaiPanel(panelInfo) {
        if (isEmpty(panelInfo)) return false;
        return String(DicVal(panelInfo, 'type', '')).trim() === KAKOUSIJI_FUZOKU_MEISAI_PANEL_TYPE;
    }
    function isKakousijiFukushizaiListPanel(panelInfo) {
        if (isEmpty(panelInfo)) return false;
        return String(DicVal(panelInfo, 'type', '')).trim() === KAKOUSIJI_FUKUSHIZAI_LIST_PANEL_TYPE;
    }
    function isKakousijiFukushizaiBasePanel(panelInfo) {
        if (isEmpty(panelInfo)) return false;
        return String(DicVal(panelInfo, 'type', '')).trim() === KAKOUSIJI_FUKUSHIZAI_BASE_PANEL_TYPE;
    }
    function isKakousijiQualityBasePanel(panelInfo) {
        if (isEmpty(panelInfo)) return false;
        return String(DicVal(panelInfo, 'type', '')).trim() === KAKOUSIJI_QUALITY_BASE_PANEL_TYPE;
    }
    function isKakousijiSoseiPanel(panelInfo) {
        if (isEmpty(panelInfo)) return false;
        const type = String(DicVal(panelInfo, 'type', '')).trim();
        return type === KAKOUSIJI_QUALITY_DISPLAY_PANEL_TYPE || type === KAKOUSIJI_SOSEI_CALC_PANEL_TYPE;
    }
    function isKakousijiSamplePanel(panelInfo) {
        if (isEmpty(panelInfo)) return false;
        const numericType = Number(String(DicVal(panelInfo, 'type', '')).trim());
        if (!Number.isFinite(numericType)) return false;
        return numericType >= KAKOUSIJI_SAMPLE_PANEL_TYPE_MIN && numericType <= KAKOUSIJI_SAMPLE_PANEL_TYPE_MAX;
    }
    function activeKakousijiSummaryItem() {
        return (Array.isArray(kakousijiSummaryList) ? kakousijiSummaryList : []).find((item) => item.key === activeKakousijiKey) || null;
    }
    function isActiveKakousijiDraft() {
        return !!DicVal(activeKakousijiSummaryItem(), 'isDraft', false);
    }
    function shouldUseKakousijiDraftNewFormMode(panelInfo) {
        return isKakousijiPanel(panelInfo) && isActiveKakousijiDraft();
    }
    function resolveKakousijiPanelView(panelInfo) {
        if (!isKakousijiPanel(panelInfo)) return '';
        const type = String(DicVal(panelInfo, 'type', '')).trim();
        if (type === KAKOUSIJI_DEMAND_JUTYU_PANEL_TYPE) return 'type2';
        if (type === KAKOUSIJI_DEMAND_NOUHIN_PANEL_TYPE) return 'type3';
        return 'type1';
    }
    function parseBoolLike(value, defaultVal = false) {
        return entryValueSvc.parseBoolLike(value, defaultVal);
    }

    function normalizeCodeValue(raw) {
        return entryValueSvc.normalizeCodeValue(raw);
    }

    function findEntryValue(entryObj, candidates) {
        return entryValueSvc.findEntryValue(entryObj, candidates);
    }

    function findColumnInfoByCandidates(candidates, typeCandidates) {
        return entryValueSvc.findColumnInfoByCandidates(candidates, typeCandidates);
    }

    function resolveEntryColumnId(candidates, entryObj) {
        return entryValueSvc.resolveEntryColumnId(candidates, entryObj);
    }

    function normalizeColOptionsToStrings(options) {
        return entryValueSvc.normalizeColOptionsToStrings(options);
    }

    // 品番原価の原価パターン照会と通貨単位の同期をまとめる。
    function buildGenkaPatternLoaderDeps() {
        return {
            DicVal,
            HINBAN_GENKA_PANEL_TYPE,
            applyForcedGenkaJpyIfNeeded,
            buildGenkaPatternRequest,
            deriveGenkaPatternFromEntry,
            dispatch,
            edittingcode,
            entrydata,
            entrydataRef,
            entryrerender,
            fnc,
            genkaBrandKbnColumnIdCandidates,
            genkaCurrencyOptionsFromLayout,
            genkaHeaderCurrencyColumnIdCandidates,
            genkaKaigaiKbnColumnIdCandidates,
            genkaPatternLabelByNo,
            genkaPatternRequestSeqRef,
            genkaPatternUrl,
            genkaShohinKbnColumnIdCandidates,
            genkaSupplierCurrencyColumnIdCandidates,
            genkaYushoMushoKbnColumnIdCandidates,
            isEmpty,
            isGenkaCurrencyEditableByLayout,
            normalizeGenkaPatternNo,
            recalcHinbanGenkaGridAndSummary,
            rerender,
            resolveGenkaCurrencyFromEntry,
            resolveKakousijiGridPanelByType,
            setGenkaCurrency,
            setGenkaCurrencyNo,
            setGenkaCurrencyOptions,
            setGenkaCurrencyToEntry,
            setGenkaPattern,
            setGenkaPatternNo,
            setGenkaRateToEntry,
            shouldForceGenkaCurrencyJpy
        };
    }
    // 品番原価グリッドの行/列の組み立てと表示値の整形をまとめる。
    function buildGenkaGridServiceDeps() {
        return {
            DicVal,
            GridData,
            HINBAN_GENKA_COLUMN_MAP,
            HINBAN_GENKA_PANEL_TYPE,
            HINBAN_GENKA_ROW_DEFS,
            HINBAN_GENKA_SLOT_DEFS,
            HINBAN_GENKA_SUMMARY_DEFS,
            columninfo,
            ensureGridDataRef,
            isEmpty
        };
    }
    // 品番原価の金額再計算(原価率・掛率・スロット別集計)をまとめる。
    function buildGenkaRecalcServiceDeps() {
        return {
            DeepCopy,
            DicVal,
            GridApi,
            GridData,
            HINBAN_GENKA_PANEL_TYPE,
            HINBAN_GENKA_ROW_DEFS,
            SetGridData,
            buildHinbanGenkaDisplayRows,
            buildHinbanGenkaSaveRows,
            deriveGenkaPatternFromEntry,
            emptyHinbanGenkaRow,
            entrydataRef,
            fnc,
            genkaCurrency,
            genkaPattern,
            genkaPatternNo,
            hinbanGenkaRowKeyOrder,
            hinbanGenkaRowLabelByKey,
            isEmpty,
            rawHinbanGenkaRow,
            rerender,
            shouldForceGenkaCurrencyJpy
        };
    }
    function isHinbanGenkaPanel(panelInfo) {
        return createGenkaPatternLoader(buildGenkaPatternLoaderDeps()).isHinbanGenkaPanel(panelInfo);
    }

    function genkaPatternLabelByNo(no) {
        return genkaPatternSvc.genkaPatternLabelByNo(no);
    }
    function genkaCurrencyDisplayLabel(value) {
        return genkaPatternSvc.genkaCurrencyDisplayLabel(value);
    }
    function isJpyCurrencyValue(value) {
        return genkaPatternSvc.isJpyCurrencyValue(value);
    }
    function shouldForceGenkaCurrencyJpy(entryObj) {
        return genkaPatternSvc.shouldForceGenkaCurrencyJpy(entryObj);
    }
    function deriveGenkaPatternFromEntry(entryObj) {
        return genkaPatternSvc.deriveGenkaPatternFromEntry(entryObj);
    }
    function normalizeGenkaPatternNo(value) {
        return genkaPatternSvc.normalizeGenkaPatternNo(value);
    }
    function applyGenkaPatternResult(source) {
        return createGenkaPatternLoader(buildGenkaPatternLoaderDeps()).applyGenkaPatternResult(source);
    }
    function applyGenkaPatternFallback(entryObj) {
        return createGenkaPatternLoader(buildGenkaPatternLoaderDeps()).applyGenkaPatternFallback(entryObj);
    }
    function resolveGenkaPatternRequestCode(code, entryObj) {
        return genkaPatternSvc.resolveGenkaPatternRequestCode(code, entryObj);
    }
    function buildGenkaPatternRequest(code, entryObj) {
        return genkaPatternSvc.buildGenkaPatternRequest(code, entryObj);
    }
    function loadHinbanGenkaPattern(code, entryObj = entrydataRef.current) {
        return createGenkaPatternLoader(buildGenkaPatternLoaderDeps()).loadHinbanGenkaPattern(code, entryObj);
    }
    function findGenkaCurrencyLayoutMeta() {
        return genkaPatternSvc.findGenkaCurrencyLayoutMeta();
    }
    function isGenkaCurrencyEditableByLayout() {
        return genkaPatternSvc.isGenkaCurrencyEditableByLayout();
    }
    function genkaCurrencyOptionsFromLayout() {
        return genkaPatternSvc.genkaCurrencyOptionsFromLayout();
    }
    function resolveGenkaCurrencyFromEntry(entryObj) {
        return genkaPatternSvc.resolveGenkaCurrencyFromEntry(entryObj);
    }
    function setGenkaCurrencyToEntry(entryObj, value) {
        return genkaPatternSvc.setGenkaCurrencyToEntry(entryObj, value);
    }
    function setGenkaRateToEntry(entryObj, value) {
        return genkaPatternSvc.setGenkaRateToEntry(entryObj, value);
    }
    function applyForcedGenkaJpyIfNeeded(entryObj) {
        return genkaPatternSvc.applyForcedGenkaJpyIfNeeded(entryObj);
    }
    function syncHinbanGenkaCurrencyState(entryObj = entrydataRef.current, applyEntry = false) {
        return createGenkaPatternLoader(buildGenkaPatternLoaderDeps()).syncHinbanGenkaCurrencyState(entryObj, applyEntry);
    }
    function syncHinbanGenkaPatternByEntry(entryObj = entrydataRef.current, code = edittingcode) {
        return createGenkaPatternLoader(buildGenkaPatternLoaderDeps()).syncHinbanGenkaPatternByEntry(entryObj, code);
    }
    function handleHinbanGenkaCurrencyChanged(value) {
        return createGenkaPatternLoader(buildGenkaPatternLoaderDeps()).handleHinbanGenkaCurrencyChanged(value);
    }
    function shouldRefreshHinbanGenkaByColumnId(columnId) {
        return createGenkaPatternLoader(buildGenkaPatternLoaderDeps()).shouldRefreshHinbanGenkaByColumnId(columnId);
    }
    function renderHinbanGenkaHeader() {
        return createGenkaRenderer(buildGenkaRendererDeps()).renderHinbanGenkaHeader();
    }
    const HINBAN_GENKA_ROW_DEFS = [
        { key: 'MAT_AMOUNT', label: '素材金額' },
        { key: 'MAT_LOSS', label: '素材ロス率' },
        { key: 'MAT_TOTAL', label: '素材金額計' },
        { key: 'SUB_AMOUNT', label: '附属金額' },
        { key: 'SUB_LOSS', label: '附属ロス率' },
        { key: 'NAME_AMOUNT', label: 'ネーム類' },
        { key: 'DELIVERY_MAT', label: '納品資材' },
        { key: 'ETC_LOSS', label: 'その他附属ロス率' },
        { key: 'SUB_TOTAL', label: '附属金額計' },
        { key: 'PROCESS', label: '加工賃' },
        { key: 'PRODUCT', label: '商品金額' },
        { key: 'SECONDARY', label: '二次加工賃' },
        { key: 'MARGIN', label: 'マージン％' },
        { key: 'EXPENSE_OUT', label: '輸出諸掛' },
        { key: 'EXPENSE_IN', label: '輸入諸掛' },
        { key: 'TARIFF', label: '輸入関税' },
        { key: 'ZAN8', label: '暫８金額' },
        { key: 'POST_SUB', label: '後付附属金額' },
        { key: 'DOMESTIC_WORK', label: '国内作業' },
        { key: 'ADJUST', label: '調整' },
        { key: 'EST_COST', label: '見積原価' }
    ];
    const HINBAN_GENKA_SLOT_DEFS = [
        { colId: 'muryo', headerName: '無償支給', minWidth: 96 },
        { colId: 'muryo_f', headerName: '無償支給(外)', minWidth: 108 },
        { colId: 'yusho', headerName: '有償支給', minWidth: 96 },
        { colId: 'yusho_f', headerName: '有償支給(外)', minWidth: 108 },
        { colId: 'kojo', headerName: '工場手配', minWidth: 96 },
        { colId: 'kojo_f', headerName: '工場手配(外)', minWidth: 108 },
        { colId: 'syokei', headerName: '小計', minWidth: 92 },
        { colId: 'syokei_f', headerName: '小計(外)', minWidth: 98 },
        { colId: 'kousei', headerName: '構成比率', minWidth: 100 }
    ];
    const HINBAN_GENKA_SUMMARY_DEFS = [
        { id: 'SSDGM_BOUEKIJYOKEN', label: '貿易条件区分', valueKey: 'SSDGM_BOUEKIJYOKEN', valueKey2: '' },
        { id: 'SSDGM_TSUKATANI', label: '通貨', valueKey: 'SSDGM_TSUKATANI', valueKey2: '' },
        { id: 'SSDGM_RATE', label: 'レート', valueKey: 'SSDGM_RATE', valueKey2: '' },
        { id: 'SSDGM_FOBKIN', label: '小計', valueKey: 'SSDGM_FOBKIN', valueKey2: 'SSDGM_FOBKINF' },
        { id: 'SSDGM_SYOKAKARITAKA', label: '諸掛計', valueKey: 'SSDGM_SYOKAKARITAKA', valueKey2: '' },
        { id: 'SSDGM_SEIHINGENKA', label: '仕入原価', valueKey: 'SSDGM_SEIHINGENKA', valueKey2: '' },
        { id: 'SSDGM_JYODAI', label: '上代', valueKey: 'SSDGM_JYODAI', valueKey2: '' },
        { id: 'SSDGM_JYODAIRITU', label: '設定率', valueKey: 'SSDGM_JYODAIRITU', valueKey2: '' },
        { id: 'SSDGM_HACHUTANKA', label: '発注単価', valueKey: 'SSDGM_HACHUTANKA', valueKey2: '' },
        { id: 'SSDGM_HACHUTANKAF', label: '発注単価（外）', valueKey: 'SSDGM_HACHUTANKAF', valueKey2: '' },
        { id: 'SSDGM_FIXTANKA', label: '確定単価', valueKey: 'SSDGM_FIXTANKA', valueKey2: '' },
        { id: 'SSDGM_FIXTANKAF', label: '確定単価（外）', valueKey: 'SSDGM_FIXTANKAF', valueKey2: '' }
    ];
    const HINBAN_GENKA_COLUMN_MAP = {
        'SSDGM_KIJIKIN_MSIKYU': { row: 'MAT_AMOUNT', cols: ['muryo'] },
        'SSDGM_KIJIKIN_YSIKYU': { row: 'MAT_AMOUNT', cols: ['yusho'] },
        'SSDGM_KIJIKIN_YSIKYUF': { row: 'MAT_AMOUNT', cols: ['yusho_f'] },
        'SSDGM_KIJIKIN_KTEHAI': { row: 'MAT_AMOUNT', cols: ['kojo'] },
        'SSDGM_KIJIKIN_KTEHAIF': { row: 'MAT_AMOUNT', cols: ['kojo_f'] },
        'SSDGM_KIJILOSRITU_MSIKYU': { row: 'MAT_LOSS', cols: ['muryo'] },
        'SSDGM_KIJILOSRITU_YSIKYU': { row: 'MAT_LOSS', cols: ['yusho', 'yusho_f'] },
        'SSDGM_KIJILOSRITU_KTEHAI': { row: 'MAT_LOSS', cols: ['kojo', 'kojo_f'] },
        'SSDGM_FUZOKUKIN_MSIKYU': { row: 'SUB_AMOUNT', cols: ['muryo'] },
        'SSDGM_FUZOKUKIN_YSIKYU': { row: 'SUB_AMOUNT', cols: ['yusho'] },
        'SSDGM_FUZOKUKIN_YSIKYUF': { row: 'SUB_AMOUNT', cols: ['yusho_f'] },
        'SSDGM_FUZOKUKIN_KTEHAI': { row: 'SUB_AMOUNT', cols: ['kojo'] },
        'SSDGM_FUZOKUKIN_KTEHAIF': { row: 'SUB_AMOUNT', cols: ['kojo_f'] },
        'SSDGM_FUZOKULOSRITU_MSIKYU': { row: 'SUB_LOSS', cols: ['muryo'] },
        'SSDGM_FUZOKULOSRITU_YSIKYU': { row: 'SUB_LOSS', cols: ['yusho', 'yusho_f'] },
        'SSDGM_FUZOKULOSRITU_KTEHAI': { row: 'SUB_LOSS', cols: ['kojo', 'kojo_f'] },
        'SSDGM_NAMEKIN_MSIKYU': { row: 'NAME_AMOUNT', cols: ['muryo'] },
        'SSDGM_NAMEKIN_YSIKYU': { row: 'NAME_AMOUNT', cols: ['yusho'] },
        'SSDGM_NAMEKIN_YSIKYUF': { row: 'NAME_AMOUNT', cols: ['yusho_f'] },
        'SSDGM_NAMEKIN_KTEHAI': { row: 'NAME_AMOUNT', cols: ['kojo'] },
        'SSDGM_NAMEKIN_KTEHAIF': { row: 'NAME_AMOUNT', cols: ['kojo_f'] },
        'SSDGM_SIZAIKIN_MSIKYU': { row: 'DELIVERY_MAT', cols: ['muryo'] },
        'SSDGM_SIZAIKIN_YSIKYU': { row: 'DELIVERY_MAT', cols: ['yusho'] },
        'SSDGM_SIZAIKIN_YSIKYUF': { row: 'DELIVERY_MAT', cols: ['yusho_f'] },
        'SSDGM_SIZAIKIN_KTEHAI': { row: 'DELIVERY_MAT', cols: ['kojo'] },
        'SSDGM_SIZAIKIN_KTEHAIF': { row: 'DELIVERY_MAT', cols: ['kojo_f'] },
        'SSDGM_NAMESIZAILOSRITU_MSIKYU': { row: 'ETC_LOSS', cols: ['muryo'] },
        'SSDGM_NAMESIZAILOSRITU_YSIKYU': { row: 'ETC_LOSS', cols: ['yusho', 'yusho_f'] },
        'SSDGM_NAMESIZAILOSRITU_KTEHAI': { row: 'ETC_LOSS', cols: ['kojo', 'kojo_f'] },
        'SSDGM_KAKOKIN_KTEHAI': { row: 'PROCESS', cols: ['kojo'] },
        'SSDGM_KAKOKIN_KTEHAIF': { row: 'PROCESS', cols: ['kojo_f'] },
        'SSDGM_SHOHINKIN_KTEHAI': { row: 'PRODUCT', cols: ['kojo'] },
        'SSDGM_SHOHINKIN_KTEHAIF': { row: 'PRODUCT', cols: ['kojo_f'] },
        'SSDGM_NKAKOKIN_MSIKYU': { row: 'SECONDARY', cols: ['muryo'] },
        'SSDGM_NKAKOKIN_YSIKYU': { row: 'SECONDARY', cols: ['yusho'] },
        'SSDGM_NKAKOKIN_YSIKYUF': { row: 'SECONDARY', cols: ['yusho_f'] },
        'SSDGM_NKAKOKIN_KTEHAI': { row: 'SECONDARY', cols: ['kojo'] },
        'SSDGM_NKAKOKIN_KTEHAIF': { row: 'SECONDARY', cols: ['kojo_f'] },
        'SSDGM_MARGINKIN_YSIKYU': { row: 'MARGIN', cols: ['yusho'] },
        'SSDGM_MARGINKIN_KTEHAI': { row: 'MARGIN', cols: ['kojo', 'kojo_f'] },
        'SSDGM_EXPSYOKAKARIKIN_MSIKYU': { row: 'EXPENSE_OUT', cols: ['muryo'] },
        'SSDGM_EXPSYOKAKARIKIN_YSIKYU': { row: 'EXPENSE_OUT', cols: ['yusho'] },
        'SSDGM_IMPSYOKAKARIKIN_MSIKYU': { row: 'EXPENSE_IN', cols: ['muryo'] },
        'SSDGM_IMPSYOKAKARIKIN_YSIKYU': { row: 'EXPENSE_IN', cols: ['yusho'] },
        'SSDGM_IMPKANZEI_MSIKYU': { row: 'TARIFF', cols: ['muryo'] },
        'SSDGM_IMPKANZEI_YSIKYU': { row: 'TARIFF', cols: ['yusho'] },
        'SSDGM_ZANTEIKIN_MSIKYU': { row: 'ZAN8', cols: ['muryo'] },
        'SSDGM_ZANTEIKIN_YSIKYU': { row: 'ZAN8', cols: ['yusho'] },
        'SSDGM_ATOFUZOKUKIN_MSIKYU': { row: 'POST_SUB', cols: ['muryo'] },
        'SSDGM_ATOFUZOKUKIN_YSIKYU': { row: 'POST_SUB', cols: ['yusho'] },
        'SSDGM_KOKUSAGYOKIN_MSIKYU': { row: 'DOMESTIC_WORK', cols: ['muryo'] },
        'SSDGM_KOKUSAGYOKIN_YSIKYU': { row: 'DOMESTIC_WORK', cols: ['yusho'] },
        'SSDGM_CHOUSEIKIN_MSIKYU': { row: 'ADJUST', cols: ['muryo'] },
        'SSDGM_CHOUSEIKIN_YSIKYU': { row: 'ADJUST', cols: ['yusho'] },
        'SSDGM_CHOUSEIKIN_KTEHAI': { row: 'ADJUST', cols: ['kojo'] },
        'SSDGM_MITUMORIGENKA_MSIKYU': { row: 'EST_COST', cols: ['muryo'] },
        'SSDGM_MITUMORIGENKA_YSIKYU': { row: 'EST_COST', cols: ['yusho'] },
        'SSDGM_MITUMORIGENKA_YSIKYUF': { row: 'EST_COST', cols: ['yusho_f'] },
        'SSDGM_MITUMORIGENKA_KTEHAI': { row: 'EST_COST', cols: ['kojo'] },
        'SSDGM_MITUMORIGENKA_KTEHAIF': { row: 'EST_COST', cols: ['kojo_f'] }
    };

    function normalizeHinbanGenkaUpper(value) {
        return createGenkaGridService(buildGenkaGridServiceDeps()).normalizeHinbanGenkaUpper(value);
    }

    function mapHinbanGenkaByColumnId(columnId) {
        return createGenkaGridService(buildGenkaGridServiceDeps()).mapHinbanGenkaByColumnId(columnId);
    }

    function emptyHinbanGenkaRow(def, index) {
        return createGenkaGridService(buildGenkaGridServiceDeps()).emptyHinbanGenkaRow(def, index);
    }

    function rawHinbanGenkaRow(sourceRows) {
        return createGenkaGridService(buildGenkaGridServiceDeps()).rawHinbanGenkaRow(sourceRows);
    }

    function buildHinbanGenkaDisplayRows(sourceRows) {
        return createGenkaGridService(buildGenkaGridServiceDeps()).buildHinbanGenkaDisplayRows(sourceRows);
    }

    function fixedHinbanGenkaDisplayRows(sourceRows) {
        return createGenkaGridService(buildGenkaGridServiceDeps()).fixedHinbanGenkaDisplayRows(sourceRows);
    }
    function buildHinbanGenkaSaveRows(displayRows, previousRows) {
        return createGenkaGridService(buildGenkaGridServiceDeps()).buildHinbanGenkaSaveRows(displayRows, previousRows);
    }

    function isHinbanGenkaDisplayRows(rows) {
        return createGenkaGridService(buildGenkaGridServiceDeps()).isHinbanGenkaDisplayRows(rows);
    }

    function buildHinbanGenkaStoredRows(panelInfo, rows) {
        return createGenkaGridService(buildGenkaGridServiceDeps()).buildHinbanGenkaStoredRows(panelInfo, rows);
    }
    function resolveHinbanGenkaSlotLayoutMeta(slot) {
        return createGenkaGridService(buildGenkaGridServiceDeps()).resolveHinbanGenkaSlotLayoutMeta(slot);
    }

    function formatHinbanGenkaDisplayValue(params) {
        return createGenkaGridService(buildGenkaGridServiceDeps()).formatHinbanGenkaDisplayValue(params);
    }

    function formatHinbanGenkaKouseiDisplayValue(params) {
        return createGenkaGridService(buildGenkaGridServiceDeps()).formatHinbanGenkaKouseiDisplayValue(params);
    }

    function hinbanGenkaSlotColInfo(rowKey, slot) {
        return createGenkaGridService(buildGenkaGridServiceDeps()).hinbanGenkaSlotColInfo(rowKey, slot);
    }

    function isHinbanGenkaCellEditable(rowKey, slot) {
        return createGenkaGridService(buildGenkaGridServiceDeps()).isHinbanGenkaCellEditable(rowKey, slot);
    }

    function hinbanGenkaInactiveCellStyle(params, isLabel) {
        return createGenkaGridService(buildGenkaGridServiceDeps()).hinbanGenkaInactiveCellStyle(params, isLabel);
    }

    function buildHinbanGenkaFixedColumns() {
        return createGenkaGridService(buildGenkaGridServiceDeps()).buildHinbanGenkaFixedColumns();
    }
    function buildHinbanGenkaSummaryRows(sourceRows) {
        return createGenkaGridService(buildGenkaGridServiceDeps()).buildHinbanGenkaSummaryRows(sourceRows);
    }

    function ensureHinbanGenkaGridDataRef(panelInfo) {
        return createGenkaGridService(buildGenkaGridServiceDeps()).ensureHinbanGenkaGridDataRef(panelInfo);
    }

    function renderHinbanGenkaDetailGrid(panelInfo) {
        return createGenkaRenderer(buildGenkaRendererDeps()).renderHinbanGenkaDetailGrid(panelInfo);
    }
    function renderHinbanGenkaSummaryTable(panelInfo) {
        return createGenkaRenderer(buildGenkaRendererDeps()).renderHinbanGenkaSummaryTable(panelInfo);
    }

    function renderHinbanGenkaSection(panelInfo, filteredColumnInfo, filteredColumns) {
        return createGenkaRenderer(buildGenkaRendererDeps()).renderHinbanGenkaSection(panelInfo, filteredColumnInfo, filteredColumns);
    }
    const hinbanGenkaRowKeyOrder = HINBAN_GENKA_ROW_DEFS.map((def) => def.key);
    const hinbanGenkaRowLabelByKey = HINBAN_GENKA_ROW_DEFS.reduce((map, def) => {
        map[def.key] = def.label;
        return map;
    }, {});
    function hinbanGenkaToNumber(value) {
        return createGenkaRecalcService(buildGenkaRecalcServiceDeps()).hinbanGenkaToNumber(value);
    }
    function roundHinbanGenka(value) {
        return createGenkaRecalcService(buildGenkaRecalcServiceDeps()).roundHinbanGenka(value);
    }
    function calcHinbanGenkaRate(value) {
        return createGenkaRecalcService(buildGenkaRecalcServiceDeps()).calcHinbanGenkaRate(value);
    }
    function hinbanGenkaMainSlotByPatternNo(no) {
        return createGenkaRecalcService(buildGenkaRecalcServiceDeps()).hinbanGenkaMainSlotByPatternNo(no);
    }
    function hinbanGenkaMainFSlotByPatternNo(no) {
        return createGenkaRecalcService(buildGenkaRecalcServiceDeps()).hinbanGenkaMainFSlotByPatternNo(no);
    }
    function hinbanGenkaExpenseSlotByPatternNo(no) {
        return createGenkaRecalcService(buildGenkaRecalcServiceDeps()).hinbanGenkaExpenseSlotByPatternNo(no);
    }
    function hinbanGenkaPatternNoForCalc() {
        return createGenkaRecalcService(buildGenkaRecalcServiceDeps()).hinbanGenkaPatternNoForCalc();
    }
    function buildHinbanGenkaCalcRowMap(displayRows) {
        return createGenkaRecalcService(buildGenkaRecalcServiceDeps()).buildHinbanGenkaCalcRowMap(displayRows);
    }
    function applyHinbanGenkaDisplayRows(panelInfo, rawRows, displayRows) {
        return createGenkaRecalcService(buildGenkaRecalcServiceDeps()).applyHinbanGenkaDisplayRows(panelInfo, rawRows, displayRows);
    }
    function recalcHinbanGenkaGridAndSummary(panelInfo) {
        return createGenkaRecalcService(buildGenkaRecalcServiceDeps()).recalcHinbanGenkaGridAndSummary(panelInfo);
    }

    function getKakousijiDemandTypeKey(panelInfo) {
        return String(DicVal(panelInfo, 'type', '')).trim();
    }

    function normalizeKakousijiColumnIdSuffix(value) {
        return columnIdUtil.normalizeColumnIdSuffix(value);
    }
    function resolveKakousijiTypeColumnIdBySuffix(type, suffixCandidates) {
        return typeColumnResolver.resolveTypeColumnIdBySuffix(type, suffixCandidates);
    }
    function resolveKakousijiTypeColumnIdByName(type, names) {
        return typeColumnResolver.resolveTypeColumnIdByName(type, names);
    }
    function normalizeKakousijiJutyuRows(rows) {
        return demandRowNormalizer.normalizeJutyuRows(rows);
    }
    function normalizeKakousijiNouhinRows(rows) {
        return demandRowNormalizer.normalizeNouhinYoteiRows(rows);
    }
    function normalizeKakousijiDemandRows(panelInfo, rows) {
        if (!Array.isArray(rows)) return [];
        if (isKakousijiDemandJutyuPanel(panelInfo)) return normalizeKakousijiJutyuRows(rows);
        if (isKakousijiDemandNouhinPanel(panelInfo)) return normalizeKakousijiNouhinRows(rows);
        return rows;
    }
    function buildKakousijiDemandColumns(panelInfo, colDef) {
        // 加工指示と同じ順序で、表示列の絞り込み → 納品予定の日付2段ヘッダ の順に適用する。
        const nextDefs = demandGridColumnBuilder.buildDemandColumns(colDef, panelInfo);
        return demandGridColumnBuilder.buildNouhinHeaderColumns(nextDefs, panelInfo);
    }

    function getKakousijiDemandRowStyle(panelInfo) {
        if (isKakousijiDemandJutyuPanel(panelInfo)) {
            return function (params) {
                const kind = String(DicVal(DicVal(params, 'data', {}), 'row_kind', '')).trim();
                if (kind === 'subtotal') return { backgroundColor: '#cfe0e0', fontWeight: 700 };
                if (kind === 'total') return { backgroundColor: '#c5d9d9', fontWeight: 700 };
                return null;
            };
        }

        if (isKakousijiDemandNouhinPanel(panelInfo)) {
            return function (params) {
                const kind = String(DicVal(DicVal(params, 'data', {}), 'row_kind', '')).trim();
                if (kind === 'summary_label') return { backgroundColor: '#a7bcbc', color: '#ffffff', fontWeight: 700 };
                if (kind === 'summary_total') return { backgroundColor: '#eef1f1', color: '#333', fontWeight: 500 };
                return null;
            };
        }

        return null;
    }
    function isKakousijiDemandJutyuPanel(panelInfo) {
        if (isEmpty(panelInfo)) return false;
        return String(DicVal(panelInfo, 'type', '')).trim() === KAKOUSIJI_DEMAND_JUTYU_PANEL_TYPE;
    }

    function isKakousijiDemandNouhinPanel(panelInfo) {
        if (isEmpty(panelInfo)) return false;
        return String(DicVal(panelInfo, 'type', '')).trim() === KAKOUSIJI_DEMAND_NOUHIN_PANEL_TYPE;
    }

    function isKakousijiDemandPanel(panelInfo) {
        return isKakousijiDemandJutyuPanel(panelInfo) || isKakousijiDemandNouhinPanel(panelInfo);
    }
    function normalizeKakousijiText(value) {
        return String(value ?? '').trim();
    }
    function normalizeKakousijiUpperColumnId(value) {
        return normalizeKakousijiText(value).toUpperCase();
    }
    function readKakousijiRowValueIgnoreCase(row, columnId) {
        if (isEmpty(row) || isEmpty(columnId)) return undefined;
        const target = normalizeKakousijiUpperColumnId(columnId);
        const key = Object.keys(row).find((k) => normalizeKakousijiUpperColumnId(k) === target);
        return isEmpty(key) ? undefined : row[key];
    }
    function extractKakousijiMasterCode(value) {
        const text = normalizeKakousijiText(value);
        if (text === '') return '';
        return text.split(':')[0].trim();
    }
    function extractKakousijiMasterName(value) {
        const text = normalizeKakousijiText(value);
        if (text === '' || text.indexOf(':') === -1) return '';
        return text.substring(text.indexOf(':') + 1).trim();
    }
    function findKakousijiEntryValue(entryObj, candidates) {
        const source = isEmpty(entryObj) ? {} : entryObj;
        const list = Array.isArray(candidates) ? candidates : [candidates];
        for (let i = 0; i < list.length; i += 1) {
            const key = String(list[i] ?? '').trim();
            if (key === '') continue;
            const value = DicVal(source, key, undefined);
            if (value !== undefined && value !== null && String(value).trim() !== '') return value;
        }
        return '';
    }
    function normalizeKakousijiGroupNo(value) {
        return sharedNormalizeGroupNo(value);
    }
    function isKakousijiGroupManagedPanelType(panelType) {
        return createKakousijiGroupContextService(buildKakousijiGroupContextServiceDeps()).isKakousijiGroupManagedPanelType(panelType);
    }
    function kakousijiGroupNoToLabel(value) {
        return sharedGroupNoToLabel(value);
    }
    function resolveKakousijiGroupItemContext(row) {
        return createKakousijiGroupContextService(buildKakousijiGroupContextServiceDeps()).resolveKakousijiGroupItemContext(row);
    }
    function rowMatchesKakousijiItemGroup(row, itemCd, groupNo) {
        return createKakousijiGroupContextService(buildKakousijiGroupContextServiceDeps()).rowMatchesKakousijiItemGroup(row, itemCd, groupNo);
    }
    function getKakousijiRowsByContext(panelType, itemCd, groupNo) {
        return createKakousijiGroupContextService(buildKakousijiGroupContextServiceDeps()).getKakousijiRowsByContext(panelType, itemCd, groupNo);
    }
    function resolveKakousijiGroupSourceRows() {
        return createKakousijiGroupContextService(buildKakousijiGroupContextServiceDeps()).resolveKakousijiGroupSourceRows();
    }
    function collectKakousijiGroupItemOptions() {
        return createKakousijiGroupContextService(buildKakousijiGroupContextServiceDeps()).collectKakousijiGroupItemOptions();
    }
    function collectPdtItemDetailItemOptions() {
        return createKakousijiGroupContextService(buildKakousijiGroupContextServiceDeps()).collectPdtItemDetailItemOptions();
    }
    function getKnownKakousijiGroupNos(itemCd) {
        return createKakousijiGroupContextService(buildKakousijiGroupContextServiceDeps()).getKnownKakousijiGroupNos(itemCd);
    }
    function getKnownKakousijiGroupNosByPanelType(panelType, itemCd) {
        return createKakousijiGroupContextService(buildKakousijiGroupContextServiceDeps()).getKnownKakousijiGroupNosByPanelType(panelType, itemCd);
    }
    function getNextUnusedKakousijiGroupNo(itemCd) {
        return createKakousijiGroupContextService(buildKakousijiGroupContextServiceDeps()).getNextUnusedKakousijiGroupNo(itemCd);
    }
    function nextKakousijiDetailRowId(rows) {
        return createKakousijiGroupContextService(buildKakousijiGroupContextServiceDeps()).nextKakousijiDetailRowId(rows);
    }
    function createKakousijiGroupRow(panelType, itemCd, groupNo) {
        return createKakousijiGroupContextService(buildKakousijiGroupContextServiceDeps()).createKakousijiGroupRow(panelType, itemCd, groupNo);
    }
    function resolveKakousijiGroupSelection() {
        return createKakousijiGroupContextService(buildKakousijiGroupContextServiceDeps()).resolveKakousijiGroupSelection();
    }
    function resolveKakousijiFukushizaiBaseGroupSelection() {
        return createKakousijiGroupContextService(buildKakousijiGroupContextServiceDeps()).resolveKakousijiFukushizaiBaseGroupSelection();
    }
    function resolveKakousijiGroupCopySelection(panelType) {
        return createKakousijiGroupContextService(buildKakousijiGroupContextServiceDeps()).resolveKakousijiGroupCopySelection(panelType);
    }
    function resolveKakousijiActiveGroupSelection(panelType) {
        return createKakousijiGroupContextService(buildKakousijiGroupContextServiceDeps()).resolveKakousijiActiveGroupSelection(panelType);
    }
    function applyKakousijiGroupSelectionToRow(panelType, row) {
        return createKakousijiGroupContextService(buildKakousijiGroupContextServiceDeps()).applyKakousijiGroupSelectionToRow(panelType, row);
    }
    function doesKakousijiGroupSelectionMatchRow(panelType, row) {
        return createKakousijiGroupContextService(buildKakousijiGroupContextServiceDeps()).doesKakousijiGroupSelectionMatchRow(panelType, row);
    }
    function buildKakousijiGroupFilterVersion(panelType) {
        return createKakousijiGroupContextService(buildKakousijiGroupContextServiceDeps()).buildKakousijiGroupFilterVersion(panelType);
    }
    function handleKakousijiGroupAdd(panelType, itemCd) {
        return createKakousijiGroupContextService(buildKakousijiGroupContextServiceDeps()).handleKakousijiGroupAdd(panelType, itemCd);
    }
    function resolveKakousijiSourceFieldName(row, fieldId, rawValue = '') {
        return createKakousijiGroupContextService(buildKakousijiGroupContextServiceDeps()).resolveKakousijiSourceFieldName(row, fieldId, rawValue);
    }
    function resolveKakousijiGridPanelByType(type) {
        return createKakousijiGroupContextService(buildKakousijiGroupContextServiceDeps()).resolveKakousijiGridPanelByType(type);
    }
    function getKakousijiGridRowsByType(type) {
        return createKakousijiGroupContextService(buildKakousijiGroupContextServiceDeps()).getKakousijiGridRowsByType(type);
    }
    function stopKakousijiGridEditing(panelInfo) {
        return createKakousijiGroupContextService(buildKakousijiGroupContextServiceDeps()).stopKakousijiGridEditing(panelInfo);
    }
    function syncKakousijiGridRowsFromApi(panelInfo) {
        return createKakousijiGroupContextService(buildKakousijiGroupContextServiceDeps()).syncKakousijiGridRowsFromApi(panelInfo);
    }
    function normalizeSoseiColumnId(value) {
        return soseiCalcSvc.normalizeSoseiColumnId(value);
    }
    function getHinbanSoseiPanelColumnInfo(panelInfo) {
        return soseiCalcSvc.getSoseiPanelColumnInfo(panelInfo);
    }
    function readSoseiRowValue(row, field) {
        return soseiCalcSvc.readSoseiRowValue(row, field);
    }
    function readSoseiRowName(row, codeField, nameField) {
        return soseiCalcSvc.readSoseiRowName(row, codeField, nameField);
    }
    function writeSoseiRowField(row, field, value) {
        soseiCalcSvc.writeSoseiRowField(row, field, value);
    }
    function writeSoseiMasterValue(row, codeField, nameField, code, name) {
        soseiCalcSvc.writeSoseiMasterValue(row, codeField, nameField, code, name);
    }
    function parseSoseiRate(value) {
        return soseiCalcSvc.parseSoseiRate(value);
    }
    function isBlankSoseiRate(row, rateField) {
        return soseiCalcSvc.isBlankSoseiRate(row, rateField);
    }
    function isBlankSoseiSubFiber(row, meta) {
        return soseiCalcSvc.isBlankSoseiSubFiber(row, meta);
    }
    function isBlankSoseiDisplayValue(row, field) {
        return soseiCalcSvc.isBlankSoseiDisplayValue(row, field);
    }
    function isBlankSoseiDisplayRow(row, meta) {
        return soseiCalcSvc.isBlankSoseiDisplayRow(row, meta);
    }
    function isSoseiRemainderCandidateRow(row, meta) {
        return soseiCalcSvc.isSoseiRemainderCandidateRow(row, meta);
    }
    function formatSoseiRate(value, decimalPlaces) {
        return soseiCalcSvc.formatSoseiRate(value, decimalPlaces);
    }
    function splitSoseiRate(total, count, decimalPlaces) {
        return soseiCalcSvc.splitSoseiRate(total, count, decimalPlaces);
    }
    function readSoseiMasterCacheName(dataid, code, dbcolumn) {
        return soseiCalcSvc.readSoseiMasterCacheName(dataid, code, dbcolumn);
    }
    function resolveDefaultSubSosei(row, meta) {
        return soseiCalcSvc.resolveDefaultSubSosei(row, meta);
    }
    function applyDefaultSubSoseiToRow(row, meta, defaultSub, rate) {
        soseiCalcSvc.applyDefaultSubSoseiToRow(row, meta, defaultSub, rate);
    }
    function addSoseiRateToRow(row, meta, addRate) {
        soseiCalcSvc.addSoseiRateToRow(row, meta, addRate);
    }
    function sameSoseiParentIdentity(left, right, meta) {
        return soseiCalcSvc.sameSoseiParentIdentity(left, right, meta);
    }
    function buildSoseiGroupsByInputOrder(rows, meta) {
        return soseiCalcSvc.buildSoseiGroupsByInputOrder(rows, meta);
    }
    function hasDuplicateSoseiFiberRows(rows, meta) {
        return soseiCalcSvc.hasDuplicateSoseiFiberRows(rows, meta);
    }
    function hasSoseiRateOverLimit(rows, meta) {
        return soseiCalcSvc.hasSoseiRateOverLimit(rows, meta);
    }
    function calculateSoseiRows(rows, meta) {
        return soseiCalcSvc.calculateSoseiRows(rows, meta);
    }
    function runHinbanSoseiCalc(panelType = KAKOUSIJI_QUALITY_DISPLAY_PANEL_TYPE) {
        const panelInfo = resolveKakousijiGridPanelByType(panelType);
        if (isEmpty(panelInfo)) {
            fnc.current.warnmsg('組成グリッドが見つかりません。');
            return;
        }
        stopKakousijiGridEditing(panelInfo);
        const rows = syncKakousijiGridRowsFromApi(panelInfo);
        const meta = getHinbanSoseiPanelColumnInfo(panelInfo);
        if (isEmpty(meta.mainCol) || isEmpty(meta.subCol) || isEmpty(meta.subRateCol)) {
            fnc.current.warnmsg('組成計算に必要な列定義が見つかりません。');
            return;
        }
        if (hasDuplicateSoseiFiberRows(rows, meta)) {
            fnc.current.warnmsg('同じ部位、組成、サブ組成で同じ組成繊維が、入力されています。');
            return;
        }
        if (hasSoseiRateOverLimit(rows, meta)) {
            fnc.current.warnmsg('同じ部位、組成、サブ組成の混率が100％を超えて入力されています。');
            return;
        }
        const result = calculateSoseiRows(rows, meta);
        if (result.groupCount === 0) {
            fnc.current.warnmsg('計算対象の組成がありません。');
            return;
        }
        setEntryGridRows(panelInfo, result.rows);
        fnc.current.modify(true);
        dispatch(entryrerender());
        rerender();
    }
    function flushKakousijiListReflectSourcePanels() {
        return createKakousijiRepresentativeProjectionService(buildKakousijiRepresentativeProjectionServiceDeps()).flushKakousijiListReflectSourcePanels();
    }
    function setKakousijiGridRows(panelInfo, rows) {
        return createKakousijiRepresentativeProjectionService(buildKakousijiRepresentativeProjectionServiceDeps()).setKakousijiGridRows(panelInfo, rows);
    }
    function buildKakousijiKnownColumnIds(panelType) {
        return createKakousijiRepresentativeProjectionService(buildKakousijiRepresentativeProjectionServiceDeps()).buildKakousijiKnownColumnIds(panelType);
    }
    function getKakousijiRepresentativeFieldPrefixes(panelType) {
        return createKakousijiRepresentativeProjectionService(buildKakousijiRepresentativeProjectionServiceDeps()).getKakousijiRepresentativeFieldPrefixes(panelType);
    }
    function getKakousijiRepresentativeFieldIds(panelType) {
        return createKakousijiRepresentativeProjectionService(buildKakousijiRepresentativeProjectionServiceDeps()).getKakousijiRepresentativeFieldIds(panelType);
    }
    function clearKakousijiRepresentativeFields(entryObj, panelType) {
        return createKakousijiRepresentativeProjectionService(buildKakousijiRepresentativeProjectionServiceDeps()).clearKakousijiRepresentativeFields(entryObj, panelType);
    }
    function pickKakousijiRepresentativeRow(panelType, contextOverride = null) {
        return createKakousijiRepresentativeProjectionService(buildKakousijiRepresentativeProjectionServiceDeps()).pickKakousijiRepresentativeRow(panelType, contextOverride);
    }
    function mergeKakousijiRepresentativeRowToEntry(panelType, contextOverride = null) {
        return createKakousijiRepresentativeProjectionService(buildKakousijiRepresentativeProjectionServiceDeps()).mergeKakousijiRepresentativeRowToEntry(panelType, contextOverride);
    }
    function syncKakousijiRepresentativeEntryProjection(panelType, contextOverride = null) {
        return createKakousijiRepresentativeProjectionService(buildKakousijiRepresentativeProjectionServiceDeps()).syncKakousijiRepresentativeEntryProjection(panelType, contextOverride);
    }
    function resolveKakousijiRepresentativePanelTypeByFieldId(fieldId) {
        return createKakousijiRepresentativeProjectionService(buildKakousijiRepresentativeProjectionServiceDeps()).resolveKakousijiRepresentativePanelTypeByFieldId(fieldId);
    }
    function applyKakousijiBaseUpdatesToCurrentContext(panelType, updates, contextOverride = null) {
        return createKakousijiRepresentativeProjectionService(buildKakousijiRepresentativeProjectionServiceDeps()).applyKakousijiBaseUpdatesToCurrentContext(panelType, updates, contextOverride);
    }
    function isKakousijiEmptyGridRow(row, targetColumns) {
        return createKakousijiRepresentativeProjectionService(buildKakousijiRepresentativeProjectionServiceDeps()).isKakousijiEmptyGridRow(row, targetColumns);
    }
    function normalizeKakousijiCalcText(value) {
        return createKakousijiDetailCalcService(buildKakousijiDetailCalcServiceDeps()).normalizeKakousijiCalcText(value);
    }
    function toKakousijiCalcNumber(value) {
        return createKakousijiDetailCalcService(buildKakousijiDetailCalcServiceDeps()).toKakousijiCalcNumber(value);
    }
    function roundKakousijiCalcNumber(value, decimalPlaces = 2, rounding = 1) {
        return createKakousijiDetailCalcService(buildKakousijiDetailCalcServiceDeps()).roundKakousijiCalcNumber(value, decimalPlaces, rounding);
    }
    function formatKakousijiCalcNumber(value, decimalPlaces = 2, rounding = 1) {
        return createKakousijiDetailCalcService(buildKakousijiDetailCalcServiceDeps()).formatKakousijiCalcNumber(value, decimalPlaces, rounding);
    }
    // table="-" の画面計算項目は、s_layoutで定義されたcolumnidと完全一致する列定義だけを参照する。
    // 表示名や類似columnidからの推測は行わない（加工指示画面と同じ方針）。
    function resolveKakousijiDetailCalcDisplayColumnMeta(panelType, columnId) {
        return createKakousijiDetailCalcService(buildKakousijiDetailCalcServiceDeps()).resolveKakousijiDetailCalcDisplayColumnMeta(panelType, columnId);
    }
    // 円建て金額の端数処理。kakousiji/GetEntryData が返す設定（S_ENV/M_ICPC由来）を使う。
    function resolveKakousijiAmountRoundingRule() {
        return createKakousijiDetailCalcService(buildKakousijiDetailCalcServiceDeps()).resolveKakousijiAmountRoundingRule();
    }
    // 外貨金額の端数処理。行の通貨単位に対応する名称マスタ(6480)の設定を使う。
    function resolveKakousijiForeignAmountRoundingRule(currencyCode) {
        return createKakousijiDetailCalcService(buildKakousijiDetailCalcServiceDeps()).resolveKakousijiForeignAmountRoundingRule(currencyCode);
    }
    function normalizeKakousijiAmountRoundingRule(rule, defaultDecimalPlaces, defaultRounding) {
        return createKakousijiDetailCalcService(buildKakousijiDetailCalcServiceDeps()).normalizeKakousijiAmountRoundingRule(rule, defaultDecimalPlaces, defaultRounding);
    }
    // 明細行の通貨単位を取得する。未設定の行は基本情報の通貨単位で補う。
    function resolveKakousijiDetailRowCurrency(row, currencyField) {
        return createKakousijiDetailCalcService(buildKakousijiDetailCalcServiceDeps()).resolveKakousijiDetailRowCurrency(row, currencyField);
    }
    // 円建て(JPY)かどうか。通貨単位が行にも基本情報にも無い場合は円建て扱いとする。
    function isKakousijiDomesticCurrencyRow(row, currencyField) {
        return createKakousijiDetailCalcService(buildKakousijiDetailCalcServiceDeps()).isKakousijiDomesticCurrencyRow(row, currencyField);
    }
    function resolveKakousijiCurrencyInputLockSide(config, columnId) {
        return createKakousijiDetailCalcService(buildKakousijiDetailCalcServiceDeps()).resolveKakousijiCurrencyInputLockSide(config, columnId);
    }
    // 通貨単位に応じて単価/金額セルの入力可否と背景色を切り替える。
    // HinbanEntryGridAr は lockcell を持たないため、列定義の editable を包んで制御する。
    function applyKakousijiCurrencyInputLockColDef(column) {
        return createKakousijiDetailCalcService(buildKakousijiDetailCalcServiceDeps()).applyKakousijiCurrencyInputLockColDef(column);
    }
    // 通貨に応じて単価/単価(外)を正規化する（加工指示画面と同じ規則）。
    //   通貨=JPY  ：単価(外)=0。単価は入力値のまま
    //   通貨≠JPY ：単価=単価(外)×見積レート（レート未設定なら0）。単価(外)は入力値のまま
    // 換算後の単価は円建てのため、丸めは名称マスタ(6480)の JPY 設定に従う。
    function applyKakousijiCurrencyPriceRuleToRow(row, calcConfig = {}) {
        return createKakousijiDetailCalcService(buildKakousijiDetailCalcServiceDeps()).applyKakousijiCurrencyPriceRuleToRow(row, calcConfig);
    }
    // 円建て単価の桁数・まるめ。名称マスタ(6480)の JPY 設定を使う。
    // 設定が未取得のことがあるため、既定は円建ての 0桁・四捨五入とする。
    function resolveKakousijiDomesticPriceRoundingRule() {
        return createKakousijiDetailCalcService(buildKakousijiDetailCalcServiceDeps()).resolveKakousijiDomesticPriceRoundingRule();
    }
    function recalcKakousijiLossBasedDetailRow(row, calcConfig = {}) {
        return createKakousijiDetailCalcService(buildKakousijiDetailCalcServiceDeps()).recalcKakousijiLossBasedDetailRow(row, calcConfig);
    }
    // 明細ごとの計算対象列。画面の再計算と保存直前の通貨正規化で同じ定義を使う。
    const KAKOUSIJI_DETAIL_CALC_CONFIG_BY_TYPE = {
        [KAKOUSIJI_SOZAI_MEISAI_PANEL_TYPE]: {
            panelType: KAKOUSIJI_SOZAI_MEISAI_PANEL_TYPE,
            qtyField: 'SSDS_YOJAKU',
            lossField: 'SSDS_LOSSRITU',
            outputField: 'SSDS_LYOJAKU',
            unitField: 'SSDS_TANKA',
            unitForeignField: 'SSDS_TANKAF',
            currencyField: 'SSDS_CUR',
            rateField: 'SSDS_MITUMORIRATE',
            outputDecimalPlaces: 2,
            outputRounding: 1,
            amountColumnId: 'SOZAI_KINGAKU',
            amountForeignColumnId: 'SOZAI_KINGAKU_GAIKA'
        },
        [KAKOUSIJI_FUZOKU_MEISAI_PANEL_TYPE]: {
            panelType: KAKOUSIJI_FUZOKU_MEISAI_PANEL_TYPE,
            qtyField: 'SSDF_YOJAKU',
            lossField: 'SSDF_LOSSRITU',
            outputField: 'SSDF_LYOJAKU',
            unitField: 'SSDF_TANKA',
            unitForeignField: 'SSDF_TANKAF',
            currencyField: 'SSDF_CUR',
            rateField: 'SSDF_MITUMORIRATE',
            outputDecimalPlaces: 2,
            outputRounding: 1,
            amountColumnId: 'FUZOKU_KINGAKU',
            amountForeignColumnId: 'FUZOKU_KINGAKU_GAIKA'
        },
        [KAKOUSIJI_FUKUSHIZAI_LIST_PANEL_TYPE]: {
            panelType: KAKOUSIJI_FUKUSHIZAI_LIST_PANEL_TYPE,
            unitField: 'SSDZM_TANKA',
            unitForeignField: 'SSDZM_TANKAF',
            currencyField: 'SSDZM_CUR',
            rateField: 'SSDZM_MITUMORIRATE'
        }
    };
    function recalcKakousijiMaterialDetailCalcRow(row) {
        return createKakousijiDetailCalcService(buildKakousijiDetailCalcServiceDeps()).recalcKakousijiMaterialDetailCalcRow(row);
    }
    function recalcKakousijiAccessoryDetailCalcRow(row) {
        return createKakousijiDetailCalcService(buildKakousijiDetailCalcServiceDeps()).recalcKakousijiAccessoryDetailCalcRow(row);
    }
    function recalcKakousijiMaterialDetailCalcRows(rows) {
        return createKakousijiDetailCalcService(buildKakousijiDetailCalcServiceDeps()).recalcKakousijiMaterialDetailCalcRows(rows);
    }
    function recalcKakousijiAccessoryDetailCalcRows(rows) {
        return createKakousijiDetailCalcService(buildKakousijiDetailCalcServiceDeps()).recalcKakousijiAccessoryDetailCalcRows(rows);
    }
    function recalcKakousijiFukushizaiListCalcRows(rows) {
        return createKakousijiDetailCalcService(buildKakousijiDetailCalcServiceDeps()).recalcKakousijiFukushizaiListCalcRows(rows);
    }
    function recalcKakousijiFukushizaiListCalcRow(row) {
        return createKakousijiDetailCalcService(buildKakousijiDetailCalcServiceDeps()).recalcKakousijiFukushizaiListCalcRow(row);
    }
    function normalizeKakousijiFukushizaiListTorkubun(value) {
        return createKakousijiFukushizaiListService(buildKakousijiFukushizaiListServiceDeps()).normalizeKakousijiFukushizaiListTorkubun(value);
    }
    function buildKakousijiFukushizaiListKey(kind, code, torkubun, torcode, torsubcode) {
        return createKakousijiFukushizaiListService(buildKakousijiFukushizaiListServiceDeps()).buildKakousijiFukushizaiListKey(kind, code, torkubun, torcode, torsubcode);
    }
    function resolveKakousijiFukushizaiListKind(ruleKind, sourceField) {
        return createKakousijiFukushizaiListService(buildKakousijiFukushizaiListServiceDeps()).resolveKakousijiFukushizaiListKind(ruleKind, sourceField);
    }
    function readKakousijiItemGroupFromAnyRow(row) {
        return createKakousijiFukushizaiListService(buildKakousijiFukushizaiListServiceDeps()).readKakousijiItemGroupFromAnyRow(row);
    }
    function collectKakousijiFukushizaiSourceItems() {
        return createKakousijiFukushizaiListService(buildKakousijiFukushizaiListServiceDeps()).collectKakousijiFukushizaiSourceItems();
    }
    function buildKakousijiExistingFukushizaiListRowMap(existingRows) {
        return createKakousijiFukushizaiListService(buildKakousijiFukushizaiListServiceDeps()).buildKakousijiExistingFukushizaiListRowMap(existingRows);
    }
    function buildKakousijiFukushizaiListRows(sourceItems, existingRows) {
        return createKakousijiFukushizaiListService(buildKakousijiFukushizaiListServiceDeps()).buildKakousijiFukushizaiListRows(sourceItems, existingRows);
    }
    function applyKakousijiBulkValueToFukushizaiList(targetColumnId, value) {
        return createKakousijiFukushizaiListService(buildKakousijiFukushizaiListServiceDeps()).applyKakousijiBulkValueToFukushizaiList(targetColumnId, value);
    }
    function runAfterActiveInputCommit(action) {
        callformSvc.runAfterActiveInputCommit(action);
    }
    function handleKakousijiFukushizaiOrder() {
        window.open('about:blank', '_blank');
    }
    //発注画面呼び出し
    function openTemporaryOrderTab() {
        var a = EntrybodyRef.current;
        let code = [];
        if (!isEmpty(DicVal(entrydataRef.current, "SSD_NO", ""))){
            code.push(entrydataRef.current["SSD_NO"]);
        }
        if (code.length === 0) return;
        const placeholderTabs = createPlaceholderTabs(code.length);
        callforms('seihin_bulk_order', code, placeholderTabs);
    }
    function createPlaceholderTabs(count) {
        return callformSvc.createPlaceholderTabs(count);
    }
    function preparePlaceholderTab(tab) {
        callformSvc.preparePlaceholderTab(tab);
    }
    function closePlaceholderTabs(tabs, startIndex = 0) {
        callformSvc.closePlaceholderTabs(tabs, startIndex);
    }
    function buildCallformRequests(action, code, rowdata) {
        return callformSvc.buildCallformRequests(action, code, rowdata);
    }
    function callforms(action, code, placeholderTabs = []) {
        callformSvc.callforms(action, code, placeholderTabs);
    }

    function runKakousijiHeaderAction(action, panelType = KAKOUSIJI_QUALITY_DISPLAY_PANEL_TYPE) {
        return createKakousijiFukushizaiListService(buildKakousijiFukushizaiListServiceDeps()).runKakousijiHeaderAction(action, panelType);
    }
    function runKakousijiDetailAction(panelType, mode) {
        return createKakousijiFukushizaiListService(buildKakousijiFukushizaiListServiceDeps()).runKakousijiDetailAction(panelType, mode);
    }
    function handleKakousijiFukushizaiListReflect() {
        return createKakousijiFukushizaiListService(buildKakousijiFukushizaiListServiceDeps()).handleKakousijiFukushizaiListReflect();
    }
    function handleKakousijiFukushizaiBulkLossApply() {
        return createKakousijiFukushizaiListService(buildKakousijiFukushizaiListServiceDeps()).handleKakousijiFukushizaiBulkLossApply();
    }
    function resolveKakousijiBulkTargetColumnId(panelType, kind) {
        return createKakousijiFukushizaiListService(buildKakousijiFukushizaiListServiceDeps()).resolveKakousijiBulkTargetColumnId(panelType, kind);
    }

    function applyKakousijiBulkValueToDetailPanel(panelType, kind, value) {
        return createKakousijiFukushizaiListService(buildKakousijiFukushizaiListServiceDeps()).applyKakousijiBulkValueToDetailPanel(panelType, kind, value);
    }

    function handleKakousijiSozaiBulkLossApply() {
        return createKakousijiFukushizaiListService(buildKakousijiFukushizaiListServiceDeps()).handleKakousijiSozaiBulkLossApply();
    }

    function handleKakousijiFuzokuBulkLossApply() {
        return createKakousijiFukushizaiListService(buildKakousijiFukushizaiListServiceDeps()).handleKakousijiFuzokuBulkLossApply();
    }

    function handleKakousijiFuzokuBulkShikyuApply() {
        return createKakousijiFukushizaiListService(buildKakousijiFukushizaiListServiceDeps()).handleKakousijiFuzokuBulkShikyuApply();
    }
    function handleKakousijiFukushizaiBulkShikyuApply() {
        return createKakousijiFukushizaiListService(buildKakousijiFukushizaiListServiceDeps()).handleKakousijiFukushizaiBulkShikyuApply();
    }
    function sectionDisplaySetting(panel) {
        return createPanelVisibilityService(buildPanelVisibilityServiceDeps()).sectionDisplaySetting(panel);
    }
    function onDragEnter(e) {
        return createPanelVisibilityService(buildPanelVisibilityServiceDeps()).onDragEnter(e);
    }
    function FileDropClose() {
        return createPanelVisibilityService(buildPanelVisibilityServiceDeps()).FileDropClose();
    }

    //主キー取得
    function primarykey() {
        return columnInfoSvc.primarykey();
    }
    //項目名取得
    function nametocolumn(name) {
        return columnInfoSvc.nametocolumn(name);
    }

    useEffect(() => {
        if (isEmpty(corpkey) || isEmpty(account)) return;
        // 画面起動時に、パネル・列・レイアウトなど入力画面の定義一式を取得
        fnc.current.postaxios('common/GetListTabs', { "panels": panelsdef, "controller": controller, "subkey": subkey },
            {
                onSuccess: function (data) {
                    const normalizedColinfo = normalizeDisplayFields(data.colinfo);
                    const normalizedColumns = normalizeDisplayFields(data.columns);
                    setpanel(data.panels);
                    dispatch(setentrypanel({
                        layouts: data.layouts, prelayout: data.prelayout,
                        initlayout: data.initlayout.length === 0 ? " " : data.initlayout,
                        fitColumn: data.fitColumn
                    }));
                    setcolumninfo(normalizedColinfo);
                    setcolumns(normalizedColumns);
                    const baseFields = buildBaseFieldSet(normalizedColinfo, normalizedColumns);
                    let fields = baseFields.all;
                    settextfieldsall(fields);
                    settextfields(baseFields.visible);
                    fnc.current.initMaster(data.master);


                    let idx = 0;
                    let glist = [];
                    data.panels.filter(e => e.grid).forEach(function (panel) {
                        gridapiRefs.current[idx] = createRef();
                        gridcolapiRefs.current[idx] = createRef();
                        griddataRefs.current[idx] = createRef();
                        gridcolRefs.current[idx] = createRef();
                        glist.push({id:panel.id, type:panel.type, index:idx});
                        idx++;
                    });

                    dispatch(setgridlist(glist));

                    if (data.prelayout) {   //レイアウト復元
                        RestoreLayout(data.panels, fields);
                    }

                    //遷移state取得
                    let state = props.location.state;   //history.push
                    if (isEmpty(state) && !isEmpty(window.history.state)) {
                        if ("status" in window.history.state) {
                            //go back
                            state = window.history.state;
                        }
                    }
                    locationstate.current = state;
                    if (!isEmpty(state)) {
                        if ("code" in state) {
                            clearform();
                            dispatch(changestatus(state.code === "" ? "NEW FORM" : "ENTRY FORM"));
                        }
                    } else {
                        clearform(true);
                    //    dispatch(changestatus("VIEW"));
                    }
                    refreshControlDate(false);
                    fnc.current.wait(false);
                }
            });
    }, [search]);

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (isEmpty(menuinfo.ctrls)) return;
        setlayoutlock(menuinfo.ctrls.indexOf("LOCK2") !== -1);
        setsectionclose(menuinfo.ctrls.indexOf("SECCLOSE") !== -1); //セクションCLOSEボタン
        setgallery(menuinfo.ctrls.indexOf("GALLERY") !== -1); //フォトギャラリ
    }, [menuinfo]);
    useEffect(() => {
        if (isEmpty(baseref.current) || typeof baseref.current.ChangeNavmenu !== 'function') return;
        baseref.current.ChangeNavmenu(currentRequestStatusNavMenu());
    }, [update, entrylock]);

    useEffect(() => {
        applyHinbanDeleteMenuDisabled();
        if (typeof MutationObserver === "undefined" || typeof document === "undefined") return;
        const observer = new MutationObserver(() => applyHinbanDeleteMenuDisabled());
        observer.observe(document.body, { childList: true, subtree: true });
        return () => observer.disconnect();
    }, [hinbanDeleteMenuDisabled, formstatus]);
    useEffect(() => {
        if (formstatus === "NEW FORM") {
            refreshControlDate(false);
        }
        refreshPdtSizePatternEditableState();
    }, [formstatus]);

    useEffect(() => {
        kakousijiGroupControlStateRef.current = { ...kakousijiGroupControlState };
    }, [kakousijiGroupControlState]);
    useEffect(() => {
        kakousijiQualityGroupControlStateRef.current = { ...kakousijiQualityGroupControlState };
    }, [kakousijiQualityGroupControlState]);
    useEffect(() => {
        if (formstatus === "COPY FORM") {
            columninfo.filter(e => e.copyclear).forEach(function (col) {
                entrydataRef.current[col.columnid] = "";
            });
            // 複写では加工指示を引き継がない。加工指示NO(SSD_NO)が複写元と同一のため、
            // 表示すると複写元の加工指示に見えるうえ、そのまま登録すると
            // kakousijiEntries 経由で複写元の加工指示を上書き保存してしまう。
            delete entrydataRef.current.kakousijiEntries;
            kakousijiEntryCacheRef.current = {};
            kakousijiImportedSummaryRowsRef.current = [];
            lastLoadedKakousijiCodeRef.current = "";
            setKakousijiSummaryList([]);
            setActiveKakousijiKey("");
            (Array.isArray(gridlist) ? gridlist : []).forEach((item) => {
                const panelType = Number(DicVal(item, 'type', ''));
                if (panelType >= Number(KAKOUSIJI_PANEL_TYPE_MIN) && panelType <= Number(KAKOUSIJI_PANEL_TYPE_MAX)) {
                    SetGridData(item, null);
                }
            });
            syncKakousijiAnchorGridRows([]);
            dispatch(entrydata({ ...entrydataRef.current }));
            rerender();
        }
    }, [formstatus]);

    useEffect(() => {
        if (formstatus !== "ENTRY FORM") return;
        if (pdtItemCodesLoadVersion === 0) return;
        if (pdtItemCodesAppliedVersionRef.current === pdtItemCodesLoadVersion) return;
        pdtItemCodesAppliedVersionRef.current = pdtItemCodesLoadVersion;
        loadPdtItemCodes({ silent: true });
    }, [formstatus, pdtItemCodesLoadVersion]);

    useEffect(() => {
        activeKakousijiKeyRef.current = String(activeKakousijiKey ?? "").trim();
    }, [activeKakousijiKey]);

    useEffect(() => {
        if (isEmpty(columninfo)) return;
        if (!Array.isArray(gridlist) || gridlist.length === 0) return;
        const activeItem = (Array.isArray(kakousijiSummaryList) ? kakousijiSummaryList : []).find((item) => item.key === activeKakousijiKey) || null;
        if (isEmpty(activeItem)) return;
        loadActiveKakousijiSelectionData(activeItem);
    }, [activeKakousijiKey, kakousijiSummaryList, columninfo, gridlist]);

    //遷移state状態表示

    function callshow() {
        return createEntryLifecycleService(buildEntryLifecycleServiceDeps()).callshow();
    }
    function onFirstDataRendered(param, panel) {
        return createEntryLifecycleService(buildEntryLifecycleServiceDeps()).onFirstDataRendered(param, panel);
    }
    // 表示開始から全通信が静定するまでローディングを保持する。
    // 各サービスが個別に wait(true/false) を出すため素の Backdrop は点滅する。
    function beginInitialLoadingHold() {
        if (initialLoadingTimerRef.current !== null) clearInterval(initialLoadingTimerRef.current);
        setInitialLoading(true);
        const startedAt = Date.now();
        let calmTicks = 0;
        initialLoadingTimerRef.current = setInterval(() => {
            if (getActiveAxiosCount() === 0) { calmTicks += 1; } else { calmTicks = 0; }
            const timedOut = Date.now() - startedAt > 20000;
            if (calmTicks >= 2 || timedOut) {
                clearInterval(initialLoadingTimerRef.current);
                initialLoadingTimerRef.current = null;
                setInitialLoading(false);
            }
        }, 400);
    }
    useEffect(() => () => {
        if (initialLoadingTimerRef.current !== null) clearInterval(initialLoadingTimerRef.current);
        if (refreshKakousijiSummaryDebounceRef.current.timer !== null) {
            clearTimeout(refreshKakousijiSummaryDebounceRef.current.timer);
            refreshKakousijiSummaryDebounceRef.current.timer = null;
        }
        refreshKakousijiSummaryExecRef.current = null;
    }, []);
    function Show(data, pushcode) {
        beginInitialLoadingHold();
        return createEntryLifecycleService(buildEntryLifecycleServiceDeps()).Show(data, pushcode);
    }

    //リストレイアウト適用
    function SetLayout(newcol, type) {
        return createEntryLifecycleService(buildEntryLifecycleServiceDeps()).SetLayout(newcol, type);
    }

    function showpanel(id, type, show) {
        return createEntryLifecycleService(buildEntryLifecycleServiceDeps()).showpanel(id, type, show);
    }
    // スクロール位置を保存する
    function saveScrollPos() {
        return createEntryLifecycleService(buildEntryLifecycleServiceDeps()).saveScrollPos();
    }
    // スクロール位置を復元する
    function restoreScrollPos() {
        return createEntryLifecycleService(buildEntryLifecycleServiceDeps()).restoreScrollPos();
    }
    function formatDateTimeForServer(value) {
        return createSectionEditStateService(buildSectionEditStateServiceDeps()).formatDateTimeForServer(value);
    }
    function normalizeSectionEditTime(value) {
        return createSectionEditStateService(buildSectionEditStateServiceDeps()).normalizeSectionEditTime(value);
    }
    function sectionEditTimeValue(value) {
        return createSectionEditStateService(buildSectionEditStateServiceDeps()).sectionEditTimeValue(value);
    }
    function buildSectionEditInfo(data, sectionType) {
        return createSectionEditStateService(buildSectionEditStateServiceDeps()).buildSectionEditInfo(data, sectionType);
    }
    function setSectionEditInfoFromData(data, sectionType) {
        return createSectionEditStateService(buildSectionEditStateServiceDeps()).setSectionEditInfoFromData(data, sectionType);
    }
    function setSectionEditInfoFromDataBulk(data, sectionTypes) {
        return createSectionEditStateService(buildSectionEditStateServiceDeps()).setSectionEditInfoFromDataBulk(data, sectionTypes);
    }
    function buildStoredGridRows(panel, rows) {
        return createEntryLifecycleService(buildEntryLifecycleServiceDeps()).buildStoredGridRows(panel, rows);
    }

    //行データ保持
    function storeRowData(panel) {
        return createEntryLifecycleService(buildEntryLifecycleServiceDeps()).storeRowData(panel);
    }
    function Jump(id, type) {
        return createHinbanActionService(buildHinbanActionServiceDeps()).Jump(id, type);
    }


    function RequestHinbanEntry(nocheck, skipPdtcSkuNameConfirm) {
        return createHinbanActionService(buildHinbanActionServiceDeps()).RequestHinbanEntry(nocheck, skipPdtcSkuNameConfirm);
    }
    function continueRequestHinbanEntry(oppiCode, nocheck) {
        return createHinbanActionService(buildHinbanActionServiceDeps()).continueRequestHinbanEntry(oppiCode, nocheck);
    }
    function CancelHinbanRequestEntry() {
        return createHinbanActionService(buildHinbanActionServiceDeps()).CancelHinbanRequestEntry();
    }
    function ResolveTehaiReportUrl(action) {
        return createHinbanActionService(buildHinbanActionServiceDeps()).ResolveTehaiReportUrl(action);
    }

    function PrintTehaiReport(action) {
        return createHinbanActionService(buildHinbanActionServiceDeps()).PrintTehaiReport(action);
    }
    function MenuAction(action, finallycallback) {
        return createHinbanActionService(buildHinbanActionServiceDeps()).MenuAction(action, finallycallback);
    }
    // 品番マスタ本体の保存ペイロード(data / detail)の組み立てをまとめる。
    function buildMainSavePayloadBuilderDeps() {
        return {
            DETAIL_HEADER_PANEL,
            DicVal,
            GridData,
            collectBasePanelColumnIds,
            collectKakousijiPanelColumnIds,
            entrydataRef,
            findEntryValue,
            isEmpty,
            isKakousijiPanelType,
            jyutakuHasuShoriKbnColumnIdCandidates,
            jyutakuHasuShoriPosColumnIdCandidates,
            normalizeNumericPayloadObject,
            pdtItemCodesPanel,
            sanitizeEntryData,
            sectionHeaderData,
            storeentrydata,
            syncPdtBrandCodeAlias
        };
    }
    // 加工指示エントリの保存ペイロード(キー付与・システム列除去・エントリ統合)の組み立てをまとめる。
    function buildKakousijiSavePayloadBuilderDeps() {
        return {
            DeepCopy,
            DicVal,
            KAKOUSIJI_DETAIL_CALC_CONFIG_BY_TYPE,
            KAKOUSIJI_FUKUSHIZAI_BASE_PANEL_TYPE,
            KAKOUSIJI_SECTION_139_SAVE_FIELD_IDS,
            applyKakousijiCurrencyPriceRuleToRow,
            buildKakousijiSampleNestedRows,
            extractKakousijiMasterCode,
            firstNonEmptyValue,
            getKakousijiEntryCache,
            getKakousijiEntryCacheForSummaryItem,
            getKakousijiRowsByContext,
            isEmpty,
            isKakousijiSampleGroupSummaryItem,
            kakousijiSampleGroupEntryKeys,
            kakousijiSummaryList,
            normalizeKakousijiDetailForSave,
            normalizeKakousijiGroupNo,
            normalizeKakousijiText,
            normalizeNumericPayloadObject,
            readKakousijiRowValueIgnoreCase,
            resolveCurrentOppiCode,
            resolveKakousijiActiveGroupSelection,
            sanitizeEntryData,
            snapshotActiveKakousijiSelectionData,
            snapshotKakousijiSampleGroupDisplayEntry
        };
    }
    function buildMainSaveDetail(detailSource) {
        return createMainSavePayloadBuilder(buildMainSavePayloadBuilderDeps()).buildMainSaveDetail(detailSource);
    }
    function normalizeKonpoGrpForSave(data) {
        return createMainSavePayloadBuilder(buildMainSavePayloadBuilderDeps()).normalizeKonpoGrpForSave(data);
    }
    function applyPdtItemDetailCodesForSave(data) {
        return createMainSavePayloadBuilder(buildMainSavePayloadBuilderDeps()).applyPdtItemDetailCodesForSave(data);
    }
    function applyJyutakuHasuShoriFieldsForSave(data) {
        return createMainSavePayloadBuilder(buildMainSavePayloadBuilderDeps()).applyJyutakuHasuShoriFieldsForSave(data);
    }
    function applyPdtTenkaiCodeForSave(data) {
        return createMainSavePayloadBuilder(buildMainSavePayloadBuilderDeps()).applyPdtTenkaiCodeForSave(data);
    }
    function buildMainSaveData() {
        return createMainSavePayloadBuilder(buildMainSavePayloadBuilderDeps()).buildMainSaveData();
    }
    function applyKakousijiSaveKeys(data, ssdNo, oppiCode) {
        return createKakousijiSavePayloadBuilder(buildKakousijiSavePayloadBuilderDeps()).applyKakousijiSaveKeys(data, ssdNo, oppiCode);
    }
    function isKakousijiDetailSystemColumn(columnId) {
        return createKakousijiSavePayloadBuilder(buildKakousijiSavePayloadBuilderDeps()).isKakousijiDetailSystemColumn(columnId);
    }
    function hasKakousijiDetailSpecificValue(row) {
        return createKakousijiSavePayloadBuilder(buildKakousijiSavePayloadBuilderDeps()).hasKakousijiDetailSpecificValue(row);
    }
    function buildKakousijiSaveData(snapshot, summaryItem, ssdNo) {
        return createKakousijiSavePayloadBuilder(buildKakousijiSavePayloadBuilderDeps()).buildKakousijiSaveData(snapshot, summaryItem, ssdNo);
    }
    function buildKakousijiSection139SaveRow(sourceData) {
        return createKakousijiSavePayloadBuilder(buildKakousijiSavePayloadBuilderDeps()).buildKakousijiSection139SaveRow(sourceData);
    }
    function applyKakousijiSection139Detail(detail, sourceData) {
        return createKakousijiSavePayloadBuilder(buildKakousijiSavePayloadBuilderDeps()).applyKakousijiSection139Detail(detail, sourceData);
    }
    function clearKakousijiSnapshotSystemValues(row, oppiCode, kubunValue, type) {
        return createKakousijiSavePayloadBuilder(buildKakousijiSavePayloadBuilderDeps()).clearKakousijiSnapshotSystemValues(row, oppiCode, kubunValue, type);
    }
    function normalizeKakousijiSampleSaveRows(type, rows, ssdNo, oppiCode) {
        return createKakousijiSavePayloadBuilder(buildKakousijiSavePayloadBuilderDeps()).normalizeKakousijiSampleSaveRows(type, rows, ssdNo, oppiCode);
    }
    function isSsdqSaveRow(row) {
        return createKakousijiSavePayloadBuilder(buildKakousijiSavePayloadBuilderDeps()).isSsdqSaveRow(row);
    }
    function resolveSelectedSsdzValuesForSsdqSave() {
        return createKakousijiSavePayloadBuilder(buildKakousijiSavePayloadBuilderDeps()).resolveSelectedSsdzValuesForSsdqSave();
    }
    function prepareSsdqRowsForSaveEntries(entries) {
        return createKakousijiSavePayloadBuilder(buildKakousijiSavePayloadBuilderDeps()).prepareSsdqRowsForSaveEntries(entries);
    }
    function buildKakousijiSaveDetail(snapshot, ssdNo, oppiCode) {
        return createKakousijiSavePayloadBuilder(buildKakousijiSavePayloadBuilderDeps()).buildKakousijiSaveDetail(snapshot, ssdNo, oppiCode);
    }
    function normalizeKakousijiSaveEntryKey(entry) {
        return createKakousijiSavePayloadBuilder(buildKakousijiSavePayloadBuilderDeps()).normalizeKakousijiSaveEntryKey(entry);
    }
    function mergeKakousijiEntryDetail(baseDetail, updateDetail) {
        return createKakousijiSavePayloadBuilder(buildKakousijiSavePayloadBuilderDeps()).mergeKakousijiEntryDetail(baseDetail, updateDetail);
    }
    function mergeKakousijiSaveEntry(baseEntry, updateEntry) {
        return createKakousijiSavePayloadBuilder(buildKakousijiSavePayloadBuilderDeps()).mergeKakousijiSaveEntry(baseEntry, updateEntry);
    }
    function mergeKakousijiSaveEntries(dataEntries, directEntries) {
        return createKakousijiSavePayloadBuilder(buildKakousijiSavePayloadBuilderDeps()).mergeKakousijiSaveEntries(dataEntries, directEntries);
    }
    function snapshotKakousijiSampleGroupDisplayEntry(groupItem, entryKey, entryIndex) {
        return createKakousijiAddDialogService(buildKakousijiAddDialogServiceDeps()).snapshotKakousijiSampleGroupDisplayEntry(groupItem, entryKey, entryIndex);
    }
    function buildPendingKakousijiSaveEntries() {
        return createKakousijiSavePayloadBuilder(buildKakousijiSavePayloadBuilderDeps()).buildPendingKakousijiSaveEntries();
    }
    function Save(finallycallback, nocheck, skipPdtcSkuNameConfirm) {
        return createSaveOrchestrator(buildSaveOrchestratorDeps()).Save(finallycallback, nocheck, skipPdtcSkuNameConfirm);
    }
    function buildCurrentHinbanSavePayload(nocheck) {
        return createSaveOrchestrator(buildSaveOrchestratorDeps()).buildCurrentHinbanSavePayload(nocheck);
    }

    function continueSave(finallycallback, nocheck) {
        return createSaveOrchestrator(buildSaveOrchestratorDeps()).continueSave(finallycallback, nocheck);
    }
    function Delete(finallycallback) {
        return createEntryLifecycleService(buildEntryLifecycleServiceDeps()).Delete(finallycallback);
    }
    function Getrowid() {
        return createEntryLifecycleService(buildEntryLifecycleServiceDeps()).Getrowid();
    }
    function LoadData(code) {
        return createEntryLifecycleService(buildEntryLifecycleServiceDeps()).LoadData(code);
    }
    function SetPLData() {
        return createEntryLifecycleService(buildEntryLifecycleServiceDeps()).SetPLData();
    }
    //入力フィールドクリア
    function clearform(newform) {
        return createEntryLifecycleService(buildEntryLifecycleServiceDeps()).clearform(newform);
    }
    //基本項目設定
    function SetBaseField(type) {
        fnc.current.entrylayoutopen(type);
    }
    //レイアウト復元
    function RestoreLayout(panels, fields) {
        //パネルの並び
        RestorePanel(panels);
        //基本情報
        RestoreBase(fields)
    }
    function RestorePanel(panel) {
        layoutStorageSvc.RestorePanel(panel);
    }
    function RestoreBase(fields) {
        const baseinfo = Getstorage(corpkey, account, fnc.current.statusKey(G_id.BASE, "", formid));
        if (isEmpty(baseinfo)) return;
        let newdata = [];
        for (let i = 0; i < baseinfo.length; i++) {
            let item = fields.find(e => e.table === baseinfo[i].table && e.columnid === baseinfo[i].columnid);
            if (isEmpty(item)) continue;
            newdata.push(item);
        }
        settextfields(
            insertCostRateField(
                insertFixedHinbanNumberingField(
                    insertBrandHinbanField(
                        insertSubBrandField(newdata, resolveSubBrandField(fields)),
                        resolveBrandHinbanField(fields)
                    ),
                    resolveFixedHinbanNumberingField(fields)
                ),
                resolveCostRateField(fields)
            )
        );
    }
    //レイアウト保持
    function LayoutSaveStorage() {
        layoutStorageSvc.LayoutSaveStorage();
    }

    //レイアウト登録
    function SaveLayout(layoutid) {
        layoutStorageSvc.SaveLayout(layoutid);
    }
    //レイアウト削除
    function DeleteLayout(layoutid) {
        layoutStorageSvc.DeleteLayout(layoutid);
    }
    //レイアウト呼び出し
    function CallLayout(layoutid) {
        layoutStorageSvc.CallLayout(layoutid);
    }
    //データ表示後処理　7/20 Honma
    function RowDataUpdated(api, data) {
        return createEntryLifecycleService(buildEntryLifecycleServiceDeps()).RowDataUpdated(api, data);
    }
    //画像追加読み込み  　7/20 Honma
    function moreImage(e, mode, src) {
        return createEntryLifecycleService(buildEntryLifecycleServiceDeps()).moreImage(e, mode, src);
    }

    //リスト編集セル制御
    function ListlockCell(params, edit, status, tabvalue) {
        return createEntryLifecycleService(buildEntryLifecycleServiceDeps()).ListlockCell(params, edit, status, tabvalue);
    }

    //パネル別列情報取得
    function tabletype(id) {
        return columnInfoSvc.tabletype(id);
    }

    //File Upload 再表示
    function fileuploaded(data) {
        return createEntryLifecycleService(buildEntryLifecycleServiceDeps()).fileuploaded(data);
    }

    //Basic Data Change
    function ValueChanged(id, value, edit, options) {
        return createValueChangedService(buildValueChangedServiceDeps()).ValueChanged(id, value, edit, options);
    }

    //panel入れ替え
    const onPanelSortEnd = ({ oldIndex, newIndex }) => {
        let items = panel.filter(e => !panelhidden(e));
        let oldidx = panel.findIndex(e => e.type === items[oldIndex].type);
        let newidx = panel.findIndex(e => e.type === items[newIndex].type);
        setpanel(arrayMove(panel, oldidx, newidx));
    };

    //パネルセレクタ
    function panelnavwidth() {
        return createPanelVisibilityService(buildPanelVisibilityServiceDeps()).panelnavwidth();
    }
    function hasResolvedOppiCode(targetData) {
        return createHinbanNumberingService(buildHinbanNumberingServiceDeps()).hasResolvedOppiCode(targetData);
    }
    function applyConfirmedOppiHinbanToEntryData(targetData, confirmedHinban) {
        return createHinbanNumberingService(buildHinbanNumberingServiceDeps()).applyConfirmedOppiHinbanToEntryData(targetData, confirmedHinban);
    }
    function ensureOppiHinbanAssigned(callbacks) {
        return createHinbanNumberingService(buildHinbanNumberingServiceDeps()).ensureOppiHinbanAssigned(callbacks);
    }
    function confirmHinbanEntry(oppiCode) {
        return createHinbanActionService(buildHinbanActionServiceDeps()).confirmHinbanEntry(oppiCode);
    }
    function handleHinbanChatClick() {
        return createHinbanActionService(buildHinbanActionServiceDeps()).handleHinbanChatClick();
    }
    function handleHinbanFixClick() {
        return createHinbanActionService(buildHinbanActionServiceDeps()).handleHinbanFixClick();
    }
    // 型をレンダー毎に作り直すとチップ列が再マウントされるため、型は初回のみ生成する。
    const sortablePanelItemRenderRef = useRef(null);
    sortablePanelItemRenderRef.current = ({ pnl }) => (
        <ListItem className="minwidth0">
            <Chip
                label={pnl.name}
                title={pnl.name}
                size="small"
                onClick={() => Jump(pnl.id, pnl.type)}
            />
        </ListItem>
    );
    const SortablePanelItem = React.useMemo(() => SortableElement((p) => sortablePanelItemRenderRef.current(p)), []);
    const sortablePanelSelectorRenderRef = useRef(null);
    sortablePanelSelectorRenderRef.current = ({ items }) => {
        var newitem = [];
        for (let i = 0; i < items.length; i++) {
            // 品表注意は品質スコープ枠の先頭に表示する専用パネルのためチップには出さない
            if (String(DicVal(items[i], 'type', '')).trim() === KAKOUSIJI_QUALITY_WARNING_PANEL_TYPE) continue;
            if (!panelhidden(items[i])) newitem.push(items[i]);
        }
        return (
            <ul className="hinban-panel-selector-list">
                {newitem.map((value, index) => (
                    <SortablePanelItem key={`item-${index}`} index={index} pnl={value} />
                ))}
            </ul>
        );
    };
    const SortablePanelSelector = React.useMemo(() => SortableContainer((p) => sortablePanelSelectorRenderRef.current(p)), []);

    function kakousijiSampleUpperFields(panelInfo, fallbackFields) {
        return createKakousijiAddDialogService(buildKakousijiAddDialogServiceDeps()).kakousijiSampleUpperFields(panelInfo, fallbackFields);
    }
    function renderKakousijiSampleBaseAndLower(panelInfo, fallbackFields = null) {
        return createSectionContentRenderer(buildSectionContentRendererDeps()).renderKakousijiSampleBaseAndLower(panelInfo, fallbackFields);
    }
    function refreshKakousijiSampleGroupSummaryFromCache(targetEntryKey = '') {
        return createKakousijiAddDialogService(buildKakousijiAddDialogServiceDeps()).refreshKakousijiSampleGroupSummaryFromCache(targetEntryKey);
    }
    function kakousijiSampleDisplayEntryDataRef(panelInfo) {
        return createKakousijiAddDialogService(buildKakousijiAddDialogServiceDeps()).kakousijiSampleDisplayEntryDataRef(panelInfo);
    }
    function handleKakousijiSampleDisplayBaseValueChanged(panelInfo, id, value, edit, options) {
        return createKakousijiAddDialogService(buildKakousijiAddDialogServiceDeps()).handleKakousijiSampleDisplayBaseValueChanged(panelInfo, id, value, edit, options);
    }
    function renderContents(panelInfo) {
        return createSectionContentRenderer(buildSectionContentRendererDeps()).renderContents(panelInfo);
    }
    const MEMOIZED_CONTENTS_DEP_NAMES = ['panel', 'textfields', 'layoutlock', 'gallery', 'controller', 'edittingcode', 'columninfo', 'columns', 'formid', 'update', 'sectionEditRenderVersion', 'kakousijiSummaryList', 'activeKakousijiKey', 'formstatus'];
    // パネル単位の描画キャッシュ。署名(そのパネルの描画に影響する値の同一性)が
    // 変わらない限り前回のReact要素をそのまま返す。同一要素を返すと
    // React はそのサブツリーの再調整を丸ごと省略する。
    const panelContentCacheRef = useRef(new Map());
    function appendTypeFieldsSignature(sig, list, type) {
        if (!Array.isArray(list)) return;
        for (let i = 0; i < list.length; i += 1) {
            if (String(DicVal(list[i], 'type', '')).trim() === type) sig.push(list[i]);
        }
    }
    function isKakousijiRelatedPanelForSignature(panelInfo) {
        if (isKakousijiPanel(panelInfo)) return true;
        const type = String(DicVal(panelInfo, 'type', '')).trim();
        if (type === KAKOUSIJI_ANCHOR_PANEL_TYPE) return true;
        if (String(DicVal(panelInfo, 'sampleDisplayKey', '')).trim() !== '') return true;
        if (String(DicVal(panelInfo, 'sampleEntryKey', '')).trim() !== '') return true;
        return false;
    }
    function buildPanelContentSignature(panelInfo) {
        const type = String(DicVal(panelInfo, 'type', '')).trim();
        // 全パネル共通の依存。ここが変わったら従来どおり全パネルを作り直す。
        const sig = [panel, layoutlock, gallery, controller, edittingcode, formid, formstatus, update, sectionEditRenderVersion];
        // 加工指示系のパネルだけが参照する依存
        if (isKakousijiRelatedPanelForSignature(panelInfo)) {
            sig.push(kakousijiSummaryList, activeKakousijiKey, kakousijiGroupControlState, kakousijiQualityGroupControlState);
        }
        // このパネルの列定義。ローダは変更した要素だけ複製するため、要素の同一性で比較できる。
        sig.push('|tf');
        appendTypeFieldsSignature(sig, textfields, type);
        sig.push('|ci');
        appendTypeFieldsSignature(sig, columninfo, type);
        sig.push('|cl');
        appendTypeFieldsSignature(sig, columns, type);
        return sig;
    }
    function isSamePanelSignature(before, after) {
        if (before.length !== after.length) return false;
        for (let i = 0; i < before.length; i += 1) {
            if (!Object.is(before[i], after[i])) return false;
        }
        return true;
    }
    const memoizedContents = React.useMemo(() => {
        perfCountRender("memoizedContents(再計算)");
        perfWhyChanged('memoizedContents', MEMOIZED_CONTENTS_DEP_NAMES, [panel, textfields, layoutlock, gallery, controller, edittingcode, columninfo, columns, formid, update, sectionEditRenderVersion, kakousijiSummaryList, activeKakousijiKey, formstatus]);
        const perfMemoSpan = perfSpanStart('memoizedContents 全パネル描画');
        const cache = {};
        const displayPanels = orderedPanels();
        const nextPanelCache = new Map();
        let rebuiltCount = 0;
        displayPanels.forEach((p) => {
            const key = sectionKey(p);
            const sig = buildPanelContentSignature(p);
            const prev = panelContentCacheRef.current.get(key);
            let element;
            if (prev !== undefined && isSamePanelSignature(prev.sig, sig)) {
                element = prev.element;
            } else {
                element = renderContents(p);
                rebuiltCount += 1;
            }
            nextPanelCache.set(key, { sig: sig, element: element });
            cache[key] = element;
        });
        panelContentCacheRef.current = nextPanelCache;
        perfSpanEnd(perfMemoSpan, '(再構築 ' + rebuiltCount + '/' + displayPanels.length + ')');
        return cache;
    }, [panel, textfields, layoutlock, gallery, controller, edittingcode, columninfo, columns, formid, update, sectionEditRenderVersion, kakousijiSummaryList, activeKakousijiKey, formstatus]);
    useEffect(() => {
        perfCountRender("applySectionEditState(effect)");
        orderedPanels().forEach((p) => applySectionEditState(p, sectionEditable(p)));
    }, [panel, textfields, layoutlock, gallery, controller, edittingcode, columninfo, columns, formid, update, sectionEditRenderVersion, kakousijiSummaryList, activeKakousijiKey, formstatus]);
    useEffect(() => {
        const selection = resolveKakousijiActiveGroupSelection(KAKOUSIJI_FUKUSHIZAI_BASE_PANEL_TYPE);
        syncKakousijiRepresentativeEntryProjection(KAKOUSIJI_FUKUSHIZAI_BASE_PANEL_TYPE, selection);
        // アイテム/グループ切替時は副資材スコープ4グリッド(121-124)の表示行も選択に合わせて再構築する。
        applyFukushizaiScopeDisplayRows();
    }, [kakousijiGroupControlState.itemCd, kakousijiGroupControlState.groupNo, update]);
    useEffect(() => {
        const selection = resolveKakousijiActiveGroupSelection(KAKOUSIJI_QUALITY_BASE_PANEL_TYPE);
        syncKakousijiRepresentativeEntryProjection(KAKOUSIJI_QUALITY_BASE_PANEL_TYPE, selection);
        // 品質アイテム/グループ切替時は洗濯表示(131)の代表行も選び直す(他の品質グリッドは外部フィルタで追従)。
        applyKakousijiWashScopeDisplay();
    }, [kakousijiQualityGroupControlState.itemCd, kakousijiQualityGroupControlState.groupNo, update]);
    useEffect(() => {
        if (washStpSearchRoutingActiveRef.current) return;
        const source = Array.isArray(changeurl) ? changeurl : [];
        if (source.some((value) => sameChangeUrl(value, HINBAN_MASTER_SEARCH_CHANGE_URL))) return;
        dispatch(setchangeurl(createHinbanMasterSearchChangeUrl(source)));
    }, [changeurl, dispatch]);
    useEffect(() => {
        if (!searchlistOpen && washStpSearchRoutingActiveRef.current) {
            restoreWashStpSearchChangeUrl();
        }
    }, [searchlistOpen]);
    useEffect(() => {
        const currentCode = String(DicVal(entrydataRef.current, "PDT_JYUTAKUSIRECD", "")).trim();
        if (observedJyutakuSupplierCodeRef.current === currentCode) return;
        observedJyutakuSupplierCodeRef.current = currentCode;
        loadJyutakuSupplierInfo({ silent: true, force: true });
    });
    function EmptyPanel(id, type) {
        return createPanelVisibilityService(buildPanelVisibilityServiceDeps()).EmptyPanel(id, type);
    }
    function panelhidden(p) {
        return createPanelVisibilityService(buildPanelVisibilityServiceDeps()).panelhidden(p);
    }

        function setSubBrandFieldOptions(options) {
        const normalizedOptions = Array.isArray(options) ? options : [];
        const updateFields = (prev) => {
            if (isEmpty(prev)) return prev;
            let changed = false;
            const next = prev.map((field) => {
                if (!matchesColumnId(DicVal(field, "columnid", ""), SUB_BRAND_COLUMNID)) return field;
                const currentOptions = Array.isArray(DicVal(field, "options", null)) ? field.options : [];
                const sameLength = currentOptions.length === normalizedOptions.length;
                const sameOptions = sameLength && currentOptions.every((item, index) => {
                    const nextItem = normalizedOptions[index] || {};
                    return String(DicVal(item, "code", "")) === String(DicVal(nextItem, "code", ""))
                        && String(DicVal(item, "name", "")) === String(DicVal(nextItem, "name", ""));
                });
                if (sameOptions) return field;
                changed = true;
                return { ...field, options: normalizedOptions.map((item) => ({ ...item })) };
            });
            return changed ? next : prev;
        };
        settextfields(updateFields);
        settextfieldsall(updateFields);
    }
    function isKakousijiSampleGroupActive() {
        return createPanelVisibilityService(buildPanelVisibilityServiceDeps()).isKakousijiSampleGroupActive();
    }
    function sourcePanelForDisplayPanel(panelInfo) {
        return createPanelVisibilityService(buildPanelVisibilityServiceDeps()).sourcePanelForDisplayPanel(panelInfo);
    }
    function normalizeKakousijiSampleGroupDisplayRows(snapshot, panelType) {
        return createPanelVisibilityService(buildPanelVisibilityServiceDeps()).normalizeKakousijiSampleGroupDisplayRows(snapshot, panelType);
    }
    function buildKakousijiSampleGroupDisplayPanels(basePanels) {
        return createPanelVisibilityService(buildPanelVisibilityServiceDeps()).buildKakousijiSampleGroupDisplayPanels(basePanels);
    }
    function orderedPanels() {
        return createPanelVisibilityService(buildPanelVisibilityServiceDeps()).orderedPanels();
    }

    // 加工指示セクションの操作エリア(サマリ帯・一括入力・グループ操作・モード切替)の描画をまとめる。
    function buildHinbanSectionActionRendererDeps() {
        return {
            DicVal,
            KAKOUSIJI_DETAIL_COPY_MODE,
            KAKOUSIJI_FUKUSHIZAI_BASE_PANEL_TYPE,
            KAKOUSIJI_FUKUSHIZAI_LIST_PANEL_TYPE,
            KAKOUSIJI_FUZOKU_MEISAI_PANEL_TYPE,
            KAKOUSIJI_QUALITY_BASE_PANEL_TYPE,
            KAKOUSIJI_SAMPLE_GROUP_KEY,
            KAKOUSIJI_SOZAI_MEISAI_PANEL_TYPE,
            KAKOUSIJI_UI_ACTION,
            activeKakousijiKey,
            entrylock,
            getKnownKakousijiGroupNos,
            getKnownKakousijiGroupNosByPanelType,
            handleKakousijiGroupAdd,
            handleKakousijiGroupCopy,
            isEmpty,
            isKakousijiDemandNouhinPanel,
            kakouType,
            kakouTypeButtons,
            kakousijiBulkInputMap,
            kakousijiGroupNoToLabel,
            kakousijiOrderDateMap,
            kakousijiOrderHistoryData,
            kakousijiOrderDenpyoMap,
            setKakousijiOrderDenpyoMap,
            formid,
            kakousijiSummaryList,
            kakousijiSummaryLoading,
            normalizeKakousijiGroupNo,
            normalizeKakousijiText,
            openKakousijiAddDialog,
            openKakousijiGroupDialog,
            openTemporaryOrderTab,
            resolveKakousijiColorOptionsForDialog,
            resolveKakousijiGroupCopySelection,
            resolveKakousijiGroupSelection,
            resolveKakousijiNouhinDateBand,
            runAfterActiveInputCommit,
            runKakousijiDetailAction,
            runKakousijiHeaderAction,
            setKakouType,
            setKakousijiBulkInputMap,
            setKakousijiGroupControlState,
            setKakousijiQualityGroupControlState,
            setKakousijiOrderDateMap,
            switchActiveKakousijiKey
        };
    }
    // 加工指示の追加ダイアログ・グループ操作ダイアログの描画をまとめる。
    function buildKakousijiDialogRendererDeps() {
        return {
            DicVal,
            closeKakousijiAddDialog,
            closeKakousijiGroupDialog,
            commitKakousijiAddDialog,
            commitKakousijiGroupDialog,
            isEmpty,
            kakousijiAddDialogState,
            kakousijiGroupDialogState,
            kakousijiGroupNoToLabel,
            setKakousijiAddDialogState,
            setKakousijiGroupDialogState,
            updateKakousijiGroupDialogColorChecked
        };
    }
    function renderKakousijiSummaryBand() {
        return createHinbanSectionActionRenderer(buildHinbanSectionActionRendererDeps()).renderKakousijiSummaryBand();
    }
    function renderKakousijiSijisuActionArea() {
        return createHinbanSectionActionRenderer(buildHinbanSectionActionRendererDeps()).renderKakousijiSijisuActionArea();
    }
    function renderKakousijiActionButton(label, onClick, minWidth = 96) {
        return createHinbanSectionActionRenderer(buildHinbanSectionActionRendererDeps()).renderKakousijiActionButton(label, onClick, minWidth);
    }
    function renderKakousijiSimpleActionRow(buttons) {
        return createHinbanSectionActionRenderer(buildHinbanSectionActionRendererDeps()).renderKakousijiSimpleActionRow(buttons);
    }
    function renderKakousijiSozaiMeisaiActionArea() {
        return createHinbanSectionActionRenderer(buildHinbanSectionActionRendererDeps()).renderKakousijiSozaiMeisaiActionArea();
    }

    function renderKakousijiFuzokuMeisaiActionArea() {
        return createHinbanSectionActionRenderer(buildHinbanSectionActionRendererDeps()).renderKakousijiFuzokuMeisaiActionArea();
    }
    function renderKakousijiGroupControlArea(panelType) {
        return createHinbanSectionActionRenderer(buildHinbanSectionActionRendererDeps()).renderKakousijiGroupControlArea(panelType);
    }
    function renderKakousijiFukushizaiTabBarArea() {
        return createHinbanSectionActionRenderer(buildHinbanSectionActionRendererDeps()).renderKakousijiFukushizaiTabBarArea();
    }
    function renderKakousijiQualityTabBarArea() {
        return createHinbanSectionActionRenderer(buildHinbanSectionActionRendererDeps()).renderKakousijiQualityTabBarArea();
    }
    function renderKakousijiFukushizaiBaseActionArea() {
        return createHinbanSectionActionRenderer(buildHinbanSectionActionRendererDeps()).renderKakousijiFukushizaiBaseActionArea();
    }
    function renderKakousijiQualityBaseActionArea() {
        return createHinbanSectionActionRenderer(buildHinbanSectionActionRendererDeps()).renderKakousijiQualityBaseActionArea();
    }
    function renderKakousijiSoseiActionArea(panelInfo, inline = false) {
        return createHinbanSectionActionRenderer(buildHinbanSectionActionRendererDeps()).renderKakousijiSoseiActionArea(panelInfo, inline);
    }
    function renderKakousijiFukushizaiListActionArea() {
        return createHinbanSectionActionRenderer(buildHinbanSectionActionRendererDeps()).renderKakousijiFukushizaiListActionArea();
    }
    function renderKakousijiModeButtons() {
        return createHinbanSectionActionRenderer(buildHinbanSectionActionRendererDeps()).renderKakousijiModeButtons();
    }
    // 受注数/納品予定の上部情報。加工指示側の renderer をセクションIDブリッジ経由で呼ぶ。
    function resolveKakousijiDemandHeaderFallbackValue(sectionId, primaryKeys, detailPanelType, fallbackGridSectionId) {
        const primary = String(findKakousijiEntryValue(entrydataRef.current, primaryKeys) ?? '').trim();
        if (primary !== '') return primary;
        const panelInfo = resolveKakousijiGridPanelByType(detailPanelType)
            || resolveKakousijiGridPanelByType(sectionIdBridge.panelTypeBySectionId(fallbackGridSectionId || sectionId));
        const gridRows = isEmpty(panelInfo) ? [] : GridData(panelInfo);
        if (!Array.isArray(gridRows) || gridRows.length === 0) return '';
        const gridRow = gridRows.find((row) => !isEmpty(row));
        if (isEmpty(gridRow)) return '';
        for (let i = 0; i < primaryKeys.length; i++) {
            const value = String(DicVal(gridRow, primaryKeys[i], '') ?? '').trim();
            if (value !== '') return value;
        }
        return '';
    }
    function renderKakousijiDemandHeader(panelInfo) {
        if (isEmpty(panelInfo)) return null;
        return demandHeaderRenderer.renderDemandHeader(sectionIdBridge.sectionIdByPanelInfo(panelInfo));
    }
    function formatKakousijiNouhinDateLabel(raw) {
        return createSectionContentRenderer(buildSectionContentRendererDeps()).formatKakousijiNouhinDateLabel(raw);
    }
    function getKakousijiNouhinHeaderRows(panelInfo) {
        return createSectionContentRenderer(buildSectionContentRendererDeps()).getKakousijiNouhinHeaderRows(panelInfo);
    }

    function firstKakousijiNouhinDateFromRows(rows, candidates) {
        return createSectionContentRenderer(buildSectionContentRendererDeps()).firstKakousijiNouhinDateFromRows(rows, candidates);
    }

    function resolveKakousijiNouhinDateBand(panelInfo) {
        return createSectionContentRenderer(buildSectionContentRendererDeps()).resolveKakousijiNouhinDateBand(panelInfo);
    }
    function renderKakousijiNouhinDateBand(panelInfo) {
        return createHinbanSectionActionRenderer(buildHinbanSectionActionRendererDeps()).renderKakousijiNouhinDateBand(panelInfo);
    }
    function resolveKakousijiGroupFieldId(panelType) {
        return createKakousijiGroupDialogService(buildKakousijiGroupDialogServiceDeps()).resolveKakousijiGroupFieldId(panelType);
    }
    function resolveKakousijiColorFieldId(panelType) {
        return createKakousijiGroupDialogService(buildKakousijiGroupDialogServiceDeps()).resolveKakousijiColorFieldId(panelType);
    }
    function resolveKakousijiColorOptionsForDialog(panelType, itemCd, groupNo) {
        return createKakousijiGroupDialogService(buildKakousijiGroupDialogServiceDeps()).resolveKakousijiColorOptionsForDialog(panelType, itemCd, groupNo);
    }
    function openKakousijiGroupDialog(panelType, mode, itemCd, groupNo) {
        return createKakousijiGroupDialogService(buildKakousijiGroupDialogServiceDeps()).openKakousijiGroupDialog(panelType, mode, itemCd, groupNo);
    }
    function closeKakousijiGroupDialog() {
        return createKakousijiGroupDialogService(buildKakousijiGroupDialogServiceDeps()).closeKakousijiGroupDialog();
    }
    function updateKakousijiGroupDialogColorChecked(colorCd, checked) {
        return createKakousijiGroupDialogService(buildKakousijiGroupDialogServiceDeps()).updateKakousijiGroupDialogColorChecked(colorCd, checked);
    }
    function applyKakousijiGroupDelete(panelType, itemCd, groupNo) {
        return createKakousijiGroupDialogService(buildKakousijiGroupDialogServiceDeps()).applyKakousijiGroupDelete(panelType, itemCd, groupNo);
    }
    function applyKakousijiGroupAdd(panelType, itemCd, groupNo, colorOptions) {
        return createKakousijiGroupDialogService(buildKakousijiGroupDialogServiceDeps()).applyKakousijiGroupAdd(panelType, itemCd, groupNo, colorOptions);
    }
    function applyKakousijiGroupEdit(panelType, itemCd, groupNo, colorOptions) {
        return createKakousijiGroupDialogService(buildKakousijiGroupDialogServiceDeps()).applyKakousijiGroupEdit(panelType, itemCd, groupNo, colorOptions);
    }
    function handleKakousijiGroupCopy(panelType, targetItemCd, targetGroupNo, sourceItemCd, sourceGroupNo) {
        return createKakousijiGroupDialogService(buildKakousijiGroupDialogServiceDeps()).handleKakousijiGroupCopy(panelType, targetItemCd, targetGroupNo, sourceItemCd, sourceGroupNo);
    }
    function commitKakousijiGroupDialog() {
        return createKakousijiGroupDialogService(buildKakousijiGroupDialogServiceDeps()).commitKakousijiGroupDialog();
    }
    function closeKakousijiAddDialog() {
        return createKakousijiAddDialogService(buildKakousijiAddDialogServiceDeps()).closeKakousijiAddDialog();
    }

    function renderKakousijiAddDialog() {
        return createKakousijiDialogRenderer(buildKakousijiDialogRendererDeps()).renderKakousijiAddDialog();
    }
    function renderKakousijiGroupActionDialog() {
        return createKakousijiDialogRenderer(buildKakousijiDialogRendererDeps()).renderKakousijiGroupActionDialog();
    }
    const headlineColumnInfo = React.useMemo(() => buildHinbanHeadlineColumnInfo(columninfo), [columninfo]);
    const headlineEntryData = isEmpty(storeentrydata) ? entrydataRef.current : storeentrydata;

    // パネル選択チップ列。MasterLayout の StatusNav(ENTRY FORMボタン)と同じ行に
    // 表示するため、絶対配置ではなく statusnavextra スロットへ渡す。
    const panelSelectorHeaderNode = (formstatus === 'NEW FORM' || formstatus === 'ENTRY FORM' || formstatus === 'COPY FORM') ? (
        <React.Fragment>
                    <div className="hinban-panel-selector-anchor">
                    <Paper
                        component="div"
                        elevation={0}
                        className="hinban-panel-selector-paper"
                        style={{ width: panelnavwidth() }}
                    >
                            <ChipScrollBar>
                                {/*Panel Selector*/}
                                <SortablePanelSelector
                                    axis={"x"}
                                    items={orderedPanels()}
                                    onSortEnd={onPanelSortEnd}
                                    distance={2}
                                />
                            </ChipScrollBar>
                    </Paper>
                    </div>
        </React.Fragment>
    ) : null;
    return (
        <div>
            {/* 標準のローディング(MasterLayout の Backdrop)と同じ見た目で保持表示する */}
            {/* 標準の Backdrop(form.wait)が出ている間は隠し、常にどちらか1枚だけにする。
                2枚重なると半透明黒が二重になり、ローディングの濃さが変わって見える。 */}
            <Backdrop className="hinban-initial-loading" open={initialLoading && !standardWaitOpen}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <Dialog
                open={sectionOverwriteConfirmState.open}
                onClose={closeSectionOverwriteConfirmDialog}
                disableBackdropClick={true}
                fullWidth={true}
                maxWidth="sm"
            >
                <DialogContent>
                    <div className="hinban-dialog-message">他の人により更新されています。上書きしてよろしいですか？</div>
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={handleSectionOverwriteConfirmOk} variant="outlined" color="primary">OK</Button>
                    <Button onClick={closeSectionOverwriteConfirmDialog} variant="outlined" color="primary">キャンセル</Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={skuNameConfirmState.open}
                onClose={handleSkuNameConfirmNo}
                disableBackdropClick={true}
                fullWidth={true}
                maxWidth="sm"
            >
                <DialogContent>
                    <div className="hinban-dialog-message">SKU別の名称・略称も変更しますがよろしいですか？</div>
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={handleSkuNameConfirmYes} variant="outlined" color="primary">はい</Button>
                    <Button onClick={handleSkuNameConfirmNo} variant="outlined" color="primary">いいえ</Button>
                </DialogActions>
            </Dialog>
            <ComFunc ref={fnc} />
            {/*primaryid削除　影響不明*/}
            <MasterBase
                statusnavextra={panelSelectorHeaderNode}
                ref={baseref}
                formid={formid}
                controller={controller}
                subkey={subkey}
                location={props.location}
                actionurl={actionurl}
                uploaded={fileuploaded}
                entrycallback={MenuAction}
                condition={true}
                entryform={true}
                tabs={true}
                show={Show}
                primarykey={primarykeys}
                entrydataRef={entrydataRef}
                navmenu={currentRequestStatusNavMenu()}
                lockcell={ListlockCell}
                suppressaction={suppressaction}
                usecondition={true}
                RowDataUpdated={RowDataUpdated}
                imageclick={moreImage}
            >
            <HinbanMasterEntryForm
                displayPanels={orderedPanels()}
                EntrybodyRef={EntrybodyRef}
                onDragEnter={onDragEnter}
                sectionEditable={sectionEditable}
                sectionBodyLocked={sectionBodyLocked}
                sectionDisplaySetting={sectionDisplaySetting}
                sectionKey={sectionKey}
                panelhidden={panelhidden}
                setSectionRef={setSectionRef}
                sectionHeaderFieldsetRefs={sectionHeaderFieldsetRefs}
                renderDetailSectionHeaderInline={renderDetailSectionHeaderInline}
                layoutlock={layoutlock}
                entrylock={entrylock}
                SetBaseField={SetBaseField}
                isKakousijiPanel={isKakousijiPanel}
                sectionButtonRefs={sectionButtonRefs}
                toggleSectionEdit={toggleSectionEdit}
                sectionclose={sectionclose}
                showpanel={showpanel}
                isKakousijiHeaderPanel={isKakousijiHeaderPanel}
                kakousijiSummaryBand={renderKakousijiSummaryBand()}
                isKakousijiSijisuPanel={isKakousijiSijisuPanel}
                kakousijiSijisuActionArea={renderKakousijiSijisuActionArea()}
                isKakousijiFukushizaiListPanel={isKakousijiFukushizaiListPanel}
                kakousijiFukushizaiListActionArea={renderKakousijiFukushizaiListActionArea()}
                isKakousijiSozaiMeisaiPanel={isKakousijiSozaiMeisaiPanel}
                kakousijiSozaiMeisaiActionArea={renderKakousijiSozaiMeisaiActionArea()}
                isKakousijiFuzokuMeisaiPanel={isKakousijiFuzokuMeisaiPanel}
                kakousijiFuzokuMeisaiActionArea={renderKakousijiFuzokuMeisaiActionArea()}
                isKakousijiFukushizaiBasePanel={isKakousijiFukushizaiBasePanel}
                kakousijiFukushizaiBaseActionArea={renderKakousijiFukushizaiBaseActionArea()}
                isKakousijiQualityBasePanel={isKakousijiQualityBasePanel}
                kakousijiQualityBaseActionArea={renderKakousijiQualityBaseActionArea()}
                kakousijiFukushizaiTabBarArea={renderKakousijiFukushizaiTabBarArea()}
                kakousijiQualityTabBarArea={renderKakousijiQualityTabBarArea()}
                kakousijiFukushizaiScopePanelTypes={KAKOUSIJI_FUKUSHIZAI_SCOPE_PANEL_TYPES}
                kakousijiQualityScopePanelTypes={KAKOUSIJI_QUALITY_SCOPE_PANEL_TYPES}
                kakousijiQualityWarningPanelType={KAKOUSIJI_QUALITY_WARNING_PANEL_TYPE}
                isKakousijiSoseiPanel={isKakousijiSoseiPanel}
                renderKakousijiSoseiActionArea={renderKakousijiSoseiActionArea}
                sectionFieldsetRefs={sectionFieldsetRefs}
                memoizedContents={memoizedContents}
                sectionOverlayRefs={sectionOverlayRefs}
                kakousijiModeButtons={isKakousijiSampleGroupSummaryItem(activeKakousijiSummaryItem()) ? null : renderKakousijiModeButtons()}
                isKakousijiModeAnchorPanel={isKakousijiModeAnchorPanel}
                isDetailHeaderPanel={isDetailHeaderPanel}
                renderKakousijiDemandHeader={renderKakousijiDemandHeader}
                isKakousijiDemandPanel={isKakousijiDemandPanel}
                isHinbanGenkaPanel={isHinbanGenkaPanel}
                isSustainableDesignPanel={isSustainableDesignPanel}
                renderSustainablePreviewPanel={renderSustainablePreviewPanel}
                sectionEditInfo={sectionEditInfo}
                showKakousijiSectionEditButton={showKakousijiSectionEditButton}
                kakousijiSectionEditActive={isKakousijiSectionEditActive()}
                kakousijiSectionEditInfoPanelType={selectedKakousijiKubunValue() === '0' ? '140' : '108'}
                hideKakousijiModeAnchorBodyByMode={kakouType !== 'type1'}
            />
            </MasterBase>
            <EntryLayout
                columninfo={textfieldsall}
                textfields={textfields} 
                onAppry={SetLayout}
            />
            {formstatus === 'NEW FORM' || formstatus === 'ENTRY FORM' || formstatus === 'COPY FORM' ?
                <div>
                    <div className="hinban-header-actions">
                        <Button
                            type="button"
                            variant="contained"
                            size="small"
                            onClick={handleHinbanChatClick}
                            className="hinban-header-action-button hinban-header-action-button--chat"
                        >
                            チャット
                        </Button>
                        {hinbanFixEnabled ?
                            <Button
                                type="button"
                                variant="contained"
                                size="small"
                                onClick={handleHinbanFixClick}
                                className="hinban-header-action-button hinban-header-action-button--fix"
                            >
                                品番確定
                            </Button>
                            : null}
                        <IconButton size="small" onClick={() => fnc.current.entrysettingopen()} title={"レイアウト設定"} >
                            <Icon>table_chart</Icon>
                        </IconButton>
                    </div>
                    {renderHinbanHeadline()}
                </div>
                : null}
            {renderKakousijiAddDialog()}
            {renderKakousijiGroupActionDialog()}
            <AGFunc ref={AGRef} />
            <EntrySetting
                formid={formid}
                controller={controller}
                subkey={subkey}
                savelayout={SaveLayout}
                deletelayout={DeleteLayout}
                calllayout={CallLayout}
                panels={panel}
                showpanel={showpanel}
            />
            <DropZone
                controller={controller}
                code={edittingcode}
                open={isDragActive}
                onclose={FileDropClose}
                actionurl={actionurl}
                uploaded={fileuploaded}
            />
        </div>
    );
};
